const signUp = {
  HI: "Chào mừng đến với Healthnex",
  SIGN_UP_TO_JOIN_US: "Đăng ký để tham gia cùng chúng tôi",
  USER_PROFILE: "Hồ sơ người dùng",
  LOGIN_CREDENTIALS: "Thông tin đăng nhập",
  CONFIRM_PASSWORD: "Xác nhận mật khẩu",
  PLEASE_ENTER_YOUR_USERNAME: "Vui lòng nhập tên đăng nhập",
  PLEASE_ENTER_YOUR_PASSWORD: "Vui lòng nhập mật khẩu",
  PLEASE_CONFIRM_YOUR_PASSWORD: "Vui lòng xác nhận mật khẩu",
  PLEASE_ENTER_YOUR_EMAIL: "Vui lòng nhập email",
  PLEASE_ENTER_YOUR_PHONE:
    "Vui lòng nhập đúng số điện thoại Úc, ví dụ: 0412345678",
  EG_PROFESSOR_OF_TRADITIONAL_CHINESE_MEDICINE:
    "Ví dụ: Chuyên gia Y học cổ truyền Trung Hoa",
  PLEASE_BRIEFLY_INTRODUCE_YOURSELF: "Vui lòng giới thiệu ngắn gọn về bản thân",
  TRADITIONAL_CHINESE_MEDICINE_IS_A_DISCIPLINE_THAT_UTILIZES_NATURAL_PRINCIPLES_COMBINED_WITH_VARIOUS_PHYSIOLOGICAL_AND_PATHOLOGICAL_CHANGES_IN_THE_BODY:
    "Ví dụ: Y học cổ truyền Trung Hoa là một ngành học vận dụng các nguyên lý tự nhiên kết hợp với những biến đổi sinh lý và bệnh lý khác nhau của cơ thể.",
  HERBAL_MEDICINE: "Thuốc thảo dược",
  SIGN_UP: "Gửi & Đăng ký",
  PURCHASE_AND_SIGN_UP: "Mua và Đăng ký",
  SIGN_UP_AS_PRACTITIONER: "Đăng ký làm chuyên viên",
  USERNAME_ALLOW_U_TO_LOGIN_TO_HEALTHNEXT_PLS_DONT_START_WITH_NUMBER:
    "Tên đăng nhập dùng để đăng nhập vào Healthnex không được bắt đầu bằng chữ số và không được chứa khoảng trắng.",
  THIS_IS_A_VALID_USERNAME: "Tên đăng nhập này khả dụng.",
  NO_CLINIC_NAME: "Tên phòng khám không xác định",
  IN_THIS_CLINIC_UR: "Tại phòng khám này, bạn là",
  MEMBER: "Thành viên phòng khám",
  IF_UR_MEMBER: "Nếu bạn là thành viên phòng khám",
  IF_UR_OWNER: "Nếu bạn là chủ phòng khám",
  WE_WILL_CREATE_THE_CLINIC_FOR_U:
    "Tuyệt vời! Chúng tôi sẽ tạo phòng khám này cho bạn.",
  OR_IF_NO_ANY_CLINIC_FROM_ABOVE:
    "Không tìm thấy phòng khám bạn đang tìm kiếm?",
  THIS_BECUZ_THE_CLINIC_OWNER_MIGHT_NOT_CREATED_THE_CLINIC_IN_OUR_SYSTEM_YET:
    "Điều này có thể do chủ phòng khám chưa tạo phòng khám trong hệ thống của chúng tôi.",
  PLS_CONTACT_THE_CLINIC_OWNER_TO_CREATE_THE_CLINIC_AND_INVITE_YOU_IN:
    "Vui lòng liên hệ chủ phòng khám để tạo phòng khám và mời bạn tham gia.",
  CONFIRM_PACKAGE: "Xác nhận gói",
  READ_AND_AGREE_TO_TERMS: "Đọc và đồng ý với điều khoản",
  SELECTED_PACKAGE: "Gói đã chọn",
  SIGN_IN_MINI: "Đăng nhập (Bản Lite)",
  BYE: "Tài khoản đã đăng xuất",
  U_DONT_HAVE_OWNED_CLINIC_PLS_GO_DESKTOP_VERSION_TO_CREATE_YOUR_OWN_CLINIC:
    "Bạn chưa sở hữu phòng khám nào. Vui lòng truy cập phiên bản máy tính để tạo phòng khám của riêng bạn.",
  CLINIC_OWNER: "Chủ phòng khám",
  OWNER_DESCRIPTION:
    "Nếu bạn là chủ phòng khám và muốn tạo một phòng khám trên Healthnex để bắt đầu, vui lòng chọn tùy chọn này.",
  MEMBER_DESCRIPTION:
    "Nếu bạn không phải là chủ phòng khám và muốn tham gia một phòng khám hiện có, hoặc chỉ đơn giản muốn xuất bản trang web cá nhân thông qua Healthnex, vui lòng chọn tùy chọn này.",
  PLEASE_INPUT_YOUR_CLINIC_ADDRESS: "Vui lòng nhập địa chỉ phòng khám của bạn",
  SELECT_ROLE: "Chọn vai trò của bạn",
  U_ARE: "Nếu bạn là",
  SYSTEM_RECOMMEND_THE_BELOW_PACKAGE_WILL_BE_SUITABLE_FOR_YOU:
    "Healthnex đã đề xuất một gói đăng ký phù hợp nhất với nhu cầu của bạn.",
  GET_X_MONTHS_FREE_NOW: "Nhận {{X}} tháng sử dụng miễn phí ngay bây giờ!",
  FREE_SUBSCRIPTION_OFFER_JOIN_NOW:
    "Tận hưởng quyền truy cập đầy đủ vào gói tính năng đăng ký miễn phí trong thời gian có hạn.",
  U_CAN_ALSO_JOIN_THE_EXISTING_CLINIC_AND_WORK_WITH_THEM_COOPERATIVE_IN_HEALTHNEX:
    "Ngoài ra, bạn có thể chọn tham gia một phòng khám hiện có và hợp tác làm việc trong Healthnex.",
  ORIGINAL_PRICE: "Giá gốc",
  X_MONTHS_FREE_ACCESS: "{{X}} tháng truy cập miễn phí",
  S_CLINIC: " - Phòng khám",
  AGENT_INVITATION_TO_JOIN: "Lời mời tham gia từ Đại lý",
  INVALID_AGENT_REF_KEY:
    "Mã tham chiếu đại lý không hợp lệ, vui lòng liên hệ đại lý của bạn để được hỗ trợ thêm.",
  VERIFYING_AGENT_REF_KEY: "Đang xác minh mã tham chiếu đại lý",
  PRESS_LEFT_AND_RIGHT_KEY_TO_SWITCH_CLINIC:
    "Nhấn phím ← TRÁI và PHẢI → để chuyển phòng khám",
  PRESS_ENTER_KEY_TO_START_WORKING: "Nhấn phím ⤶ ENTER để bắt đầu làm việc",
  WELCOME_TO_HEATHNEXT_TO_START_PLS_TELL_ME_WHICH_ROLE_YOU_WANT_TO_PLACE:
    "Chào mừng đến với Healthnex 👋\nTrước khi bắt đầu, hãy cho chúng tôi biết bạn là ai.",
  UPLOAD_UR_PROFILE_PICTURE_HERE:
    "Tải lên ảnh của bạn để người khác có thể dễ dàng nhận ra bạn hơn!",
  INCORRECT_PREV_PASSWORD: "Mật khẩu cũ không đúng, vui lòng nhập lại",
  PLEASE_LOGIN_USING_DESKTOP_VERSION_ENJOY_FULL_SERVICES:
    "Đăng ký thành công. Vui lòng đăng nhập vào phiên bản máy tính Healthnex để truy cập tất cả tính năng. Ngoài ra, bạn có thể tiếp tục với phiên bản Lite trên di động để sử dụng các chức năng cơ bản.",
  INDIVIDUAL_BUSINESS: "Hành nghề cá nhân",
  INDIVIDUAL_BUSINESS_DESCRIPTION:
    "Nếu bạn hoạt động với tư cách hành nghề cá nhân, bạn có thể tạo phòng khám của riêng mình và cũng có thể mời các nhân viên khác tham gia sau.",
  PLEASE_INPUT_YOUR_BUSINESS_OR_HOME_ADDRESS:
    "Vui lòng nhập địa chỉ kinh doanh của bạn (nếu có) hoặc địa chỉ nhà.",
};

const navigation = {
  PRACTITIONER: "Chuyên viên",
  PRACTITIONER_PORTAL: "Cổng thông tin chuyên viên",
  HOME: "Trang chủ",
  ABOUT_US: "Về chúng tôi",
  PARTNERS: "Đối tác",
  MEMBER_SERVICE: "Dịch vụ thành viên",
  CPD_TRAINING: "Hoạt động CPD",
  TRAINING_AND_COURSES: "Đào tạo và Khóa học",
  EVENT: "Sự kiện",
  NEWS: "Tin tức mới nhất",
  BECOMING_MEMBER: "Trở thành thành viên",
  LOGIN_SIGNUP: "Đăng nhập/Đăng ký",
  ONLINE_PAYMENT: "Thanh toán trực tuyến",
  DOWNLOAD_CENTER: "Tải xuống",
  AGREE_TO_USE_VAI_CLINIC_TEXT:
    "Bằng việc đăng nhập, bạn đồng ý sử dụng Clinic theo ",
  SIGN_IN: "Đăng nhập",
  SIGN_OUT: "Đăng xuất",
  USERNAME: "Tên đăng nhập",
  PASSWORD: "Mật khẩu",
  FORGET_PASSWORD: "Quên mật khẩu?",
  AND: " và ",
  PLEASE_ENTER_YOUR_USERNAME: "Vui lòng nhập tên đăng nhập",
  PLEASE_ENTER_YOUR_PASSWORD: "Vui lòng nhập mật khẩu",
  CLINIC: "Phòng khám",
  PRACTITIONER_PROFILE: "Trang web chuyên viên",
  CONTACT_US: "Liên hệ chúng tôi",
  GO_BACK: "Quay lại",
  ADD_PATIENT: "Thêm bệnh nhân",
  SELECT_CLINIC_TO_WORK: "Chọn phòng khám để làm việc",
  SELECT_CLINIC: "Chọn phòng khám",
  PRESCRIPTION_MEDICAL_HISTORY: "Đơn thuốc & Hồ sơ bệnh án",
  LANDING_PAGE_UPDATED: "Trang hiện tại đã được đặt làm trang khởi đầu",
  CHANGE_THIS_PAGE_AS_THE_ENTRY_PAGE:
    "Sau khi trang này được đặt làm trang khởi đầu, nó sẽ là trang đầu tiên hiển thị mỗi khi bạn truy cập hệ thống.",
  ENTRY_PAGE: "Trang khởi đầu",
  URL_LINK: "Liên kết URL",
  URL_COPIED_TO_CLIPBOARD: "Đã sao chép URL vào bộ nhớ tạm",
  EMAIL_COPIED_TO_CLIPBOARD: "Đã sao chép email vào bộ nhớ tạm",
  FAILED_TO_COPY_TO_CLIPBOARD:
    "Không thể sao chép vào bộ nhớ tạm, vui lòng sao chép thủ công hoặc chuyển sang https",
  PROFILE_PAGE_QR_CODE: "Mã QR trang hồ sơ {{X}}",
  E_DAYS: " ngày",
  PENDING_CLINIC_REQUESTS: "Tìm thấy yêu cầu phòng khám đang chờ xử lý",
  ARE_YOU_SURE_TO_SIGN_OUT: "Bạn có chắc chắn muốn đăng xuất ngay bây giờ không?",
  APPOINTMENT_MINI: "Lịch hẹn",
  PRESCRIPTION_MINI: "Bệnh nhân & Đơn thuốc",
  SHOW_MORE: "Xem thêm",
  SHOW_LESS: "Thu gọn",
  BACK_TO_PATIENT_INFO: "Quay lại thông tin bệnh nhân",
  ADD_POINT: "Thêm huyệt",
  X_HAS_BEEN_ADDED: "Đã thêm {{X}}",
  ALL_HERBS_IN_X_HAS_ADDED: "Đã thêm tất cả dược liệu trong {{X}}",
  UR_CLINIC_PACKAGE_PERMISSION_CHANGED: "Đã cập nhật quyền làm việc tại phòng khám",
  UR_CLINIC_PACKAGE_PERMISSION_CHANGED_DESCRIPTION:
    "Quyền truy cập của bạn tại phòng khám hiện tại đã được cập nhật.",
  UR_CLINIC_ROLE_PERMISSION_CHANGED: "Quyền của bạn tại phòng khám này đã thay đổi",
  UR_CLINIC_ROLE_PERMISSION_CHANGED_DESCRIPTION:
    "Vai trò/quyền của bạn tại phòng khám hiện tại đã thay đổi. Xem chi tiết bên dưới.",
  PERMISSION_DIFF_VS_BEFORE_HINT: "Hiển thị sự khác biệt về quyền của bạn so với trước khi thay đổi.",
  PERMISSION_CHANGE_AUTO_REFRESH_HINT: "Trang này sẽ tự động làm mới sau 3 giây",
  GOT_IT: "Tôi đã hiểu",
  CONFIGURE_U_WORKTIME:
    "Thiết lập thời gian làm việc của bạn, Healthnex sẽ tự động tạo các khung giờ dựa trên lịch làm việc của bạn để đặt lịch hẹn",
  MANAGE_UR_APPOINTMENTS:
    "Bạn có thể quản lý lịch hẹn của mình trong hệ thống. Bệnh nhân bên ngoài cũng có thể đặt lịch hẹn qua trang web Healthnex hoặc trang hồ sơ cá nhân của bạn (nếu tính năng này được bật).",
  PATIENT_SYSTEM_AND_PRESCRIPTION_FUNCTION:
    "Bạn có thể quản lý thông tin bệnh nhân và hồ sơ bệnh án cho phòng khám của mình, đồng thời kê đơn thuốc cho bệnh nhân.",
  AI_FUNCTION:
    "Bạn có thể sử dụng trợ lý AI để dịch thông tin và tóm tắt quá trình tư vấn.",
  U_CAN_EASILY_CUSTOMISED_PUBLISH_YOUR_PERSONAL_WEBSITE_TO_THE_PUBLIC:
    "Bạn có thể dễ dàng tùy chỉnh trang web cá nhân và xuất bản trực tuyến để tăng khả năng hiển thị và tiếp cận nhiều bệnh nhân hơn.  ",
  UR_CLINIC_HAS_REMOVED_PACKAGE_FROM_U:
    "Phòng khám của bạn đã gỡ bỏ gói của bạn. Nếu điều này không đúng như mong đợi, vui lòng liên hệ chủ phòng khám.",
  IF_UNEXPECTED_PLS_CONTACT_THE_CLINIC_OWNER:
    "Nếu điều này nằm ngoài dự kiến, vui lòng liên hệ chủ phòng khám.",
  NEW_VERSION_AVAILABLE: "Đã có phiên bản mới",
  NEW_VERSION_DESCRIPTION:
    "Đã có phiên bản Healthnex được cải tiến. Vui lòng nhấp vào nút bên dưới để làm mới trang nhằm hoàn tất việc nâng cấp.",
  REFRESH_AND_UPGRADE: "Làm mới và Nâng cấp",
  SYSTEM_REDIRECTING: "Hệ thống đang chuyển hướng",
  SWITCHING_CLINIC: "Đang chuyển phòng khám",
  UPDATING_PROFILE: "Đang cập nhật hồ sơ",
  UPLOADING_AVATAR: "Tải lên ảnh hồ sơ",
  UPDATING_PASSWORD: "Đang cập nhật mật khẩu",
  CURRENT_PASSWORD: "Mật khẩu hiện tại",
  DASHBOARD: "Bảng điều khiển",
};

const prescription = {
  CLEAR_SEARCH: "Xóa",
  PRESCRIPTION: "Hồ sơ bệnh án",
  PATIENT_PRESCRIPTION: "Hồ sơ bệnh án của bệnh nhân",
  DOCTOR_PRESCRIPTION: "Đơn thuốc của bác sĩ",
  NO_PRESCRIPTION_FOUND: "Không tìm thấy đơn thuốc",
  NO_PREVIOUS_HISTORY: "Không có hồ sơ trước đó",
  PRESCRIPTION_NOT_FOUND: "Không tìm thấy đơn thuốc",
  "EDIT_NOW_HISTORY_#X": "Đang chỉnh sửa hồ sơ bệnh án #{{X}}",
  EDITING_NOW: "Đang chỉnh sửa",
  NO_ENGLISH_ENTRY: "Không có nội dung tiếng Anh",
  NO_CHINESE_ENTRY: "Không có nội dung tiếng Trung",
  ENGLISH_CONTENT: "Nội dung tiếng Anh",
  CHINESE_CONTENT: "Nội dung tiếng Trung",
  CASE_ID: "Mã hồ sơ",
  DATE: "Ngày",
  CREATED_BY: "Người tạo",
  PAYMENT_STATUS: "Trạng thái thanh toán",
  ACTION: "Thao tác",
  NOT_PAID: "Chưa thanh toán",
  PAID: "Đã thanh toán",
  CARD_ONLINE: "Thẻ trực tuyến",
  CARD_OFFLINE: "Thẻ tại quầy",
  CASH: "Tiền mặt",
  HICAPS: "HICAPS",
  CONNECTING_TO_HICAPS_TERMINAL: "Đang kết nối với máy HICAPS...",
  HICAPS_TERMINAL_CONNECTED: "Đã kết nối với máy HICAPS",
  HICAPS_TERMINAL_CONNECTION_FAILED: "Kết nối với máy HICAPS không thành công",
  RETRY: "Thử lại",
  RESUBMIT: "Gửi lại",
  SUBMITTING: "Đang gửi...",
  HICAPS_TERMINAL_SERVER_NOT_CONFIGURED: "Phòng khám này chưa cấu hình địa chỉ máy chủ cho máy HICAPS — vui lòng liên hệ quản trị viên.",
  HICAPS_CHARGE_NOT_SUBMITTED_TITLE: "Đã tính phí nhưng chưa gửi được",
  HICAPS_CHARGE_NOT_SUBMITTED_DESCRIPTION: "Máy HICAPS đã tính phí số tiền này, nhưng việc lưu vào hồ sơ đã thất bại. Gửi lại để hoàn tất việc lưu — thao tác này sẽ không tính phí lại trên máy.",
  CONFIRM_REFUND_TITLE: "Xác nhận hoàn tiền qua HICAPS?",
  CONFIRM_REFUND_DESCRIPTION: "Thao tác này sẽ đặt lại hồ sơ về trạng thái chưa thanh toán. Những mục sau sẽ được hoàn lại:",
  CONFIRM_REFUND_ITEM_REBATE: "Yêu cầu bồi hoàn quỹ y tế sẽ bị hủy",
  CONFIRM_REFUND_ITEM_BALANCE: "Khoản thanh toán số dư sẽ được hoàn lại",
  CONFIRM_REFUND: "Xác nhận hoàn tiền",
  CONFIRM_REFUND_SCOPE_FULL: "Hoàn tiền toàn bộ",
  CONFIRM_REFUND_SCOPE_FULL_DESCRIPTION: "Hủy yêu cầu bồi hoàn quỹ y tế và hoàn lại khoản thanh toán số dư",
  CONFIRM_REFUND_SCOPE_BALANCE_ONLY: "Chỉ hoàn số dư",
  CONFIRM_REFUND_SCOPE_BALANCE_ONLY_DESCRIPTION: "Chỉ hoàn lại khoản thanh toán số dư — yêu cầu bồi hoàn quỹ y tế giữ nguyên",
  REFUND_CLAIM_CANCEL_SUCCESS_PROCESSING_BALANCE: "Hủy yêu cầu bồi hoàn thành công. Đang xử lý hoàn tiền số dư...",
  HICAPS_PRICE_LOCK_WARNING: "Sau khi chọn Hicaps, giá của hồ sơ này sẽ không thể chỉnh sửa được nữa.",
  SELECT_PROVIDER: "Chọn nhà cung cấp",
  SEARCH_PROVIDER_NAME: "Tìm theo tên",
  SELECT_MERCHANT: "Chọn thương nhân",
  HEALTH_FUND_REBATE: "Hoàn tiền quỹ y tế",
  BALANCE_PAYMENT: "Thanh toán số dư",
  PROCESSING_REBATE_PAYMENT: "Đang xử lý thanh toán hoàn tiền quỹ y tế",
  PROCESSING_BALANCE_PAYMENT: "Đang xử lý thanh toán số dư",
  PROVIDER_USED_FOR_BOTH_STEPS: "Nhà cung cấp này sẽ được dùng cho cả hoàn tiền và thanh toán số dư",
  WAITING_FOR_PAYMENT: "Đang chờ thanh toán",
  PLEASE_TAP_CARD_ON_TERMINAL: "Vui lòng yêu cầu bệnh nhân chạm, cắm hoặc quẹt thẻ trên máy HICAPS ngay bây giờ",
  FINALIZING_PAYMENT: "Đang hoàn tất thanh toán",
  SAVING_INSURANCE_RECORD: "Đang lưu hồ sơ hoàn tiền",
  HICAPS_ZERO_AMOUNT_HINT: "Không thể chọn HICAPS khi số tiền là $0",
  HICAPS_PAYMENT_LOCKED_TITLE: "Đã thanh toán qua HICAPS",
  HICAPS_PAYMENT_LOCKED_DESCRIPTION: "Hồ sơ này đã được thanh toán qua máy HICAPS nên không thể chỉnh sửa giá nữa. Để thay đổi, vui lòng yêu cầu hoàn tiền trước — sau khi hoàn tiền thành công, hồ sơ sẽ trở lại trạng thái chưa thanh toán.",
  HICAPS_PAYMENT_LOCKED_DESCRIPTION_SHORT: "Đã thanh toán qua HICAPS — yêu cầu hoàn tiền để chỉnh sửa giá lại",
  COMPLETE: "Hoàn tất",
  REFUND: "Hoàn tiền",
  UNPAID: "Chưa thanh toán",
  MARK_AS_PAID: "Đánh dấu đã thanh toán",
  MARK_REBATE_AS_PAID: "Đánh dấu khoản hoàn tiền là đã thanh toán",
  MARK_REBATE_AS_PAID_WARNING: "Thao tác này sẽ cập nhật trạng thái thanh toán HICAPS của khoản hoàn tiền thành đã thanh toán. Chỉ sử dụng khi giao dịch HICAPS đã thực sự thành công trên máy nhưng hệ thống không hiển thị đúng là đã thanh toán.",
  HICAPS_PAY_IN_FULL: "Thanh toán toàn bộ qua HICAPS",
  HICAPS_PAY_PARTIAL: "Chia với phương thức khác",
  HICAPS_AMOUNT_TO_PAY: "Số tiền thanh toán qua HICAPS",
  HICAPS_PARTIAL_AMOUNT_MUST_BE_LESS_THAN_BALANCE: "Phải lớn hơn $0 và nhỏ hơn tổng số dư",
  REMAINING_AMOUNT_X: "Số tiền còn lại ${{X}} sẽ được thu riêng",
  CONNECT_HICAPS_TERMINAL: "Kết nối máy HICAPS",
  REFUND_STEP_REBATE: "Đang hủy yêu cầu hoàn tiền bảo hiểm",
  REFUND_STEP_BALANCE: "Đang hoàn tiền số dư",
  REFUND_STEP_ROLLBACK: "Đang cập nhật trạng thái thanh toán của hồ sơ",
  REFUND_STEP_REBATE_ROLLBACK: "Đang cập nhật trạng thái thanh toán của khoản bồi hoàn",
  REFUND_STEP_REBATE_ROLLBACK_SHORT: "Trạng thái bồi hoàn",
  REFUND_STEP_REBATE_SHORT: "Hủy yêu cầu bồi hoàn",
  REFUND_STEP_BALANCE_SHORT: "Hoàn tiền số dư",
  REFUND_STEP_ROLLBACK_SHORT: "Trạng thái thanh toán",
  REFUND_SUCCESSFUL: "Hoàn tiền thành công",
  REFUND_FAILED: "Hoàn tiền thất bại, vui lòng thử lại",
  PROCESSING_WITH_HICAPS_TERMINAL: "Đang xử lý qua máy HICAPS...",
  HICAPS_TRANSACTION_SUCCESSFUL: "Giao dịch HICAPS thành công",
  HICAPS_TRANSACTION_FAILED: "Giao dịch HICAPS không thành công, vui lòng thử lại",
  HICAPS_REBATE_COMPLETED: "Đã hoàn tất khoản hoàn trả qua HICAPS",
  FILTER_BY_DATE: "Lọc theo ngày",
  SELECT_DEFAULT_DATE_RANGE: "Chọn khoảng ngày mặc định",
  SELECT_CUSTOM_DATE_RANGE: "Chọn khoảng ngày tùy chỉnh",
  LAST_ONE_YEAR: "Một năm qua",
  LAST_ONE_MONTH: "Một tháng qua",
  LAST_THREE_MONTHS: "Ba tháng qua",
  ROWS_PER_PAGE: "Số hàng mỗi trang",
  MORE_INFORMATION: "Thêm thông tin",
  AGE: "Tuổi",
  PRESCRIPTION_FORM: "Mẫu đơn thuốc",
  CREATE_CASE: "Tạo hồ sơ",
  CREATE_CASE_FAILED: "Tạo hồ sơ thất bại, vui lòng thử lại",
  SELECT_OPTIONS: "Chọn tùy chọn",
  CLICK_TO_RECORD: "Nhấp để ghi âm",
  PRESS_TO_RECORD: "Nhấn để ghi âm",
  TRANSLATE_TO_X: "Dịch sang {{X}}",
  COMPLAINTS_SYMPTOMS: "Lý do khám & Triệu chứng",
  PAST_DISEASE: "Bệnh sử",
  FAMILY_DISEASE_HISTORY: "Tiền sử bệnh gia đình",
  ALLERGY: "Dị ứng",
  ALLERGEN: "Tác nhân gây dị ứng",
  CURRENT_MEDICINE_TAKEN: "Thuốc đang sử dụng",
  SIGNS_DIAGNOSIS: "Dấu hiệu và Chẩn đoán",
  ATTACHMENT: "Tệp đính kèm",
  REMARKS: "Ghi chú",
  CLICK_DRAG_TO_UPLOAD: "Nhấp hoặc Kéo để tải lên",
  NO_ATTACHMENT_FOUND: "Chưa có tệp đính kèm",
  TREATMENT_PLAN: "Kế hoạch điều trị",
  PATIENT_ADVICES: "Lời khuyên cho bệnh nhân",
  PROCEED_TO_PAYMENT: "Tiến hành thanh toán",
  PROCEED_TO_TREATMENT: "Tiến hành điều trị",
  MEDICINE: "Thuốc",
  PRESCRIBE_MEDICATION_TO_THE_PATIENT: "Kê thuốc cho bệnh nhân",
  PRESCRIBE_ACUPUNCTURE_TO_THE_PATIENT:
    "Điều trị châm cứu cho bệnh nhân",
  PRESCRIBE_MASSAGE_TO_THE_PATIENT: "Điều trị xoa bóp cho bệnh nhân",
  PRESCRIBE_REMEDIAL_MASSAGE_TO_THE_PATIENT:
    "Điều trị xoa bóp trị liệu cho bệnh nhân",
  SELECT: "Chọn",
  MODALITY: "Phương thức điều trị",
  MEDICINE_TREATMENT_NAME: "Tên thuốc điều trị",
  PREVIOUS_STEP: "Bước trước",
  PATIENT_HERB_HISTORY: "Lịch sử dùng dược liệu của bệnh nhân",
  APPLY: "Áp dụng",
  HERB: "Dược liệu",
  RAW: "Dược liệu thô (g)",
  GRAN: "Thuốc cốm (g)",
  TOTAL: "Tổng cộng",
  FORMULA: "Bài thuốc",
  CLASSICAL: "Bài thuốc dược liệu",
  SINGLE_HERB: "Vị thuốc đơn",
  TYPE: "Loại",
  SELECT_HERBS: "Chọn dược liệu",
  SEARCH_CLASSICAL_FORMULA: "Tìm bài thuốc dược liệu",
  PLEASE_SEARCH_BY_NAME: "Vui lòng tìm theo tên",
  CANCEL_SEARCH: "Hủy tìm kiếm",
  ADD_ALL_HERBS_IN_FORMULA: "Thêm tất cả dược liệu trong bài thuốc",
  X_HERBS_INCLUDED: "Bao gồm {{X}} dược liệu",
  FILL_IN_THE_DOSAGE: "Điền liều lượng",
  HERBS_ADDED: "Dược liệu đã thêm",
  PLS_SELECT_HERB_FROM_HISTORY_OR_FORMULA:
    "Vui lòng chọn dược liệu từ lịch sử hoặc bài thuốc",
  GRAMS_DAILY: "Liều mỗi ngày",
  DAILY_TOTAL: "Tổng mỗi ngày",
  DAYS: "Ngày",
  TOTAL_GRANS: "Tổng thuốc cốm",
  TOTAL_RAW: "Tổng dược liệu thô",
  DAILY_GRANS: "Thuốc cốm mỗi ngày",
  DAILY_RAW: "Dược liệu thô mỗi ngày",
  DOSAGE_INSTRUCTION: "Hướng dẫn dùng thuốc",
  DOSAGE: "Liều lượng",
  NO_OF_REPEATS: "Số lần dùng",
  DOSAGE_DAYS: "Số ngày dùng",
  TO_BE_DISPENSED_AFTER: "Cấp phát sau",
  WEEK: "Tuần",
  RAW_HERBS: "Dược liệu thô",
  HERBS_EXTRACT: "Cao chiết dược liệu",
  HERBAL_MEDICATION: "Thuốc thảo dược",
  EXTERNAL: "Dùng ngoài",
  HERB_BOIL_GUIDE: "Hướng dẫn sắc thuốc",
  SECOND_BOIL_REQUIRED: "Cần sắc lần hai",
  FIRST_BOILS: "Sắc lần đầu",
  NO_CUP_WATER: "Số chén nước",
  BOIL_TIME: "Thời gian sắc",
  NO_CUPS_REMAINS: "Số chén còn lại",
  MIN_BOIL_TIME: "Thời gian sắc tối thiểu (Phút)",
  PLEASE_ENTER_NUMBER: "Vui lòng nhập số",
  SELECT_POINT: "Chọn huyệt",
  X_HISTORY: "Lịch sử {{X}}",
  POINT: "Huyệt",
  X_GROUP: "Nhóm {{X}}",
  POINT_GROUPS: "Nhóm huyệt",
  ORDER: "Thứ tự",
  SINGLE_POINT: "Huyệt đơn",
  REVIEW_THE_POINTS: "Xem lại các huyệt",
  PLS_SELECT_POINT_FROM_HISTORY_OR_GROUP:
    "Vui lòng chọn huyệt từ lịch sử hoặc nhóm",
  DROP_HERE: "Thả vào đây",
  X_INSTRUCTION: "Hướng dẫn {{X}}",
  DURATION: "Thời lượng",
  PLS_ENTER_THE_DURATION: "Vui lòng nhập thời lượng",
  PRECAUTION: "Lưu ý / Ghi chú / Chỉ định y tế",
  FILL_IN_PRECAUTION: "Điền lưu ý / ghi chú / hướng dẫn",
  MAS_TECHNIQUE: "Kỹ thuật",
  PLS_ENTER_THE_PRECAUTION: "Vui lòng nhập lưu ý / Ghi chú / Chỉ định y tế",
  POINTS_ADDED: "Huyệt đã thêm",
  VIEW_COPIED_POINTS: "Xem huyệt vị đã thêm từ bệnh án trước",
  VIEW_COPIED_HERBS: "Xem thuốc đã thêm từ bệnh án trước",
  HERB_RAW_SHORT: "Thô",
  HERB_GRAN_SHORT: "Hạt",
  PAYMENT: "Thanh toán",
  FILL_IN_THE_PAYMENT_DETAILS: "Điền thông tin thanh toán",
  SUBTOTAL: "Tạm tính",
  OTHER_FEE: "Phí khác",
  DIAGNOSIS_FEE: "Phí điều trị",
  DISCOUNT_FEE: "Giảm giá",
  FEE: "Phí",
  TOTAL_AMOUNTS: "Tổng số tiền",
  CASH_OR_CARD_OFFLINE_AMOUNT: "Số tiền tiền mặt / thẻ trực tiếp",
  INITIAL_VISIT: "Lần khám đầu",
  FOLLOW_UP: "Tái khám",
  ADD_FEE: "Thêm phí",
  FEE_LABEL: "Tên phí",
  PLEASE_ENTER_LABEL: "Vui lòng nhập nhãn",
  FEE_AMOUNT: "Số tiền phí",
  PLEASE_ENTER_AMOUNT: "Vui lòng nhập số tiền",
  FEE_LABEL_ALREADY_EXISTS: "Đã tồn tại phí với tên này",
  FEE_AMOUNT_MUST_BE_POSITIVE: "Số tiền không thể âm",
  MEDICAL_REBATE: "Hoàn phí y tế",
  MEDICAL_FUNDS_OF_PATIENT: "Sử dụng quỹ y tế của bệnh nhân",
  REBATE_AMOUNT: "Số tiền hoàn từ bảo hiểm",
  ANY_DISCOUNT: "Có giảm giá không",
  PENDING_PAYMENT_AMOUNT: "Số tiền chờ thanh toán",
  PAYMENT_METHOD: "Phương thức thanh toán",
  DISCOUNT_AMOUNT: "Số tiền giảm giá",
  FINISH_PAYMENT: "Hoàn tất thanh toán",
  PLEASE_ENTER_YOUR_CARD_DETAILS_BELOW_TO_COMPLETE_YOUR_PURCHASE:
    "Vui lòng nhập thông tin thẻ bên dưới để hoàn tất giao dịch",
  PAYMENT_FAILED_PLEASE_TRY_AGAIN: "Thanh toán thất bại. Vui lòng thử lại",
  X_TRIES_LEFT: "Còn {{X}} lần thử",
  TOTAL_AMOUNT_CANNOT_BE_NEGATIVE: "Tổng số tiền không thể âm",
  PAY_NOW: "Thanh toán ngay",
  YOUR_PAYMENT_HAS_BEEN_SUCCESSFULLY_PROCESSED:
    "Thanh toán của bạn đã được xử lý thành công",
  SYSTEM_REDICTING: "Hệ thống đang chuyển hướng...",
  SURCHARGE_WILL_BE_INCLUDED: "Đã bao gồm phụ phí",
  PROCESSING_PAYMENT: "Đang xử lý thanh toán",
  LAST_MODIFIED_AT: "Truy cập lần cuối lúc",
  PAY: "Thanh toán",
  NEXT: "Tiếp theo",
  PRINT_RECEIPT: "Tải xuống biên lai",
  SEND_RECEIPT_TO_PATIENT: "Gửi biên lai cho bệnh nhân",
  SEND_TO_PATIENT_VIA_EMAIL_WITH_RECEIPT_ATTACHED:
    "Gửi hóa đơn đến email của bệnh nhân qua email",
  PATIENT_EMAIL: "Địa chỉ email của bệnh nhân",
  RECIPIENT_EMAIL: "Email người nhận",
  EMAIL_SENT_TO_X: "Email đã được gửi đến: {{X}}",
  SEND: "Gửi",
  SENDING_EMAIL: "Đang gửi email",
  PRINT_MEDICAL_RECORD: "Tải xuống hồ sơ bệnh án",
  GENERATING: "Đang tạo",
  NO_MEDICAL_HISTORY_FOUND: "Chưa điền hồ sơ bệnh án",
  NO_TREATMENTS_INCLUDED: "Không có liệu trình nào",
  TREATMENT: "Điều trị",
  TREATMENTS: "Các liệu trình",
  VIEW_X_INSTRUCTION: "Xem hướng dẫn {{X}}",
  X_SURCHARGE_AMOUNT: "Số tiền phụ phí {{X}}",
  DISCOUNT: "Giảm giá",
  COLLAPSE_ALL: "Thu gọn tất cả",
  EXPAND_ALL: "Mở rộng tất cả",
  VIEW_DOSAGE_INSTRUCTION: "Xem hướng dẫn liều lượng",
  FINISH: "Tóm tắt",
  X_OPTIONS: "Tùy chọn {{X}}",
  FULL_CONTENT_MODE: "Chế độ đơn giản",
  HAS_BEEN_ADDED: " đã được thêm",
  ALL_HERBS_IN_FORMULA_HAS_ADDED: "Đã thêm tất cả dược liệu trong bài thuốc",
  CLASSICAL_FORMULA: "Bài thuốc dược liệu",
  PLS_ENTER_NUMBER: "Vui lòng nhập số",
  SEARCH_CLASSICAL_FORMULA_BY_NAME: "Tìm bài thuốc theo tên",
  SEARCH_CLASSICAL_FORMULA_HERB_BY_NAME:
    "Tìm bài thuốc cổ phương & dược liệu theo tên",
  SEARCH_HERB_BY_NAME: "Tìm dược liệu theo tên",
  REMOVE_TREATMENT: "Xóa liệu trình",
  ARE_YOU_SURE_TO_REMOVE: "Bạn có chắc chắn muốn xóa",
  SECOND_BOILS: "Sắc lần hai",
  MIN_BOILING: "Số phút sắc",
  X_POINTS_INCLUDED: "Bao gồm {{X}} huyệt",
  ADD_ALL_POINTS_IN_FORMULA: "Thêm tất cả huyệt trong nhóm",
  SEARCH_POINT_GROUPS_BY_NAME: "Tìm nhóm huyệt theo tên",
  SEARCH_POINT_GROUPS_POINT_BY_NAME: "Tìm nhóm huyệt & huyệt theo tên",
  SEARCH_POINT_BY_NAME: "Tìm huyệt theo tên",
  ALL_POINTS_IN_FORMULA_HAS_ADDED: "Đã thêm tất cả huyệt trong nhóm",
  THIS_TREATMENT_HAS_NO_PRICE_OR_PRICE_ZERO:
    "Liệu trình này không có giá hoặc giá bằng không",
  PAYMENT_CHANNEL_EXPIRED_PLS_RELOAD_PAGE:
    "Kênh thanh toán đã hết hạn, vui lòng tải lại trang",
  ENTER_FEE_AMOUNT: "Nhập số tiền phí",
  NO_TREATMENT_INCLUDED_IN_THIS_PRESCRIPTION:
    "Không có liệu trình nào trong đơn thuốc này",
  PLEASE_SELECT_TREATMENT_TO_PROCEED:
    "Vui lòng chọn phương thức điều trị để tiến hành",
  ADD_TREATMENT: "Thêm liệu trình",
  MORE: "Xem thêm",
  HAS_REMOVED: " đã được xóa",
  ATTACHMENT_UPLOADED: "Đã tải lên tệp đính kèm",
  REMOVE_ATTACHMENT: "Xóa tệp đính kèm",
  ARE_YOU_SURE_TO_REMOVE_THIS_FILE: "Bạn có chắc chắn muốn xóa tệp này không?",
  ATTACHMENT_REMOVED: "Đã xóa tệp đính kèm",
  LAST_SIX_MONTHS: "6 tháng qua",
  INPUT_TOTAL_COST_HERE: "Nhập chi phí điều trị tại đây",
  EDIT_PATIENT_INFO: "Chỉnh sửa thông tin bệnh nhân",
  ARE_YOU_SURE_TO_CLEAR_ALL_CONTENT_IN_THIS_FIELD:
    "Bạn có chắc chắn muốn xóa toàn bộ nội dung đã viết bên dưới không?",
  CLEAR_CONFIRM: "Xác nhận xóa",
  DUPLICATE_MEDICAL_HISTORY: "Sao chép hồ sơ",
  ARE_YOU_SURE_TO_DUPLICATE_THIS_MEDICAL_HISTORY:
    "Bạn đang định sao chép hồ sơ bệnh án đã chọn",
  YOU_WILL_GET_A_NEW_MEDICAL_HISTORY_WITH_PREFILLED_DATA_FROM_LAST_RECORD:
    "Bạn sẽ nhận được một hồ sơ bệnh án mới với dữ liệu được điền sẵn giống hồ sơ bệnh án đã chọn",
  ARE_YOU_SURE_TO_DELETE_MEDICAL_RECORD:
    "Bạn có chắc chắn muốn xóa hồ sơ bệnh án này không",
  PATIENT_HISTORY_COPIED: "Đã sao chép lịch sử bệnh nhân",
  DELETE_SUCCESS: "Xóa thành công",
  ADD_ASSISTANT_EXAMINATION: "Thêm cận lâm sàng",
  ADD_NOW: "Thêm ngay",
  RESULT_PREVIEW: "Xem trước",
  EXPAND_RECORD_PREVIEW: "Mở rộng xem trước hồ sơ",
  COLLAPSE_RECORD_PREVIEW: "Thu gọn xem trước hồ sơ",
  AUXILIARY_TEST: "Xét nghiệm cận lâm sàng",
  TEST_NAME: "Tên xét nghiệm",
  TEST_DATE: "Ngày xét nghiệm",
  ATTACHMENTS: "Tệp đính kèm",
  SELECT_PHOTO_PDF: "Chọn ảnh/PDF",
  TAKE_PHOTO_OR_SELECT_FILE: "Chụp ảnh / Chọn tệp",
  EXAMINATION: "Khám lâm sàng",
  EXAMINATION_DESCRIPTION: "Mô tả",
  INSPECTION: "Vọng chẩn (chẩn đoán bằng quan sát YHCT)",
  TONGUE_PHOTO: "Ảnh lưỡi",
  FACIAL_PHOTO: "Ảnh khuôn mặt",
  INQUIRY: "Vấn chẩn (hỏi bệnh YHCT)",
  INQUIRY_RECORD: "Hồ sơ vấn chẩn",
  PULSE: "Mạch chẩn",
  LISTEN_SMELL: "Văn chẩn (nghe và ngửi)",
  BODY_TEMP: "Nhiệt độ cơ thể",
  BLOOD_PRESSURE: "Huyết áp",
  PULSE_RATE: "Nhịp mạch",
  BREATH_RATE: "Nhịp thở",
  PERSONAL_OTHER: "Thói quen cá nhân & khác",
  ANY_ALLERGY: "Có dị ứng không",
  IS_PREGNANT: "Có mang thai không?",
  ALLERGY_DRUGS: "Dị ứng thuốc",
  ALLERGY_TRIGGERS: "Tác nhân gây dị ứng",
  STD: "Tiền sử bệnh lây qua đường tình dục",
  PROMISCUITY: "Quan hệ tình dục bừa bãi",
  SMOKING: "Hút thuốc",
  ALCOHOL_ABUSE: "Lạm dụng rượu bia",
  ADD_HISTORY: "Thêm bệnh sử",
  NO_DISEASES: "Không có bệnh sử",
  FAMILY_DISEASES: "Tiền sử bệnh gia đình",
  SYMPTOMS: "Triệu chứng",
  NO_SYMPTOMS_ADDED: "Chưa thêm triệu chứng",
  MAIN_SYMPTOM: "Triệu chứng chính",
  SYMPTOM_DESCRIPTION: "Mô tả triệu chứng",
  ONSITE_TIME: "Thời gian khởi phát",
  TIME_UNIT: "Đơn vị thời gian",
  RECURRENCE_TIME: "Thời gian tái phát",
  EXACERBATION_TIME: "Thời gian nặng lên",
  FREQUENCY_OF_OCCURRENCE: "Tần suất xuất hiện",
  FREQUENCY: "Tần suất",
  ADD_MAIN_SYMPTOMS: "Thêm triệu chứng chính",
  PREDISPOSITION: "Yếu tố thuận lợi",
  ASSOCIATED_SYMPTOMS: "Triệu chứng kèm theo",
  ARE_YOU_SURE_TO_DELETE_THIS_SYMPTOM: "Bạn có chắc chắn muốn xóa triệu chứng này không?",
  ADD_PAST_DISEASE: "Thêm bệnh sử",
  OTHERS: "Khác",
  PROCEED_TO_DIAGNOSIS: "Tiến hành chẩn đoán",
  UPDATE_SUCCESS: "Lưu thành công",
  PREVIOUS_TREATMENT: "Mô tả triệu chứng",
  ASSISTANT_EXAMINATION: "Cận lâm sàng",
  CLICK_TO_ADD: "Nhấp để tìm và thêm",
  CLICK_TO_SELECT: "Nhấp để tìm và chọn",
  PREVIOUS_HISTORY: "Hồ sơ bệnh án trước đó",
  PAST_DISEASE_DESCRIPTION: "Mô tả",
  ADD_EVALUATION: "Thêm đánh giá",
  TCM_ICD_CODE: "Mã ICD YHCT",
  DETERMINATION_TCM: "Tên chẩn đoán YHCT",
  SYNDROME: "Tên thể bệnh YHCT",
  EVALUATION: "Chẩn đoán",
  DISCIPLINE_TREATMENT_OPTIONS: "Nguyên tắc và phương pháp điều trị",
  ARE_YOU_SURE_TO_DELETE_THIS_RECORD: "Bạn có chắc chắn muốn xóa hồ sơ này không?",
  BPM: "Mỗi phút",
  SYSTOLIC: "Tâm thu",
  DIASTOLIC: "Tâm trương",
  ADD_NEW_INSURANCE: "Thêm quỹ y tế",
  PLZ_INPUT_INSURANCE_NO: "Vui lòng nhập mã hội viên",
  PLZ_INPUT_COMPANY_NAME: "Vui lòng nhập tên công ty bảo hiểm",
  RESULT: "Kết quả",
  VIEW_HISTORY: "Xem lịch sử trước đó",
  COLLAPSE_HISTORY: "Thu gọn lịch sử",
  COLLAPSE_INSTRUCTION: "Thu gọn hướng dẫn",
  SHOW_DOSAGE_INSTRUCTION: "Chỉnh sửa hướng dẫn liều lượng",
  IT_LOOKS_LIKE_PATIENT_HAS_NOT_BEEN_CONSENTED_WITH_AGREEMENT_WITH_US:
    "Có vẻ như bệnh nhân chưa ký thỏa thuận đồng ý với chúng tôi",
  PLEASE_ASK_PATIENT_TO_SCAN_THE_QR_BELOW_SIGN_THE_CONSENT_FORM:
    "Vui lòng để bệnh nhân quét mã QR bên dưới để hoàn tất phiếu đồng ý trước khi bắt đầu quá trình kê đơn.",
  PLEASE_ASK_PATIENT_TO_SCAN_THE_QR_BELOW_SIGN_THE_CONSENT_FORM_SHORT:
    "Bệnh nhân có thể quét mã QR bên dưới để hoàn tất phiếu đồng ý",
  SIGN_CONSENT_FORM: "Ký phiếu đồng ý của bệnh nhân",
  SIGNATURE_DATE: "Ngày ký",
  PATIENT_FIRST_VISIT_ON: "Bệnh nhân khám lần đầu vào",
  APPLY_DATE: "Áp dụng",
  THIS_PATIENT_WAS_CREATED_FROM_IMPORT_U_CAN_ASK_PATIENT_TO_SIGN_CONSENT:
    "Bệnh nhân này chưa ký phiếu đồng ý, nhưng bạn vẫn có thể tiếp tục với hồ sơ bệnh án.",
  PLEASE_CLICK_BUTTON_BELOW_AND_ASK_PATIENT_TO_SIGN_THE_CONSENT_FORM:
    "Vui lòng nhấp vào nút bên dưới và yêu cầu bệnh nhân ký phiếu đồng ý.",
  CLICK_HERE_TO_SIGN_CONSENT: "Nhấp vào đây để ký phiếu đồng ý",
  SIGN_NOW: "Ký ngay",
  DOWNLOAD_EMPTY_CONSENT_FORM: "In phiếu đồng ý trống",
  CONSENT_FORM_UPLOADED: "Đã tải lên phiếu đồng ý của bệnh nhân",
  VIEW_CONSENT_FORM: "Xem phiếu đồng ý của bệnh nhân",
  UPLOAD_CONSENT_FORM: "Tải lên phiếu đồng ý của bệnh nhân",
  REUPLOAD_CONSENT_FORM: "Tải lên lại phiếu đồng ý",
  UPLOADING: "Đang tải lên",
  UPLOAD: "Tải lên",
  IMPORTANT: "Chưa thuộc về phòng khám nào",
  X_TREATMENT_NAME: "Tên liệu trình {{X}}",
  RECENT_PRESCRIPTIONS: "Đơn thuốc gần đây",
  EDITED_IN: "Chỉnh sửa trong: ",
  PHOTOS_AND_VIDEOS: "Ảnh & Video",
  GENERATING_CONSENT_FORM: "Đang tạo phiếu đồng ý",
  CANCELLED: "Đã hủy",
  MORE_INFO_PLS_CHECK_MEDICAL_HISTORY_USING_DESKTOP:
    "Một số thông tin giá đã được chỉnh sửa trong phiên bản không được bản Lite hỗ trợ. Vui lòng sử dụng phiên bản máy tính để xem đầy đủ chi tiết.",
  UPDATING_PRICE: "Đang cập nhật giá... Vui lòng thử lại",
  EDIT_PRESCRIPTION: "Chỉnh sửa đơn thuốc",
  DIAGNOSIS_DATE: "Ngày chẩn đoán",
  EDIT_DIAGNOSIS_DATE: "Chỉnh sửa ngày chẩn đoán",
  CHANGE_DIAGNOSIS_DATE_TO: "Đổi ngày chẩn đoán thành",
  PAID_AT: "Thanh toán lúc",
  PRESCRIPTION_DATE_UPDATED: "Đã cập nhật ngày chẩn đoán",
  PAIN_LEVEL: "Mức độ đau",
  PAIN_TYPE: "Loại đau",
  CLICK_TO_TOGGLE_IMG: "Nhấp để chuyển đổi hình ảnh",
  CLICK_TO_TOGGLE_X: "Nhấp để chuyển đổi hình ảnh sang {{X}}",
  IMG_FRONT: "Mặt trước",
  IMG_BACK: "Mặt sau",
  DEFAULT_SCALE: "Đặt lại tỷ lệ",
  LOADING_IMG: "Đang tải hình ảnh",
  THIS_IMAGE_HAS_DETECTED_TO_BE_OLD_CANVAS_NEW_CANVAS_WILL_BE_APPLY_IN_NEXT_UPDATE:
    "Hình ảnh hiện tại đã được xác định là phiên bản cũ. Hệ thống sẽ tự động chuyển sang hình ảnh mới nhất trong lần cập nhật tiếp theo của bạn. Lưu ý rằng vị trí huyệt khác nhau giữa các phiên bản, và bạn sẽ cần đánh dấu lại sau khi cập nhật.",
  NO_IMAGE_FOUND: "Không tìm thấy hình ảnh",
  SELECTABLE_POINTS: "Huyệt",
  NO_OF_PACKS: "Số thang thuốc",
  PER_DAY: "lần/ngày",
  "DOSAGE.PER_DAY": "lần/ngày",
  "DOSAGE.SHOW_DAILY": "Hiển thị liều mỗi ngày",
  PACKS: "Thang",
  HEALTH_CONDITION_RECORD: "Hồ sơ tình trạng sức khỏe",
  AS_MYSELF: "Cho chính tôi",
  ON_BEHALF_OF: "Thay mặt cho",
  ON_BEHALF_OF_X: "Thay mặt cho: {{X}}",
  ON_BEHALF_OF_OTHERS: "Thay mặt cho người khác",
  UPLOAD_PAYMENT_DOC: "Tải lên chứng từ thanh toán",
  PAYMENT_FILES: "Tệp thanh toán",
  SELECTED_HISTORY: "Hồ sơ lịch sử đã chọn",
  PATIENT_NOT_FOUND: "Không tìm thấy bệnh nhân trong phòng khám này",
  NEW_PATIENT_RECORD: "Đơn thuốc cho bệnh nhân mới",
  VIEW_EDIT: "Xem / Chỉnh sửa",
  FIND: "Tìm",
  SEARCH_BY_PATIENT_NAME_MOBILE: "Tìm theo Tên/Số điện thoại bệnh nhân",
  NO_BOOKINGS_FOUND: "Không tìm thấy lịch hẹn liên quan",
  FILL_IN_TREATMENT_NOTE_PLAN: "Điền ghi chú / kế hoạch điều trị",
  TREATMENT_NOTE_PLAN: "Ghi chú / kế hoạch điều trị",
  DOWNLOAD_SELECTED_MEDICAL_RECORDS: "Tải xuống bệnh án đã chọn",
  DOWNLOAD_ALL_CURRENT_MEDICAL_RECORDS: "Tải xuống tất cả bệnh án",
  DOWNLOAD_ALL_CONSENT_FORMS: "Tải xuống tất cả phiếu đồng ý của bệnh nhân",
  ARE_YOU_SURE_TO_DOWNLOAD_SELECTED_MEDICAL_RECORDS: "Bạn có chắc muốn tải xuống các bệnh án đã chọn không?",
  ARE_YOU_SURE_TO_DOWNLOAD_ALL_MEDICAL_RECORDS: "Bạn có chắc muốn tải xuống tất cả bệnh án không?",
  UNPAID_MEDICAL_RECORDS_WILL_NOT_BE_DOWNLOADED: "Các bệnh án chưa hoàn tất thanh toán sẽ không được đưa vào tệp tải xuống.",
  DATE_RANGE: "Khoảng thời gian",
  NUMBER_OF_RECORDS: "Số lượng bệnh án",
  ENTER_PRESCRIPTION_NAME: "Nhập tên đơn thuốc",
  QUICK_SELECT: "Chọn nhanh",
  SELECT_FROM_BODY_PART: "Chọn từ sơ đồ cơ thể",
  ADD_EDIT_METHOD_FROM_BODY_PART: "Chỉnh sửa kỹ thuật theo vùng cơ thể",
  EDIT_METHOD: "Chỉnh sửa kỹ thuật",
  NO_BODY_PART_HAS_BEEN_SELECTED: "Chưa có vùng cơ thể nào được chọn ở bước trước.",
  GO_AND_EDIT_BODY_PART: "Đi đến sơ đồ cơ thể để chọn",
  CLICK_POINT_ON_IMAGE_TO_SELECT_METHOD: "Nhấn vào vòng tròn để thêm kỹ thuật cho vùng cơ thể đó.",
  BACK_TO_TREATMENT: "Quay lại điều trị",
  CLICK_POINT_ON_IMAGE_FROM_LEFT_TO_SELECT_METHOD: "Nhấp vào vùng cơ thể trên hình bên trái để chọn kỹ thuật"
};

const search = {
  SEARCH: "Tìm kiếm",
  SEARCH_PLACEHOLDER: "Tìm kiếm",
  SEARCH_RESULT: "Kết quả tìm kiếm",
  NO_SEARCH_RESULT: "Không có kết quả tìm kiếm",
  SEARCHING: "Đang tìm kiếm",
  SEARCH_PATIENT: "Tìm bệnh nhân theo tên/email/số điện thoại",
  SEARCH_FOR_PATIENT_IN_TOP_SEARCH_BAR_OR_NEW_PATIENT_HERE:
    "Tìm bệnh nhân bên dưới theo tên, hoặc thêm bệnh nhân mới bằng nút bên trái.",
  SEARCH_PATIENT_BY_NAME: "Tìm bệnh nhân theo tên/email/số điện thoại/số bảo hiểm",
  NO_PATIENT_FOUND: "Không tìm thấy bệnh nhân",
  SEARCHING_PATIENT: "Đang tìm bệnh nhân",
};

const info = {
  DOB: "Ngày sinh",
  DATE_OF_BIRTH: "Ngày sinh",
  SELECT_PATIENT: "Chọn bệnh nhân",
  X_PRESCRIPTION_INFO: "Đơn thuốc của {{X}}",
  VIEW_DETAILS: "Xem chi tiết",
  "MEDICAL_HISTORY_#X": "Hồ sơ bệnh án #{{X}}",
  LAST_MODIFIED_BY_X_AT_Y: "Chỉnh sửa lần cuối bởi {{X}} lúc {{Y}}",
  NEW_MEDICAL_HISTORY: "Hồ sơ bệnh án mới",
  NOT_SAVED_YET: "Chưa được lưu",
  SAVE_HISTORY: "Lưu hồ sơ",
  PATIENT_INFO: "Thông tin bệnh nhân",
  PATIENT_ID: "Mã bệnh nhân",
  GENDER: "Giới tính",
  MALE: "Nam",
  FEMALE: "Nữ",
  MEDICAL_HISTORY: "Hồ sơ bệnh án",
  APPOINTMENT: "Lịch hẹn",
  NO_HISTORY_FOUND: "Không tìm thấy lịch sử",
  DESCRIPTION: "Mô tả cá nhân",
  COMPLAINTS_SYMPTOMS: "Lý do khám/Triệu chứng",
  DIAGNOSIS: "Chẩn đoán",
  TREATMENT: "Điều trị",
  ENGLISH_CONTENT_GOES_HERE: "Nội dung tiếng Anh ở đây",
  CN_CONTENT_GOES_HERE: "Nội dung tiếng Trung ở đây",
  EDITING: "Đang chỉnh sửa",
  SIGNS_DIAGNOSIS: "Dấu hiệu và Chẩn đoán",
  TREATMENT_STRATEGIES: "Phương pháp điều trị",
  ACUPUNCTURE_POINTS_DURATION_METHODS:
    "Huyệt châm cứu, Thời lượng và Phương pháp",
  ALLERGY: "DỊ ỨNG",
  THERAPEUTICAL_MASSAGE: "Xoa bóp trị liệu",
  GUA_SHA: "Cạo gió",
  OTHER: "Khác",
  REMARKS: "Ghi chú",
  TRANSLATE_FROM_X: "Đã dịch từ {{X}}",
  TRANSLATE_TO_X: "Dịch sang {{X}}",
  TRANSLATE: "Dịch",
  CHINESE: "Tiếng Trung",
  ENGLISH: "Tiếng Anh",
  THAI: "Tiếng Thái",
  VIETNAMESE: "Tiếng Việt",
  X_CONTENT_GOES_HERE: "Nhập nội dung {{X}} tại đây",
  NAME_X: "Tên ({{X}})",
  TRANSLATION_CONFIRM: "Xác nhận dịch",
  TRANSLATED_CONTENT_WILL_BE_APPLIED_OVERWRITE_UR_EXISTING_CONTENT:
    "Nội dung đã dịch sẽ được áp dụng và ghi đè lên nội dung hiện có của bạn.",
  TRANSLATE_FROM_X_TO_Y: "Đã dịch từ {{X}} sang {{Y}}",
  ARE_YOU_SURE_TO_TRANSLATE: "Bạn có chắc chắn muốn dịch",
  INFO_FILLED: "Đã lưu thông tin",
  NO_DATA_FOUND: "Không tìm thấy dữ liệu",
  FULL_CONTENT_X: "Toàn bộ hồ sơ bệnh án: {{X}}",
  "UPDATE_HISTORY_#X": "Cập nhật hồ sơ bệnh án #{{X}}",
  EDIT_DESCRIPTION: "Chỉnh sửa mô tả cá nhân",
  EDIT_PATIENT: "Chỉnh sửa bệnh nhân",
  BASIC_INFO: "Thông tin cơ bản",
  FIRST_NAME: "Tên",
  LAST_NAME: "Họ",
  CONTACT_DETAIL: "Thông tin liên hệ",
  RESIDENTIAL_ADDRESS: "Địa chỉ cư trú",
  EMERGENCY_CONTACT_DETAIL: "Thông tin liên hệ khẩn cấp",
  RELATIONSHIP: "Mối quan hệ",
  PATIENT_DISCLOSE: "Bệnh nhân tiết lộ",
  GUARDIAN_NAME: "Tên người giám hộ",
  GUARDIAN: "Người giám hộ",
  GUARDIAN_CONTACT_NUMBER: "Số liên hệ người giám hộ",
  GUARDIAN_MOBILE: "Di động người giám hộ",
  REFERRED_BY: "Được giới thiệu bởi",
  NO_INSURANCE: "Không có quỹ y tế",
  EMERGENCY_CONTACT_PERSON: "Người liên hệ khẩn cấp",
  EMERGENCY_CONTACT_NUMBER: "Số liên hệ khẩn cấp",
  INSURANCE_INFO: "Thông tin quỹ y tế",
  MORE_DETAILS: "Thêm chi tiết",
  INSURANCE_X: "Quỹ y tế {{X}}",
  COMPANY_NAME: "Tên công ty",
  INSURANCE_NO: "Mã hội viên",
  EXPIRY_DATE: "Ngày hết hạn",
  ADD_INSURANCE: "Thêm quỹ y tế",
  CANCEL: "Hủy",
  CONFIRM: "Xác nhận",
  SELECT_TEMPLATE: "Chọn mẫu trang web",
  ADD_TEMPLATE: "Thêm mẫu",
  EDIT_TEMPLATE: "Chế độ chỉnh sửa",
  PUBLISH_WEBSITE: "Xuất bản trang web",
  VIEW_PUBLISHED_WEB: "Xem trước trang web đã xuất bản",
  TEMPLATE: "Mẫu",
  INSURANCE: "Quỹ y tế",
  EXPIRED_IN: "Hết hạn trong",
  EXIT_EDIT: "Thoát chỉnh sửa",
  X_VERSION: "Phiên bản {{X}}",
  MAKE_APPOINTMENT: "Đặt lịch hẹn",
  AI_TRANSLATE: "Dịch bằng AI",
  EDIT_TITLE: "Chỉnh sửa tiêu đề",
  EDIT_NAME: "Chỉnh sửa tên",
  EDIT_INTRODUCTION: "Chỉnh sửa mô tả ngắn",
  ADD_SKILL: "Thêm kỹ năng nổi bật",
  SKILL: "Kỹ năng",
  AI_ENQUIRY: "Hỏi đáp AI",
  EDIT_AVATAR: "Chỉnh sửa ảnh hồ sơ",
  ADD_AVATAR: "Thêm ảnh hồ sơ",
  EDIT_CLINIC: "Chỉnh sửa phòng khám",
  MY_STRENGTHS: "Thế mạnh của tôi",
  STANDARD_TREATMENT: "Đặc điểm điều trị",
  ACADEMIC: "Học thuật",
  PATIENT_REVIEW: "Đánh giá của bệnh nhân",
  CLINIC_INFO: "Thông tin phòng khám",
  EDIT_STRENGTHS: "Chỉnh sửa thế mạnh",
  EDIT_TREATMENT: "Chỉnh sửa điều trị",
  EDIT_PROFILE_TREATMENT: "Chỉnh sửa hồ sơ điều trị",
  DR_X_ARTICLE: "Bài viết của {{X}}",
  COURSES: "Khóa học",
  ARTICLES: "Bài viết",
  EDIT_COURSE: "Chỉnh sửa khóa học",
  UPLOAD_REVIEW_BG: "Tải lên ảnh nền đánh giá",
  EDIT_REVIEW: "Chỉnh sửa đánh giá của bệnh nhân",
  PATIENT: "Bệnh nhân",
  TITLE: "Chức danh chuyên môn",
  SAVE_SUCCESS: "Lưu thành công",
  CLINIC_NAME: "Tên phòng khám",
  PIN_TO_DISPLAY: "Ghim để hiển thị",
  DELETE: "Xóa",
  SUBURB: "Khu vực",
  POSTCODE: "Mã bưu chính",
  STATE: "Tiểu bang",
  ADD: "Thêm",
  MOVE_DOWN: "Di chuyển xuống",
  MOVE_UP: "Di chuyển lên",
  SPECIALITY: "Chuyên khoa",
  PUBLISHED: "Đã xuất bản",
  HIDDEN: "Đã ẩn",
  READ: "Đọc",
  ADD_ARTICLE: "Thêm bài viết",
  SAVE: "Lưu",
  PUBLISH: "Xuất bản",
  RE_UPLOAD_BG: "Tải lên lại ảnh nền",
  PATIENT_NAME: "Tên bệnh nhân",
  PATIENT_DESCRIPTION: "Mô tả bệnh nhân",
  REVIEW: "Đánh giá",
  REUPLOAD_PROFILE_IMAGE: "Tải lên lại ảnh hồ sơ",
  COURSE: "Khóa học",
  COURSE_TITLE: "Tiêu đề khóa học",
  START_DATE: "Ngày bắt đầu",
  END_DATE: "Ngày kết thúc",
  START_TIME: "Giờ bắt đầu",
  DURATION: "Thời lượng",
  COURSE_TYPE: "Loại khóa học",
  OFFLINE_COURSE: "Khóa học trực tiếp",
  ONLINE_COURSE: "Khóa học trực tuyến",
  MEETING_URL: "Liên kết khóa học",
  LOCATION: "Địa điểm",
  STRENGTH: "Thế mạnh",
  EXIT_PREVIEW: "Thoát xem trước",
  MY_PROFILE: "Hồ sơ của tôi",
  PURE_HARMONY: "Mẫu Sạch sẽ và Chuyên nghiệp",
  HERB_ESSENCE: "Mẫu Tươi mới và Tinh tế",
  IM_WORKED_AT: " Tôi đang làm việc tại",
  START_WORKING: "Bắt đầu làm việc",
  TOOLBAR: "Thanh công cụ",
  COLLAPSE_TOOLBAR: "Thu gọn thanh công cụ",
  EDIT_URL: "Chỉnh sửa URL",
  SLUG: "Slug",
  EDIT_SLUG: "Chỉnh sửa URL trang hồ sơ",
  PUBLISH_CONFIRM: "Xác nhận xuất bản",
  UNPUBLISH_CONFIRM: "Xác nhận hủy xuất bản",
  ARE_YOU_SURE_TO_X_WEBSITE: "Bạn có chắc chắn muốn {{X}} trang web không?",
  WEBSITE_WILL_BE_PUBLISHED_AND_VISIBLE_TO_PUBLIC_VIA_BELOW_LINK:
    "Trang web sẽ được xuất bản và hiển thị công khai qua liên kết bên dưới",
  WEBSITE_WILL_BE_UNPUBLISHED_AND_HIDDEN_FROM_PUBLIC:
    "Trang web sẽ bị hủy xuất bản và ẩn khỏi công chúng",
  U_CAN_STILL_PUBLISH_THE_WSBSITE_LATE_IF_U_WISH:
    "Bạn vẫn có thể xuất bản trang web sau này nếu muốn",
  PUBLISH_S: "xuất bản",
  UNPUBLISH_S: "hủy xuất bản",
  UNPUBLISH_WEBSITE: "Hủy xuất bản trang web",
  UNPUBLISHED: "Đã hủy xuất bản",
  SWITCH_YOUR_TEMPLATE_PUBLISHED: "Chọn một mẫu trang web mới để xuất bản.",
  CLOSE_EDITOR: "Đóng trình chỉnh sửa",
  CLOSED: "Đã đóng",
  REMOVE_SUCCESS: "Xóa thành công",
  VIEW_ALL_X_CLINICS: "Xem tất cả {{X}} phòng khám",
  CONTINUE: "Tiếp tục",
  ONLY_WORKING_WEEKDAY: "Chỉ làm việc ngày trong tuần",
  WORKING_TIME: "Thời gian làm việc",
  WORKING_IN_WHOLE_WEEK: "Làm việc cả tuần",
  MONDAY: "T2",
  TUESDAY: "T3",
  WEDNESDAY: "T4",
  THURSDAY: "T5",
  FRIDAY: "T6",
  SATURDAY: "T7",
  SUNDAY: "CN",
  WORKING_TODAY: "Đặt làm ngày làm việc",
  END_TIME: "Giờ kết thúc",
  APPLY_WORKING_TIME_TO_ALL_DAYS: "Áp dụng giờ làm việc cho tất cả các ngày",
  ONLY_WORK_IN_WEEKDAYS: "Chỉ làm việc các ngày trong tuần",
  WORK_IN_WHOLE_WEEK: "Làm việc cả tuần",
  CURRENT_WORKING_TIME_APPLIED_TO_ALL_DAYS:
    "Thời gian làm việc hiện tại đã được áp dụng cho tất cả các ngày",
  DR_X_COURSE: "Khóa học của {{X}}",
  DR_X_VIDEO: "Video của {{X}}",
  DELETE_ARTICLE: "Xóa bài viết",
  ARE_YOU_SURE_TO_DELETE_ARTICLE: "Bạn có chắc chắn muốn xóa bài viết này không?",
  THIS_ACTION_CANNOT_BE_UNDONE: "Hành động này không thể hoàn tác",
  SAVE_ARTICLE: "Lưu bài viết",
  SAVE_ARTICLE_AND_PUBLISH: "Lưu và xuất bản bài viết",
  PUBISH_ARTICLE: "Xuất bản bài viết",
  UNPUBLISH_ARTICLE: "Hủy xuất bản bài viết",
  PUBLISH_ARTICLE: "Xuất bản bài viết",
  ARE_YOU_SURE_TO_X_ARTICLE: "Bạn có chắc chắn không muốn {{X}} bài viết không?",
  VISITORS_WILL_NOT_BE_ABLE_TO_VIEW_THIS_ARTICLE:
    "Khách truy cập sẽ không thể xem bài viết này",
  VISITORS_WILL_BE_ABLE_TO_VIEW_THIS_ARTICLE:
    "Khách truy cập sẽ có thể xem bài viết này",
  UNPUBLISH: "Hủy xuất bản",
  REMOVE_BG_IMAGE: "Xóa ảnh nền",
  ARE_YOU_SURE_TO_REMOVE_BG_IMAGE:
    "Bạn có chắc chắn muốn xóa ảnh nền không?",
  BG_UPLOAD: "Tải lên ảnh nền",
  DEFAULT_BG_WILL_BE_APPLIED: "Ảnh nền mặc định sẽ được áp dụng",
  U_ARE_PREPARED_TO_TRANSLATE_UR_WEBSITE_CONTENT:
    "Bạn đang chuẩn bị dịch nội dung trang web của mình",
  WARNING: "Cảnh báo",
  IF_YOU_HAVE_INPUTTED_ANY_TEXT_INTO_THE_LANGUAGE_YOU_SELECTED_WILL_BE_OVERWRITTEN:
    "Nếu bạn đã nhập bất kỳ văn bản nào vào ngôn ngữ bạn chọn, nội dung đó sẽ bị ghi đè",
  I_UNDERSTAND_THE_ACTION_AND_AGREE_TO_TRANSLATE_USING_AI:
    "Tôi hiểu hành động này và đồng ý dịch bằng AI",
  ALL_7_DAYS: "Cả 7 ngày",
  ARTICLE_TITLE: "Tiêu đề bài viết",
  NO_WORKING_DAYS: "Không có ngày làm việc",
  WEBSITE_PUBLISHED: "Đã xuất bản trang web",
  WEBSITE_UNPUBLISHED: "Đã hủy xuất bản trang web",
  TEMPLATE_SWITCHED_AND_PUBLISHED: "Đã cập nhật và xuất bản mẫu",
  TRANSLATING_X_PLS_BE_PATIENT: "Đang dịch {{X}}. Vui lòng chờ...",
  SAVING_TRANSLATION: "Đang lưu bản dịch. Vui lòng chờ...",
  TOGGLE_LANGUAGE: "Chuyển ngôn ngữ",
  TRANSLATE_UR_WEBSITE_USING_AI: "Dịch trang web của bạn bằng AI...",
  ARTICLE: "Bài viết",
  VIEW_PATIENT_HISTORY: "Xem lịch sử bệnh nhân",
  PRESCRIPTION_INFO: "Thông tin hồ sơ bệnh án",
  TRANSLATE_FROM: "Đã dịch từ",
  TRANSLATE_TO: "Đã dịch sang",
  SWAP: "Hoán đổi",
  NO_WORKING_TIME_AVAILABLE: "Không có thời gian làm việc khả dụng",
  MY_COLLEAGUES: "Đồng nghiệp của tôi",
  DAILY_SHARING: "Chia sẻ hằng ngày",
  EDIT_MY_COLLEAGUES: "Chỉnh sửa đồng nghiệp của tôi",
  ADD_NEW_SHARING: "Thêm chia sẻ hằng ngày mới",
  EDIT_DAILY_SHARING: "Chỉnh sửa chia sẻ hằng ngày",
  ADD_IMAGE: "Thêm hình ảnh",
  COLLEAGUE_DESCRIPTION: "Mô tả đồng nghiệp",
  REUPLOAD: "Tải lên lại",
  COLLEAGUE: "Đồng nghiệp",
  PAY_THE_BALANCE: "Thanh toán số dư",
  PAYMENT_SUCCESSFUL: "Thanh toán thành công",
  DELETE_DAILY_SHARING: "Xóa chia sẻ hằng ngày",
  ARE_YOU_SURE_TO_DELETE_THIS_DAILY_SHARING:
    "Bạn có chắc chắn muốn xóa chia sẻ hằng ngày này không?",
  EDIT_VIDEO: "Chỉnh sửa video",
  ADD_VIDEO: "Thêm video",
  VIDEO: "Chia sẻ chuyên gia",
  COVER_IMAGE: "Ảnh bìa",
  VIDEO_TITLE: "Tiêu đề video",
  VIDEO_DESC: "Mô tả video",
  WATCH: "Xem",
  DELETE_VIDEO: "Xóa video",
  ARE_YOU_SURE_TO_DELETE_THIS_VIDEO:
    "Bạn có chắc chắn muốn xóa video này không?",
  USED_BY_PHONE: "Đang dùng bằng điện thoại",
  DISCONNECT_YOUR_PHONE_TO_TYPE_IN: "Ngắt kết nối điện thoại để nhập liệu",
  DISCONNECT: "Ngắt kết nối",
  CONTENT: "Nội dung",
};

const notification = {
  CLINIC_SWITCHED_TO_X: "Phòng khám hiện tại đã được chuyển sang {{X}}",
  ONLY_IMAGE_FILES_ALLOWED: "Bạn chỉ có thể tải lên tệp hình ảnh tại đây",
  HISTORY_SAVED: "Đã lưu hồ sơ bệnh án",
  TRANSLATION_COMPLETED: "Đã hoàn tất dịch",
  "UPDATE_HISTORY_#X": "Cập nhật hồ sơ #{{X}}",
  ARTICLE_TITLE_CANNOT_BE_EMPTY: "Tiêu đề bài viết không được để trống",
  ARTICLE_UPDATED: "Đã cập nhật bài viết",
  ARTICLE_CREATED: "Đã tạo bài viết",
  ARTICLE_PUBLISHED: "Đã xuất bản bài viết",
  ARTICLE_UNPUBLISHED: "Đã hủy xuất bản bài viết",
  ARTICLE_DELETED: "Đã xóa bài viết",
  PREVIEW_TEMPLATE: "Chế độ xem trước",
  U_R_IN_PREVIEW_MODE: "Bạn đang ở chế độ xem trước",
  U_R_IN_EDIT_MODE: "Bạn đang ở chế độ chỉnh sửa",
  PROFILE_IMAGE_UPLOADED: "Đã tải lên ảnh hồ sơ",
  SAVE_SUCCESS: "Lưu thành công",
  INCORRECT_USERNAME_OR_PASSWORD: "Tên đăng nhập hoặc mật khẩu không đúng",
  CLINIC_X_SELECTED: "Đã chọn phòng khám {{X}} để làm việc",
  AUTHENTICATION_EXPIRED: "Phiên xác thực đã hết hạn! Vui lòng đăng nhập lại",
  MAKE_AN_APPOINTMENT: "Đặt lịch hẹn",
  APPOINTMENT_TIME: "Thời gian hẹn",
  PHONE: "Số điện thoại",
  EMAIL: "Email",
  FIRST_NAME_IS_REQUIRED: "Bắt buộc nhập tên",
  LAST_NAME_IS_REQUIRED: "Bắt buộc nhập họ",
  PHONE_IS_REQUIRED: "Bắt buộc nhập số điện thoại",
  INVALID_PHONE_NUMBER: "Số điện thoại không hợp lệ",
  INVALID_PHONE_FORMAT_SMS_WARNING: "Số điện thoại hiện tại có thể ảnh hưởng đến việc nhận SMS. Vui lòng sử dụng định dạng 04XXXXXXXX để đảm bảo nhận được SMS chính xác.",
  PLEASE_FIX_ERRORS: "Vui lòng sửa các lỗi",
  BOOKING_CREATED: "Đã tạo lịch hẹn",
  FIRSTNAMEEN_IS_REQUIRED: "Bắt buộc nhập tên (tiếng Anh)",
  LASTNAMEEN_IS_REQUIRED: "Bắt buộc nhập họ (tiếng Anh)",
  INVALID_EMAIL: "Email không hợp lệ",
  EMAIL_IS_REQUIRED: "Bắt buộc nhập email",
  ADDRESS_IS_REQUIRED: "Bắt buộc nhập địa chỉ",
  LESS_DETAILS: "Ít chi tiết hơn",
  REMOVE: "Xóa",
  COMPANY_NAME_IS_REQUIRED: "Bắt buộc nhập tên công ty",
  INSURANCE_NUMBER_IS_REQUIRED: "Bắt buộc nhập số bảo hiểm",
  CONFIGURATION: "Cấu hình tùy chọn",
  SELECT_SECTION_U_ARE_GOING_TO_CONFIGURE:
    "Chọn mục bạn muốn cấu hình",
  BUSINESS: "Cơ sở kinh doanh",
  CONFIGURE_BUSINESS_TIME: "Cấu hình Giờ kinh doanh / Loại dịch vụ",
  LANGUAGE: "Ngôn ngữ",
  CURRENT_LANGUAGE_X: "Ngôn ngữ hiện tại: {{X}}",
  PATIENT_CREATED: "Đã tạo bệnh nhân",
  PATIENT_EDITED: "Đã cập nhật thông tin bệnh nhân",
  CHECK_IN_SUCCESS: "Nhận khám thành công",
  WHETHER_TO_DISPLAY_THIS_SECTION: "Có hiển thị mục này hay không",
};

const appointment = {
  APPOINTMENT_INFO: "Thông tin lịch hẹn",
  APPOINTMENT_STATUS: "Trạng thái lịch hẹn",
  CHECKED_IN: "Đã nhận khám",
  CHECK_IN: "Nhận khám",
  PROCEED_TO_MEDICAL_HISTORY: "Tiến tới hồ sơ bệnh án",
  APPOINTMENT_CLINIC: "Phòng khám của lịch hẹn",
  NAME: "Tên",
  U_MIGHT_LOOKING_FOR_PATIENT: "👀 Bạn có đang tìm bệnh nhân bên dưới không?",
  NO_RELAVANT_PATIENT_IN_CLINIC: "👀 Có vẻ không tìm thấy bệnh nhân liên quan nào trong phòng khám này.",
  PLS_ADD_PATIENT_FIRST: "Bạn có muốn thêm người này vào phòng khám của mình không?",
  SELECT_EXISTING_PATIENT_FROM_CLINIC_TO_CREATE_MEDICAL_HISTORY:
    "Chọn bệnh nhân từ phòng khám để tiến hành tạo hồ sơ bệnh án",
  CREATE_MEDICAL_HISTORY: "Tạo hồ sơ bệnh án",
  NONE_OF_PATIENT_ABOVE_IS_CORRECT: "Không có bệnh nhân nào ở trên?",
  PENDING_CHECK_IN: "Đã xác nhận lịch hẹn",
  PENDING_CHECK_IN_WAITING: "Đang chờ tại phòng khám",
  ARE_YOU_SURE_TO_CHECK_IN_THIS_APPOINTMENT_FOR_X:
    "Bạn có chắc chắn muốn nhận khám lịch hẹn này cho {{X}} không?",
  AFTER_CHECKED_IN_YOU_CAN_PROCEED_MEDICAL_HISTORY_FOR_THIS_PATIENT:
    "Sau khi nhận khám, bạn có thể tiến hành tạo hồ sơ bệnh án cho bệnh nhân này.",
  LOADING_APPOINTMENT: "Đang tải lịch hẹn",
  TODAY: "Hôm nay",
  REMEDIAL_MASSAGE: "Xoa bóp trị liệu",
  MASSAGE: "Xoa bóp",
  ACUPUNCTURE: "Châm cứu",
  CHINESE_MEDICINE: "Đông y",
  APPROXIMATE_DURATION: "Thời lượng ước tính",
  DURATION_MINUTES: "{{m}} phút",
  DURATION_HOURS: "{{h}} giờ",
  DURATION_HOURS_MINUTES: "{{h}} giờ {{m}} phút",
  VIEW_IN_SCHEDULE: "Xem trong lịch",
  APPROX: "Khoảng",
  BUSINESS_TIME: "Giờ kinh doanh",
  WORKING_SERVICES: "Dịch vụ cung cấp",
  WORKING_DAYS: "Ngày làm việc",
  WORKING_TIME_PERIOD: "Khoảng thời gian làm việc",
  RESET: "Đặt lại thay đổi",
  BLOCK_TIME_SLOTS: "Chặn khung giờ",
  APPLY_BLOCK_TIMES_TO_ALL_DAYS: "Áp dụng giờ chặn cho tất cả các ngày",
  LOADING_TIME_SLOTS: "Đang tải khung giờ",
  NO_AVAILABLE_TIME: "Không có thời gian khả dụng",
  RESET_CLINIC: "Đặt lại thay đổi thời gian làm việc",
  SAVE_CHANGES: "Lưu thay đổi",
  CLINIC_NOT_FOUND: "Không tìm thấy phòng khám",
  SAVE_CLINIC_SUCCESS: "Đã lưu giờ kinh doanh",
  PLEASE_SELECT_WORKING_SERVICES: "Vui lòng chọn dịch vụ cung cấp",
  START_TIME_CANNOT_BE_AFTER_END_TIME: "Giờ bắt đầu không thể sau giờ kết thúc",
  END_TIME_CANNOT_BE_BEFORE_START_TIME: "Giờ kết thúc không thể trước giờ bắt đầu",
  SELECTED_WEEKDAY: "Ngày trong tuần đã chọn",
  MINUTES: "phút",
  CLEAR_ALL: "Xóa tất cả",
  SELECT_ALL: "Chọn tất cả",
  COPY_PRODUCTS_TO_OTHER_CLINIC: "Sao chép sản phẩm sang phòng khám khác",
  COPY_PRODUCTS_FROM_OTHER_CLINIC: "Sao chép sản phẩm từ phòng khám khác",
  ASSIGN_PRACTITIONERS_TO_IMPORTED: "Gán chuyên viên cho sản phẩm đã nhập",
  SELECT_SOURCE_CLINIC: "Chọn phòng khám nguồn",
  X_PRODUCTS_IMPORTED_FROM_Y: "Đã nhập {{X}} sản phẩm từ {{Y}}",
  COPY_TO_THIS_CLINIC: "Sao chép vào phòng khám này",
  SELECT_PRODUCTS_TO_COPY: "Chọn sản phẩm để sao chép",
  SELECT_TARGET_CLINIC: "Chọn phòng khám đích",
  SELECTED_X_OF_Y: "Đã chọn {{X}} trên {{Y}}",
  PRODUCTS_COPIED_SUCCESS: "Đã sao chép sản phẩm sang phòng khám đích",
  X_PRODUCTS_COPIED_TO_Y: "Đã sao chép {{X}} sản phẩm đã chọn sang {{Y}}",
  GO_TO_CLINIC_PRODUCTS: "Đến trang sản phẩm của phòng khám",
  HIDE_PREVIEW: "Ẩn xem trước",
  X_PRODUCTS_IN_THIS_CLINIC: "{{X}} sản phẩm trong phòng khám này",
  CLICK_ON_TIMESLOT_THAT_YOU_DONT_WANT_IT_BE_AVAILABLE_FOR_APPOINTMENT:
    "Nhấp để chặn khung giờ mà bạn không muốn nó khả dụng để đặt lịch hẹn",
  SELECT_WORKING_DAY: "Chọn ngày làm việc",
  DECREASE_DURATION: "Giảm thời lượng",
  INCREASE_DURATION: "Tăng thời lượng",
  CURRENT_BLOCK_TIME_APPLIED_TO_ALL_DAYS:
    "Giờ chặn hiện tại đã được áp dụng cho tất cả các ngày",
  SAVE_AS_NOT_WORKING: "Lưu là không làm việc",
  SAVE_AS_WORKING: "Lưu là làm việc",
  CONFIRM_CLEAR_BLOCK_TIMES: "Bạn có chắc chắn muốn xóa tất cả giờ chặn không?",
  CHANGING_DURATION_WILL_CLEAR_ALL_BLOCK_TIMES:
    "Thay đổi thời lượng sẽ xóa tất cả giờ chặn",
  CHANGING_WORKING_TIME_WILL_CLEAR_TODAY_BLOCK_TIMES:
    "Thay đổi thời gian làm việc sẽ xóa giờ chặn của hôm nay",
  BLOCK_TIMES_CLEARED: "Đã xóa giờ chặn",
  SAVING: "Đang lưu",
  BLOCK_THIS_TIMESLOT: "Chặn khung giờ này",
  ACTIVE_THIS_TIMESLOT: "Kích hoạt khung giờ này",
  UNSAVED_CHANGES: "Thay đổi chưa lưu",
  SCHEDULE_CONFLICT: "Xung đột lịch làm việc",
  ALREADY_WORKING_IN_OTHER_CLINICS_ON_THESE_DAYS: "Bạn đã có lịch làm việc tại các phòng khám khác vào những ngày sau:",
  CONFIRM_TO_REPLACE_AND_SAVE: "Xác nhận sẽ thay thế các ngày này ở các phòng khám khác, sau đó lưu thay đổi tại đây.",
  YOU_HAVE_UNSAVED_CHANGES_CONTINUE:
    "Bạn có những thay đổi chưa lưu. Bạn có chắc chắn muốn chuyển phòng khám và bỏ qua chúng không?",
  DISCARD_AND_SWITCH: "Bỏ qua và Chuyển",
  YOU_HAVE_NO_CONFIGURE_YOUR_WORKING_TIME_IN_THIS_CLINIC:
    "Bạn chưa cấu hình thời gian làm việc của mình tại phòng khám này",
  CONFIGURE_WORKING_TIME: "Giờ làm việc và dịch vụ của tôi",
  MY_WORKING_CLINICS: "Phòng khám nơi tôi làm việc",
  ALL: "Tất cả",
  FILTER: "Lọc",
  STATUS: "Trạng thái",
  REJECT: "Từ chối",
  DATE_OF_BIRTH_IS_REQUIRED: "Bắt buộc nhập ngày sinh",
  INVALID_DATE: "Ngày không hợp lệ",
  DATE_CANNOT_BE_IN_FUTURE: "Ngày không được ở tương lai",
  PATIENT_UPDATED_WARNING: "Cảnh báo thông tin bệnh nhân",
  SYSTEM_HAS_DETECTED_THE_FOLLOWING_CHANGES_TO_THIS_PATIENT:
    "Hệ thống phát hiện thông tin bệnh nhân hiện tại không khớp với thông tin được cung cấp trong thông tin lịch hẹn này",
  DO_U_WANT_TO_UPDATE_THIS_PATIENT_INFO:
    "Bạn có muốn cập nhật thông tin bệnh nhân không?",
  CURRENT_INFO: "Thông tin hiện tại",
  UPDATED_INFO: "Thông tin cập nhật",
  QUICK_UPDATE: "Cập nhật nhanh",
  DATE_SCHEDULE: "Lịch theo ngày",
  NO_APPOINTMENT_FOUND: "Không tìm thấy lịch hẹn",
  INCOMING_BOOKINGS_ONLY: "Chỉ lịch hẹn sắp tới",
  SELECT_HOUR: "Chọn giờ",
  SELECT_MINUTE: "Chọn phút",
  SELECT_APPOINTMENT_TIME: "Chọn thời gian hẹn",
  X_APPOINTMENTS_SCHEDULED_FOR_THIS_DATE:
    "{{X}} lịch hẹn được lên lịch cho ngày này",
  X_APPOINTMENTS_SECHEDULED_FOR_TODAY: "{{X}} lịch hẹn được lên lịch cho hôm nay",
  THIS_SAVED_PATIENT_INCLUDES_INVALID_PHONE_NUMBER_THIS_MIGHT_BE_A_PROBLEM_RECEIVING_SMS_LATER:
    "Đã phát hiện số điện thoại không hợp lệ cho bệnh nhân hiện tại, điều này có thể ảnh hưởng đến việc gửi thông báo SMS trong tương lai.",
  A_REMINDER_SMS_WILL_BE_SENT_TO_THE_PATIENT_WHEN_NEAR_THE_APPOINTMENT_DATE:
    "Mẹo: Khi gần đến giờ hẹn, một tin nhắn SMS nhắc nhở sẽ được gửi đến bệnh nhân.",
  A_REMINDER_SMS_WILL_BE_SENT_TO_THE_U_WHEN_NEAR_THE_APPOINTMENT_DATE:
    "Mẹo: Khi gần đến giờ hẹn, một tin nhắn SMS nhắc nhở sẽ được gửi đến bạn",
  BOOKED_PRACTITIONER: "Chuyên viên phụ trách",
  U_CAN_MANAGE_UR_CLINIC_PRODUCT_HERE: "Quản lý sản phẩm phòng khám của bạn tại đây",
  THESE_PRODUCTS_WILL_BE_USED_IN_PATIENTS_BOOKING_FROM_PUBLIC:
    "Các sản phẩm này sẽ khả dụng cho bệnh nhân khi đặt lịch hẹn qua hệ thống đặt lịch công khai",
  THIS_NOTE_WILL_BE_SAVED_TO_NEW_PATIENT_PROFILE: "Ghi chú này sẽ được lưu vào hồ sơ bệnh nhân mới.",
};

const clinicManagement = {
  CLINIC_SETTINGS: "Cài đặt phòng khám",
  CLINIC_MANAGEMENT: "Quản lý phòng khám & thành viên",
  SEARCH_CLINIC_IN_SEARCH_BAR_TO_JOIN_IN_OR_CREATE_NEW_CLINIC:
    "Tìm phòng khám trong thanh tìm kiếm để tham gia hoặc tạo phòng khám mới",
  NO_CLOSED_CLINICS: "Không có phòng khám đã đóng",
  NO_PENDING_CLINICS: "Không có phòng khám đang chờ xử lý",
  SEARCH_CLINIC: "Tìm phòng khám",
  ADD_CLINIC: "Tạo phòng khám mới",
  CLINIC_INFO: "Thông tin phòng khám",
  OWNER: "Chủ sở hữu",
  INVITE_PRACTITIONERS: "Mời chuyên viên",
  INVITED: "Đã mời",
  NO_PRACTITIONER_FOUND: "Không tìm thấy chuyên viên",
  SUBMIT_CLINIC_INFO: "Gửi thông tin phòng khám",
  UPDATE_CLINIC_INFO: "Cập nhật thông tin phòng khám",
  RESUBMIT_CLINIC_INFO: "Gửi lại thông tin phòng khám",
  ADDRESS: "Địa chỉ",
  OPEN: "Đang mở",
  PENDING: "Đang chờ",
  MY_CLINIC: "Phòng khám của tôi",
  EDIT_CLINIC_INFO: "Chỉnh sửa phòng khám",
  ACTIVE: "Đang hoạt động",
  INACTIVE: "Không hoạt động",
  ASSOCIATED_PRACTITIONERS: "Chuyên viên liên kết",
  NO_PHONE_NUMBER: "Không có số điện thoại",
  PRACTITIONER_INFO: "Thông tin chuyên viên",
  SERVICES: "Dịch vụ",
  WORK_TIME: "Thời gian làm việc",
  WORKING_DAY: "Ngày làm việc",
  NOT_AVAILABLE: "Không khả dụng",
  MINS: " phút",
  X_PRACTITIONERS_ARE_NOW_ACTIVE: "{{X}} chuyên viên hiện đang hoạt động",
  X_PRACTITIONERS_FOUND: "Tổng cộng {{X}} chuyên viên",
  NO_ACTIVE_PRACTITIONERS: "Không tìm thấy chuyên viên",
  NO_INACTIVE_PRACTITIONERS: "Không có chuyên viên không hoạt động",
  INVITE: "Mời",
  WORKING_IN_CLINIC: "Đang làm việc tại phòng khám",
  QUIT_PRACTITIONER: "Cho chuyên viên nghỉ",
  QUIT_FROM_CLINIC: "Rời khỏi phòng khám",
  QUIT_CLINIC_CONFIRM: "Xác nhận rời phòng khám",
  QUIT_CLINIC_REQUEST_SENT: "Đã gửi yêu cầu rời phòng khám",
  ARE_YOU_SURE_TO_QUIT_CLINIC: "Bạn có chắc chắn muốn rời phòng khám này",
  YOU_WILL_NOT_BE_ABLE_TO_BE_BOOKED_BY_PATIENT_FOR_THIS_CLINIC_ANYMORE:
    "Sau khi được duyệt, bạn sẽ không còn được bệnh nhân đặt lịch cho phòng khám này nữa",
  PENDING_APPROVE_TO_QUIT: "Đang chờ duyệt để rời",
  PENDING_APPROVE_TO_JOIN: "Đang chờ duyệt để tham gia",
  JOIN_CLINIC: "Tham gia phòng khám",
  X_NEW_MEMBER_REQUESTS: "{{X}} yêu cầu mới đang chờ xử lý",
  JOIN_CLINIC_CONFIRM: "Xác nhận tham gia phòng khám",
  ARE_YOU_SURE_TO_JOIN_CLINIC: "Bạn có chắc chắn muốn tham gia phòng khám này",
  YOUR_JOIN_REQUEST_HAS_BEEN_SENT: "Yêu cầu tham gia của bạn đã được gửi",
  NEW_PRACITTIONERS: "Chuyên viên mới",
  ACCEPT_CONFRIM: "Xác nhận chấp nhận",
  ARE_YOU_SURE_TO_ACCEPT_PRACTITIONER_REQUEST:
    "Bạn có chắc chắn muốn chấp nhận yêu cầu của chuyên viên này",
  ARE_YOU_SURE_TO_REJECT_PRACTITIONER_REQUEST:
    "Bạn có chắc chắn muốn từ chối yêu cầu của chuyên viên này",
  VIEW_INFO: "Xem thông tin",
  NO_SERVICES_AVAILABLE: "Không có dịch vụ khả dụng",
  SEARCH_PRACTITIONER_BY_NAME: "Tìm chuyên viên phòng khám theo tên",
  X_PENDING_APPROVAL: "{{X}} yêu cầu đang chờ duyệt",
  APPROVE: "Duyệt",
  DECLINE: "Từ chối",
  ACCEPT: "Chấp nhận",
  CLEAR: "Xóa",
  ACCEPT_CONFIRM: "Xác nhận chấp nhận",
  REJECT_CONFIRM: "Xác nhận từ chối",
  CLOSE_CLINIC: "Đóng phòng khám",
  CONFIRM_TO_CLOSE_CLINIC: "Xác nhận đóng phòng khám",
  THIS_CLINIC_WILL_BE_CLOSED_AND_ALL_ASSOCIATED_PRACTITIONERS_WILL_BE_REMOVED:
    "Phòng khám này sẽ bị đóng và tất cả chuyên viên liên kết sẽ bị gỡ bỏ",
  I_UNDERSTAND_THE_CONSEQUENCES_OF_CLOSING_THIS_CLINIC:
    "Tôi hiểu hậu quả của việc đóng phòng khám này",
  ME: "Tôi",
  ARE_YOU_SURE_TO_REMOVE_PRACTITIONER_FROM_CLINIC:
    "Bạn có chắc chắn muốn gỡ chuyên viên này khỏi phòng khám này",
  THIS_PRACTITIONER_WILL_NOT_BE_ABLE_TO_VIEW_USE_INFO_FOR_THIS_CLINIC:
    "Chuyên viên này sẽ không còn có thể làm việc tại phòng khám này nữa",
  INVITE_CONFIRM: "Xác nhận mời",
  ARE_YOU_SURE_TO_INVITE_X_TO_YOUR_CLINIC:
    "Bạn có chắc chắn muốn mời {{X}} vào phòng khám của mình",
  CONTINUE: "Tiếp tục",
  PENDING_ACCEPT: "Đang chờ chuyên viên chấp nhận",
  NO_CLINIC_SELECTED: "Chưa chọn phòng khám",
  NO_WORKING_CLINIC_FOUND: "Không tìm thấy phòng khám nơi bạn làm việc",
  NEW_CLINIC_INVITATION: "Lời mời tham gia phòng khám",
  ADD_JOIN_CLINIC: "Thêm / Tham gia phòng khám mới",
  OR_U_CAN: "HOẶC BẠN CÓ THỂ",
  CONSULTATION_FEES: "Phí phòng khám",
  THIS_CONSULTATION_FEES_WILL_BE_DISPLAYED_IN_YOUR_PERSONAL_PAGE:
    "Các khoản phí phòng khám đã hoàn tất (phí > $0.00) sẽ được hiển thị trên trang cá nhân của bạn",
  ENTER_FEE_LABEL: "Nhập nhãn phí",
  ADD_OTHER_CONSULTATION_FEE: "Thêm phí phòng khám khác",
  ALL_PACKAGES: "Tất cả gói",
  PACKAGE_FILTER: "Lọc người dùng phòng khám theo gói",
  EXTEND_PACKAGE: "Gia hạn gói",
  OOPS_THIS_PACKAGE_HAS_ALREADY_REACHED_ITS_CAPACITY:
    "🤔 Gói đã mua của người dùng cho gói này đã đạt sức chứa tối đa.",
  USER_PACK_PURCHASED: "Gói người dùng đã phân bổ / mua",
  THIS_PACKAGE_HAS_ALREADY_BEEN_ASSIGNED_TO_THIS_CLINIC_USER:
    "Người dùng phòng khám này đã được phân bổ vào gói này.",
  THIS_PACKAGE_HAS_ALREADY_REACHED_ITS_CAPACITY:
    "Gói đã mua của người dùng cho gói này đã đạt sức chứa tối đa.",
  EXPIRED_TODAY: "Sắp hết hạn",
  SOON_TO_EXPIRED: "Sắp hết hạn",
  EXTEND_NOW: "Gia hạn ngay",
  REMOVE_PACKAGE_FROM_USER: "Gỡ gói khỏi người dùng này",
  NO_PERMISSION_TO_ACCESS_CLINIC_FUNCTION:
    "Trong trường hợp này, người dùng sẽ không còn có thể truy cập chức năng phòng khám",
  NO_PERMISSION_ACCESS_FEATURE_OR_DATA:
    "Bạn hiện không có quyền truy cập dữ liệu hoặc tính năng này. Nếu có bất kỳ thắc mắc nào về quyền hạn, vui lòng liên hệ quản trị viên phòng khám của bạn",
  CURRENT_CLINIC_INVALID_MAY_HAVE_LEFT:
    "Phòng khám này không còn hợp lệ — có thể bạn đã rời khỏi phòng khám này",
  CLINIC_WORK_PERMISSIONS_UPDATED:
    "Đã phát hiện quyền làm việc của bạn tại phòng khám này đã được cập nhật",
  VALID_PACKAGE: "Gói hợp lệ",
  REPURCHASE_PACKAGE: "Mua lại gói",
  CLOSED_CLINIC: "Phòng khám đã đóng",
  THIS_CLINIC_HAS_BEEN_CLOSED: "Phòng khám này đã bị đóng",
  CLINIC_RELATED_TO_ME: "Phòng khám liên quan đến tôi",
  CANCEL_INVITATION_SUCCESS: "Hủy lời mời thành công",
  AVG_DURATION: "Thời lượng tư vấn trung bình",
  VIEW_CLINIC: "Xem phòng khám",
  NEW: "Mới",
  CLINIC_NO_PACKAGE_SUBSCRIBED: "Phòng khám chưa có gói đăng ký nào đang hoạt động.",
  PURCHASE_PACKAGE_AND_ASSIGN_TO_CLINIC_MEMBERS_TO_START_WORKING_AT_HEALTHNEX:
    "Sau khi bạn mua một gói và gán cho nhân viên phòng khám, bạn có thể mở khóa ngay trải nghiệm dịch vụ Healthnex đầy đủ!",
  PURCHASE_PACKAGE_TO_START_WORKING_AT_HEALTHNEX:
    "Sau khi bạn mua một gói, bạn có thể mở khóa ngay trải nghiệm dịch vụ Healthnex đầy đủ!",
  PURCHASE_PACKAGE_FOR_UR_CLINIC: "Chọn gói phù hợp cho phòng khám của bạn",
  NO_SURE_WHAT_DO: "Không chắc bắt đầu từ đâu?",
  START_SYSTEM_GUIDE: "Bắt đầu hướng dẫn",
  NO_PACKAGE_ALLOCATED: "Bạn chưa được gán gói nào tại phòng khám này",
  PLEASE_CONTACT_YOUR_CLINIC_OWNER_TO_ASSIGN_THE_PACKAGE_TO_ACCESS_MORE_FEATURES_IN_HEALTHNEX:
    "Vui lòng liên hệ chủ phòng khám để gán gói cho bạn nhằm truy cập đầy đủ tính năng Healthnex.",
  SUBSCRIPTION: "Đăng ký gói",
  SELECT_A_SUITABLE_PACKAGE_FOR_YOUR_CLINIC_MEMBERS_TO_START_WORKING:
    "Chọn gói phù hợp cho nhân viên phòng khám để bắt đầu làm việc.",
  ASSIGN_TO_CLINIC: "Gán cho phòng khám",
  SELECT_THE_CLINIC_THAT_U_WITH_TO_APPLY_THIS_PACKAGE_FOR:
    "Vui lòng chọn phòng khám mà bạn muốn áp dụng gói này",
  ADJUST_NUMBER_USER_PACK_U_WISH_TO_PURCHASE:
    "Vui lòng điều chỉnh số lượng gói người dùng bạn muốn mua (nếu gói này là gói kết hợp, bạn sẽ không thể tùy chỉnh số lượng người dùng)",
  USER_PACK_CAN_BE_ASSIGNED_TO_CLINIC_USER_TO_ALLOW_EXPERIENCE_THE_PACKAGE_FEATURE:
    "Gói người dùng có thể được gán cho nhân viên phòng khám, cho phép họ truy cập và trải nghiệm các tính năng của gói.",
  EG_PURCHASED_3_USER_PACKS_CAN_BE_APPLY_TO_3_USERS_IN_CLINIC_INCLUDE_OWNER:
    "Ví dụ, nếu bạn mua 3 gói người dùng, bạn có thể gán chúng cho 3 nhân viên phòng khám, bao gồm cả chủ phòng khám.",
  ASSIGN_USER_PACK_TO_CLINIC_USER: "Gán gói người dùng cho thành viên phòng khám",
  CLINIC_MEMBERS_WHO_DONT_HAVE_PACKAGE_WILL_BE_DISPLAYED_HERE_U_CAN_QUICK_ASSIGNED_PURCHASED_USER_PACK_TO_THEM:
    "Nhân viên phòng khám chưa được gán gói sẽ hiển thị tại đây. Bạn có thể nhanh chóng gán các gói người dùng đã mua cho họ.",
  CARD_DETAIL: "Thông tin thẻ",
  FILLING_UR_CARD_DETAIL_TO_PAY:
    "Điền thông tin thẻ của bạn để hoàn tất thanh toán",
  PAY_NOW: "Thanh toán ngay",
  DONT_SHOW_AGAIN: "Không hiển thị lại",
  ORDER_NO: "Đơn hàng",
  SELECTED_CLINIC: "Phòng khám đã chọn",
  CLINIC_LOGO: "Logo phòng khám",
  EDIT_LOGO: "Chỉnh sửa logo",
  ADD_LOGO: "Thêm logo",
  REUPLOAD_LOGO: "Tải lên lại logo",
  UPLOAD_LOGO: "Tải lên logo",
  CLINIC_LOGO_UPLOADED: "Đã tải lên logo phòng khám",
  NO_CLINICS_FOUND_IN_X: "🤔 Không tìm thấy phòng khám liên quan nào trong {{X}}",
  U_CAN_CREATE_YOUR_OWN_CLINIC_OR_JOIN_AN_EXISTING_CLINIC_TO_WORK_LATER:
    "🎉 Đừng lo—bạn có thể tạo phòng khám của riêng mình ngay bây giờ hoặc tham gia một phòng khám sau, tùy theo điều phù hợp nhất với bạn!",
  JOINED: "Đã tham gia",
  U_ARE_THE_OWNER_OF_BELOW_CLINICS:
    "Bạn sẽ trở thành chủ sở hữu của phòng khám sau đây",
  WE_WILL_CREATE_THE_CLINIC_FOR_YOU_ANY_NO_NAME_CLINIC_WILL_BE_RENAME_TO_YOUR_NAME:
    "Chúng tôi sẽ tạo các phòng khám này cho bạn. Lưu ý rằng bất kỳ phòng khám nào chưa có tên sẽ được đặt tên dựa trên tên của bạn. Ví dụ: Phòng khám của John",
  U_ARE_THE_MEMBER_OF_BELOW_CLINICS: "Bạn là thành viên của các phòng khám sau đây",
  U_WILL_BE_THE_MEMBER_OF_THE_BELOW_CLINICS:
    "Bạn sẽ tham gia các phòng khám hiện có sau đây trên Healthnex với tư cách thành viên",
  THESE_CLINICS_HAS_NOT_BEEN_CREATED_BY_THEIR_OWNER_IN_SYSTEM_PLEASE_CONTACT_THEIR_OWNER_TO_CREATE_THE_CLINIC_AND_INVITE_YOU_IN:
    "Các phòng khám này chưa được chủ sở hữu tạo trong hệ thống Healthnex. Vui lòng liên hệ chủ phòng khám để tạo phòng khám và mời bạn tham gia.",
  CLINIC_BELOWS_ARE_NOT_IN_THE_SYSTEM:
    "Bạn là thành viên của các phòng khám sau đây, nhưng chúng chưa được tạo trong hệ thống Healthnex.",
  CREATING_ACCOUNT:
    "Vui lòng chờ trong giây lát, chúng tôi đang tạo tài khoản Healthnex của bạn",
  PLEASE_DONT_CLOSE_THIS_PAGE: "Vui lòng không đóng trang này",
  WELCOME_TO_HEALTHNEX: "Chào mừng đến với Healthnex!",
  VERIFYING_EXTERNAL_ACCOUNT: "Đang xác minh thông tin tài khoản bên ngoài",
  PACKAGE_IS_SOOON_TO_EXPIRED: "Các gói sau đây sắp hết hạn.",
  IF_NOT_RENEW_SERVICE_WILL_BE_STOPPED:
    "Nếu bạn không gia hạn kịp thời, các dịch vụ hiện tại của bạn sẽ bị tạm ngưng.",
  RENEW_UR_PACKAGE_BEFORE_LOSE_ACCESS_TO_UR_SERVICE:
    "Để tránh bất kỳ gián đoạn nào đối với hoạt động hằng ngày, vui lòng gia hạn gói của bạn càng sớm càng tốt để đảm bảo dịch vụ luôn khả dụng.",
  RENEW_NOW: "Gia hạn ngay",
  MY_PACKAGE: "Gói của tôi",
  THIS_FEATURE_REQUIRED_A_PACKAGE_SUBSCRIPTION:
    "Tính năng này yêu cầu đăng ký gói",
  CURRENT_PACKAGE: "Gói hiện tại",
  NO_ADDRESS: "Không có địa chỉ",
  CURRENT_CLINIC_NOT_FOUND: "Không tìm thấy phòng khám hiện tại",
  CURRENT_PACKAGE_OFFER: "Ưu đãi gói hiện tại",
  FOR_USERS_PACK_AVAILABLE: " gói người dùng",
  U_CAN_ENTER_MODIFY_UR_INSURANCE_NUMBER_HERE:
    "Bạn có thể nhập hoặc chỉnh sửa số bảo hiểm của mình tại đây",
  INCLUDED_INSURANCES: "Bảo hiểm đã bao gồm",
  NO_MODALITY_INSURANCE: "Chưa thêm bảo hiểm",
  ADD_MODALITY_INSURANCE_NO: "Thêm bảo hiểm",
  INSURANCE_PROVIDER: "Nhà cung cấp BH",
  INSURANCE_NUMBER: "Số BH",
  SWITCH_TO_ENABLED: "Bật",
  SWITCH_TO_NOT_ENABLED: "Không bật mục này",
  INSURANCE_NOT_ENABLED: "Bảo hiểm chưa được bật",
  MODALITY_NOT_ENABLED: "Dịch vụ chưa được bật",
  X_INSURANCES_CHANGE_UNSAVED_ARE_YOU_SURE_TO_CLOSE:
    "Bạn có các thay đổi chưa lưu trong {{X}} bảo hiểm. Bạn có chắc chắn muốn đóng cửa sổ này không?",
  CLINIC_MAXIMUM_BED_NUM: "Sức chứa giường tối đa của phòng khám",
  CURRENT_MAXIMUM_BED_NUM_CONFIGURED_BY_CLINIC:
    "Sức chứa giường tối đa hiện tại do phòng khám cấu hình",
  CONFIGURE_BED_NUM: "Cấu hình sức chứa giường của phòng khám",
  BED: "Giường",
  PRACTITIONER_CAPACITY: "Số bệnh nhân tối đa đồng thời cho mỗi dịch vụ",
  PATIENT_AT_SAME_TIME: "Bệnh nhân cùng lúc",
  THIS_VALUE_CANNOT_EXCEED_THE_CLINIC_MAXIMUM_CAPACITY:
    "Giá trị này không thể vượt quá sức chứa giường tối đa của phòng khám.",
  X_BED_NUM: "{{X}} giường",
  U_CAN_CHANGE_THE_CLINIC_BED_NUM_HERE:
    "Bạn có thể thay đổi sức chứa giường của phòng khám tại đây",
  NOT_WORKING_DAY_IN_THIS_CLINIC: "Không phải ngày làm việc",
  REST_DAY: "Nghỉ",
  WORK_IN: "Làm việc tại",
  SELECT_ADDON: "Chọn dịch vụ bổ sung",
  YOU_SUBSCRIBED_ALL_ADDONS_TO_THIS_PACKAGE: "Bạn đã đăng ký tất cả dịch vụ bổ sung trong gói",
  EFFECTIVE_DATE: "Thời gian hiệu lực",
  NOT_YET_EFFECTIVE: "Chưa có hiệu lực",
  CANCEL_SUBSCRIPTION: "Hủy đăng ký",
  CANCEL_SUBSCRIPTION_CONFIRM: "Hủy đăng ký này?",
  CANCEL_SUBSCRIPTION_DESC: "Sau khi hủy, gói này không thể gia hạn nữa. Bạn có thể tiếp tục sử dụng bình thường cho đến khi đăng ký hết hạn, sau đó gói sẽ bị vô hiệu hóa.",
  SUBSCRIPTION_CANCELLED: "Đã hủy đăng ký",
  E_DAYS_LEFT: " ngày còn lại",
  E_DAYS_AGO: " ngày trước",
  FILTER_PRACTITIONER_BY: "Lọc chuyên viên theo",
  ASSIGN_PRACTITIONER: "Gán chuyên viên",
  CLINIC_PRACTITIONERS_NOT_VISIBLE_BELOW: "Chuyên viên không khả dụng cho dịch vụ này",
  BELOW_PRACTITIONERS_NOT_PROVIDING_SERVICE: "Các chuyên viên sau đây không cung cấp dịch vụ này:",
  ENABLE_SERVICE: "Bật dịch vụ",
  ADDON: "Dịch vụ bổ sung",
  PACKAGE: "Gói",
};

const clinicHerbs = {
  HERB_MANAGEMENT: "Quản lý tài nguyên phòng khám",
  MANAGE_YOUR_CLINIC_HERBS_FORMULA:
    "Quản lý thông tin dược liệu và bài thuốc chỉ có sẵn trong phòng khám hiện tại của bạn",
  CURRENT_CLINIC: "Phòng khám hiện tại",
  CONFIGURE_CLINIC_HERBS: "Cấu hình dược liệu phòng khám",
  CONFIGURE_CLINIC_FORMULA: "Cấu hình bài thuốc phòng khám",
  CLINIC_HERB: "Dược liệu phòng khám",
  CLINIC_FORMULA: "Bài thuốc phòng khám",
  SEARCH_HERB_NAME: "Tìm tên dược liệu",
  SEARCH_FORMULA_NAME: "Tìm tên bài thuốc",
  ADD_HERB: "Thêm dược liệu",
  ADD_FORMULA: "Thêm bài thuốc",
  HERB_NAME: "Tên dược liệu",
  HERB_NAME_IN_X: "Tên dược liệu ({{X}})",
  PINYIN: "Pinyin",
  IS_TOXIC: "Có độc tính",
  IS_PREMIUM: "Loại cao cấp",
  USED_BY_CREATER_ONLY: "Chỉ người tạo sử dụng",
  TOXIC: "Có độc",
  PREMIUM: "Cao cấp",
  YES: "Có",
  NO: "Không",
  HERB_NAME_CN: "Tên dược liệu (tiếng Trung)",
  FORMULA_NAME_CN: "Tên bài thuốc (tiếng Trung)",
  HERB_NAME_EN: "Tên dược liệu (tiếng Anh)",
  FORMULA_NAME_EN: "Tên bài thuốc (tiếng Anh)",
  HERB_NAME_X: "Tên dược liệu ({{X}})",
  FORMULA_NAME_X: "Tên bài thuốc ({{X}})",
  HERB_INFO: "Thông tin dược liệu",
  FORMULA_INFO: "Thông tin bài thuốc",
  THIS_FORMULA_CAN_ONLY_BE_USED_EDITED_BY_YOURSELF:
    "Bài thuốc này chỉ có thể được sử dụng/chỉnh sửa bởi người tạo (chính tôi)",
  SEARCH_HERB_NAME_HERE: "Tìm tên dược liệu tại đây",
  SEARCH_HERB_BY_HERB_NAME: "Tìm dược liệu theo tên dược liệu",
  HERB_IN_THIS_FORMULA: "Dược liệu trong bài thuốc này",
  NO_HERB_ADDED: "Chưa thêm dược liệu",
  FORMULA_NAME: "Tên bài thuốc",
  FORMULA_NAME_IN_X: "Tên bài thuốc ({{X}})",
  NUM_HERBS: "Số lượng dược liệu",
  ADDED: "Đã thêm",
  FORMULA_CREATED: "Đã tạo bài thuốc",
  FORMULA_UPDATED: "Đã cập nhật bài thuốc",
  POINT_GROUP_CREATED: "Đã tạo nhóm huyệt",
  HERB_CREATED: "Đã tạo dược liệu",
  HERB_UPDATED: "Đã cập nhật dược liệu",
  UNDO: "Hoàn tác",
  REDO: "Làm lại",
  PLZ_INPUT_FORMULA_NAME_CN: "Vui lòng nhập tên bài thuốc bằng tiếng Trung",
  PLZ_INPUT_FORMULA_NAME_EN: "Vui lòng nhập tên bài thuốc bằng tiếng Anh",
  PLZ_INPUT_FORMULA_NAME_X: "Vui lòng nhập tên bài thuốc bằng {{X}}",
  PLZ_INPUT_PINYIN: "Vui lòng nhập pinyin",
  PLZ_INPUT_HERB_NAME_CN: "Vui lòng nhập tên dược liệu bằng tiếng Trung",
  PLZ_INPUT_HERB_NAME_EN: "Vui lòng nhập tên dược liệu bằng tiếng Anh",
  PLZ_INPUT_HERB_NAME_X: "Vui lòng nhập tên dược liệu bằng {{X}}",
};
const packagePages = {
  INCLUDES: "Bao gồm",
  INCLUDES_ALL_LOWER_AND: "Bao gồm tất cả tính năng cấp thấp hơn và",
  PP_PER_YEAR: "Mỗi người dùng / Năm",
  PP_PER_MONTH: "Mỗi người dùng / Tháng",
  PACKAGES: "Gói",
  EXPIRE_IN_X_DAYS: "Hết hạn sau {{X}} ngày",
  FOR_NEXT_X_DAYS: "Cho {{X}} ngày tới",
  SELECT_CLINIC_FOR_APPLYING_PACKAGE:
    "Chọn phòng khám để áp dụng gói",
  NUMBER_OF_USER: "Số lượng người dùng",
  SELECTED_PACKAGE: "Gói đã chọn",
  CURRENT_USER: "Người dùng hiện tại",
  NEW_PACKAGE: "Đăng ký gói mới",
  NO_CLINIC_MEMBERS: "Không có thành viên phòng khám nào chưa có gói.",
  ASSIGN_PACKAGE_TO_USER: "Gán cho thành viên phòng khám",
  PER_EXIST_USER: "Mỗi người dùng hiện có",
  PER_NEW_USER: "Mỗi người dùng mới",
  NO_PACKAGES_FOUND: "Không tìm thấy gói",
  EXTEND: "Gia hạn",
  UPGRADE: "Nâng cấp",
  RENEW: "Gia hạn",
  PP: "Mỗi người dùng",
  SELECT_A_PACKAGE: "Chọn một gói",
  CHANGE: "Thay đổi",
  REASSIGN: "Gán lại",
  ASSIGN: "Gán",
  PURCHASE_PACKAGES: "Mua gói",
  NO_PACKAGE: "Không có gói",
  EXPIRE_DATE: "Ngày hết hạn",
  MAX_USERS: "Số người dùng tối đa",
  TIME: "Thời gian",
  PRICE: "Giá",
  PAYMENT_HISTORY: "Lịch sử thanh toán",
  CHECK_YOUR_PAYMENT_HISTORY: "Kiểm tra lịch sử thanh toán của bạn",
  THIS_PACKAGE_IS_ONLY_FOR_YOURSELF_NOT_FOR_YOUR_CLINIC_MEMBER:
    "Gói này dành cho sử dụng cá nhân và sẽ được áp dụng trực tiếp vào tài khoản của bạn khi kích hoạt.",
  PURCHASE: "Mua",
  SELECT_AVAILABLE_CLINIC_PACKAGE_FOR_YOUR_CLINIC:
    "Chọn gói mong muốn cho phòng khám của bạn",
  EXTEND_SELECTED_PACKAGE: "Gia hạn gói đã chọn",
  UPGRADE_SELECTED_PACKAGE: "Nâng cấp gói đã chọn",
  APPLY_THE_PACKAGE_TO_YOUR_CLINIC:
    "Áp dụng / tùy chỉnh gói cho phòng khám của bạn",
  MAKE_PAYMENT: "Thực hiện thanh toán",
  MY_CLINICS: "Phòng khám của tôi",
  NOTE: "Lưu ý",
  ANY_CLINICS_MANAGED_BY_U_WILL_BE_AVAILABLE_BELOW:
    "Bất kỳ phòng khám nào bạn quản lý sẽ có sẵn bên dưới",
  CURRENT_PURCHASED_USERS: "Người dùng đã mua hiện tại",
  USERS: " Người dùng",
  FOR_USERS_PACK: " Gói người dùng",
  EXTEND_TO: "Gia hạn thành",
  EXTEND_USERS_NUMBER_CANNOT_BE_EQUAL_OR_LESS_THAN_CURRENT_USER_NUMBER:
    "Số người dùng gia hạn không thể nhỏ hơn hoặc bằng số người dùng hiện tại",
  PLZ_CHECK_THE_NUMBER_OF_USERS: "Vui lòng kiểm tra số lượng người dùng",
  SYSTEM_WILL_DIRECT_U_BACK_PLS_WAIT: "Hệ thống đang chuyển hướng, vui lòng chờ...",
  PURCHASE_FOR: "Mua cho",
  IF_U_GOT_PROMOTION_CODE: "Nếu bạn có mã khuyến mãi",
  CLICK_HERE: "Nhấp vào đây",
  IF_U_GOT_PROMOTION_CODE_INPUT_IT_HERE:
    "Nếu bạn có mã khuyến mãi, vui lòng nhập vào đây",
  CURRENT_USERS_ASSIGNED_TO_THIS_PACKAGE:
    "Người dùng hiện được gán cho gói này",
  PURCHASED_FOR: "Đã mua cho ",
  RENEW_SELECTED_PACKAGE: "Gia hạn gói đã chọn của bạn",
  EXTEND_PACKAGE_FOR_YOUR_CLINIC: "Gia hạn gói cho phòng khám của bạn",
  UPGRADE_PACKAGE_FOR_YOUR_CLINIC: "Nâng cấp gói cho phòng khám của bạn",
  RENEW_PACKAGE_FOR_YOUR_CLINIC: "Gia hạn gói cho phòng khám của bạn",
  EXTENDED_USER_PACK: "Gói người dùng (Sau khi gia hạn)",
  CURRENT_USER_PACK: "Gói người dùng (Hiện tại)",
  PAYMENT_UNAVAILABLE: "Thanh toán không khả dụng",
  PLS_OPEN_PAGE_OVER_HTTPS: "Vui lòng mở trang này qua HTTPS để thanh toán an toàn.",
  CREATE_UR_CLINIC_NOW: "Tạo phòng khám của bạn",
  NO_PACKAGE_SUBSCRIBED: "Chưa đăng ký gói nào",
  BELONGS_TO: "Thuộc về",
  TO_ACCESS_FULL_HEALTHNEX_SERVICES_PLEASE_SELECT_A_PACKAGE_FOR_UR_CLINIC:
    "Chọn một gói tính năng cho phòng khám của bạn để mở khóa quyền truy cập đầy đủ vào Healthnex.",
  RENEW_UR_CLINIC_PACKAGE: "Gia hạn gói phòng khám của bạn",
  PACKAGE_ASSIGNED_BY_CLINIC_OWNER: "Gói do chủ phòng khám của bạn gán",
  RENEW_UR_PERSONAL_PACKAGE: "Gia hạn gói cá nhân của bạn",
  FOR_PERSONAL: "Cho cá nhân",
  FOR_CLINIC: "Cho phòng khám",
  PURCHASE_FOR_MYSELF: "Mua cho chính tôi",
  PURCHASE_FOR_CLINIC: "Mua cho phòng khám",
  HEALTHNEX_IS_GOING_TO_CREATE_U_OWNED_CLINIC_PLS_PROVIDE_THE_ADDRESS:
    "Healthnex sắp tạo phòng khám của bạn. Vui lòng cung cấp địa chỉ phòng khám để tiếp tục.",
  CLINIC_ADDRESS: "Địa chỉ phòng khám",
  SORRY: "Xin lỗi",
  FIND_UR_SUITABLE_PACKAGES: "Tìm gói phù hợp cho bạn",
  ARE_U_LOOKING_TO_BUY_A_PERSONAL_PACKAGE_CLINIC_PACKAGE:
    "Bạn đang muốn mua gói cá nhân hay gói phòng khám?",
  I_WANNA_BUY: "Tôi muốn mua",
  PERSONAL_WEBSITE_FOR_MYSELF: "Trang web cá nhân cho chính tôi",
  CLINIC_PACKAGE_FOR_MY_CLINIC: "Dịch vụ phòng khám cho phòng khám của tôi",
  HOW_MANY_USERS_PACK_U_WISH_TO_INCLUDE_IN_YOUR_PACKAGE:
    "Bạn muốn bao gồm bao nhiêu người dùng trong gói của mình?",
  CLINIC_MEMBERS_WHO_CAN_ACCESS_APPOINTMENT_AND_PRESCRIPTION_USING_AI_AND_ALSO_INCLUDES_PERSONAL_WEBSITE:
    "Thành viên phòng khám có thể truy cập lịch hẹn và đơn thuốc bằng AI và cũng bao gồm trang web cá nhân",
  CLINIC_MEMBERS_WHO_CAN_ACCESS_APPOINTMENT_AND_PRESCRIPTION_USING_AI_AND_ALSO_WITHOUT_INCLUDES_PERSONAL_WEBSITE:
    "Thành viên phòng khám có thể truy cập lịch hẹn và đơn thuốc bằng AI nhưng không bao gồm trang web cá nhân",
  WITHOUT_PERSONAL_WEBSITE: "Không có trang web cá nhân",
  INCLUDES_PERSONAL_WEBSITE: "Bao gồm trang web cá nhân",
  ALL_CLINIC_PACKAGES: "Tất cả gói phòng khám",
  WHAT_FEATURES_U_WISH_TO_INCLUDE:
    "Bạn muốn bao gồm những tính năng nào trong gói phòng khám của mình?",
  INCLUDES_X_USERS: "Bao gồm {{X}} người dùng",
  CUSTOM_USER_PACKS: "Gói người dùng tùy chỉnh",
  THIS_PACKAGE_REQUIRES_TO_PURCHASE_AT_LEAST_X_USER_PACKS:
    "Gói này yêu cầu mua ít nhất {{X}} gói người dùng",
  SHORT_APPOINTMENT: "Lịch hẹn",
  SHORT_PRESCRIPTION: "Đơn thuốc",
  SHORT_PACKAGE: " Gói",
  WEB: "Web",
  X_YEARS: "{{X}} năm",
  ADDONS_SERVICE_INCLUDED: "Dịch vụ bổ sung tùy chọn",
  ADDON_SERVICE_SELECTED: "Dịch vụ bổ sung đã chọn",
  PER_MESSAGE: "Mỗi tin nhắn",
  ADD_ON_BILL_BASED_ON_UR_USAGE_CHARGE_WILL_BE_APPLIED_EVERY_X: "Dịch vụ bổ sung này được tính phí dựa trên mức sử dụng của bạn. Bạn có thể sử dụng dịch vụ trong mỗi chu kỳ thanh toán ({{X}}), và phí sẽ được áp dụng vào đầu chu kỳ tiếp theo dựa trên mức sử dụng của bạn ở kỳ trước",
  CONTINUE_USE_BILL_CHARGED_EVERY_X: "Bạn sẽ bị tính phí vào đầu mỗi chu kỳ ({{X}}) dựa trên mức sử dụng của bạn ở chu kỳ trước",
  WEEKLY: "Hằng tuần",
  FORTNIGHTLY: "Hai tuần một lần",
  MONTHLY: "Hằng tháng",
  QUARTERLY: "Hằng quý",
  BI_ANNUALLY: "Nửa năm một lần",
  ANNUALLY: "Hằng năm",
  ADDON_DETAIL: "Chi tiết dịch vụ bổ sung",
  NEXT_BILLING_DATE: "Thời gian thanh toán tiếp theo",
  BILLING_CYCLE: "Chu kỳ thanh toán",
  ADDON_PRICE: "Giá dịch vụ bổ sung",
  X_ADDONS_SERVICE_INCLUDED: "{{X}} dịch vụ bổ sung tùy chọn",
  SELECT_BILLING_METHOD: "Chọn phương thức thanh toán",
  BILLING_METHOD: "Phương thức thanh toán",
  TEMPORARILY_FREE: "Hiện đang miễn phí",
  FIRST_YEAR_FREE: "Năm đầu miễn phí",
  ON_PROMOTION: "Đang khuyến mãi",
  PROMOTION_END_DATE: "Khuyến mãi kết thúc",
  REGULAR_PRICE_RESUMES_ON_X: "Giá thông thường áp dụng lại vào {{X}}",
  SET_AS_DEFAULT: "Đặt làm mặc định",
  RECENTLY_USED: "Sử dụng gần đây",
  USE_DIFFERENT_CARD: "Dùng thẻ khác",
  PAY_WITH_SAVED_CARD: "Dùng thẻ đã lưu",
  CARD_HOLDER_NAME: "Tên chủ thẻ",
  ENABLE_AUTO_RECHARGE: "Bật tự động gia hạn",
  CANCEL_AUTO_RECHARGE: "Hủy tự động gia hạn",
  AUTO_RECHARGE_WHEN_SUBCRPTION_EXPIRED: "Tự động gia hạn bằng thẻ này khi đăng ký của bạn hết hạn",
  SAVE_BELOW_CARD_DETAILS: "Lưu thẻ này",
  STORE_CREDIT_CARD_SECURELY: "Thông tin thẻ của bạn sẽ được lưu trữ an toàn để thanh toán nhanh hơn vào lần sau",
  ADDON_REQUIRES_SAVED_CARD: "Bạn đã chọn một dịch vụ bổ sung yêu cầu thanh toán định kỳ. Vui lòng lưu thông tin thẻ để chúng tôi có thể tính phí tự động mỗi chu kỳ thanh toán.",
  DETECT_U_HAVE_A_SAVED_CARD_THIS_CARD_DETAIL_WILL_BE_SAVE_AND_REPLACE_THAT_CARD_DETAIL: "Chúng tôi đã tìm thấy một thẻ được lưu trong hồ sơ. Thẻ này sẽ thay thế nó sau khi thanh toán.",
  ARE_YOU_SURE_TO_CANCEL_AUTO_RECHARGE: "Bạn có chắc chắn muốn hủy tự động gia hạn không?",
  U_CAN_ENABLE_AUTO_RECHARGE_LATER: "Bạn có thể bật tự động gia hạn sau",
  AUTO_RECHARGE_HAS_BEEN_ENABLED: "Đã bật tự động gia hạn",
  AUTO_RECHARGE_HAS_BEEN_CANCELLED: "Đã hủy tự động gia hạn",
  AUTO_RECHARGE: "Tự động gia hạn",
  HAS_ENABLED: "Đã bật",
  NOT_ENABLED: "Chưa bật",
};

const cmasaImport = {
  IMPORT_CLINICS: "Nhập phòng khám",
  CLINICS_FOUND_IN_X: "Phòng khám tìm thấy trong {{X}}",
  NO_CLINIC_FOUND: "Không tìm thấy phòng khám",
  CLINICS_IMPORTED_FROM_X: "Phòng khám đã nhập từ {{X}}",
  NO_CLINIC_IMPORTED: "Chưa nhập phòng khám nào",
  DELETE: "Xóa",
  CONFIRM: "Xác nhận",
  ARE_YOU_SURE_TO_DELETE_X: "Bạn có chắc chắn muốn xóa {{X}} không?",
  THIS_ACTION_CANNOT_BE_UNDONE: "Hành động này không thể hoàn tác",
  IMPORT_CLINIC: "Nhập phòng khám",
  UPDATE_CLINIC: "Cập nhật phòng khám",
  UPLOAD_AVATAR: "Tải lên ảnh đại diện",
  REUPLOAD_PROFILE_IMAGE: "Tải lên lại ảnh hồ sơ",
  CLICK_TO_UPLOAD: "Nhấp để tải lên",
  PLEASE_FILL_ALL_REQUIRED_FIELDS: "Vui lòng điền tất cả các trường bắt buộc",
  PLEASE_ENTER_VALID_EMAIL: "Vui lòng nhập địa chỉ email hợp lệ",
  PLEASE_ENTER_SAME_PASSWORD: "Vui lòng nhập cùng một mật khẩu",
  SIGN_UP_SUCCESS: "Đăng ký thành công",
  CLINIC_EXISTS: "Phòng khám này đã tồn tại",
  NEXT_STEP: "Bước tiếp theo",
  SAME_WITH_ORG_PASSWORD: "Giống mật khẩu gốc",
  PROFILE_IMG: "Ảnh hồ sơ",
  I_CHANGED_MY_MIND: "Tôi đã đổi ý",
  ADDING: "Đang chờ tạo",
  JOINING: "Đang chờ tham gia",
  OR: "hoặc",
  SKIP: "Bỏ qua",
  GUIDED_SAVE_AND_SKIP_OPTIONAL: "Lưu và bỏ qua mục không bắt buộc",
  JOIN: "Tham gia",
  SAVE_CONFIRM: "Xác nhận lưu",
  ARE_YOU_SURE_TO_SUBMIT_YOUR_CLINIC_INFO:
    "Bạn có chắc chắn muốn gửi thông tin phòng khám và đồng ý tạo phòng khám không?",
  FOUND_RELEVANT_CLINICS:
    "Chúng tôi đã tìm thấy một số phòng khám trong hệ thống Healthnex có thể liên quan đến phòng khám này.",

  JOIN_OR_SKIP_CLINIC_GUIDE:
    "Bạn có thể nhấp Tham gia để yêu cầu tham gia một trong số chúng. Nếu bạn không chắc chắn hoặc không thấy phòng khám phù hợp, bạn có thể nhấp Bỏ qua và xử lý việc này sau.",
  NEED_TO_ADD_CLINIC: "Bạn có cần thêm phòng khám này vào hệ thống Healthnex của chúng tôi không?",
  ADD_CLINIC_DESCRIPTION:
    "Nhấp Thêm để tiếp tục. Bạn sẽ trở thành chủ sở hữu phòng khám, có khả năng mời hoặc gỡ bỏ thành viên. Bạn cũng có thể chuyển quyền sở hữu cho thành viên phòng khám khác sau này. Nếu bạn không chắc chắn hoặc chưa cần thêm bây giờ, hãy nhấp Bỏ qua và quay lại sau.",
  CLINIC_RESULT_TITLE: "Kết quả cho phòng khám này",
  CLINIC_SKIPPED_MSG:
    "Phòng khám này đã được bỏ qua. Bạn sẽ không tham gia phòng khám hiện có cũng như không thêm nó làm phòng khám mới.",
  CLINIC_NOT_LISTED: "Phòng khám tôi muốn tham gia không có trong danh sách trên.",
  I_DO_NOT_WANT_TO_USE_THE_CLINIC_INFO_ABOVE:
    "Tôi không muốn sử dụng thông tin phòng khám ở trên",
  PREVIOUS_CLINIC: "Phòng khám trước",
  NEXT_CLINIC: "Phòng khám tiếp theo",
  ARE_YOU_SURE_TO_CHANGE_YOUR_MIND:
    "Bạn có chắc chắn muốn đổi ý không? Việc này sẽ đặt lại thiết lập bạn đã thực hiện cho phòng khám này.",
};
const camera = {
  FOR_PATIENT: "Cho bệnh nhân {{name}}",
  UPLOAD_PHOTO_LABEL: "Tải lên",
  TAKE_PHOTO: "Chụp ảnh",
  OR_CHOOSE_FROM_ALBUM: "Hoặc chọn từ album",
  CHOOSE_PHOTO: "Chọn ảnh",
  PREVIEW: "Xem trước",

  DISCONNECTED_TITLE: "Mất kết nối / Liên kết đã hết hạn",
  DISCONNECTED_BODY:
    "Liên kết tải ảnh này đã hết hạn hoặc đã bị đóng. Vui lòng tạo mã QR hoặc liên kết mới.",
  CLICK_AND_UPLOAD_WITH_YOUR_PHONE: "Nhấp và tải lên bằng điện thoại của bạn",
  CLICK_AND_RECORD_WITH_YOUR_PHONE:
    "Nhấp và kết nối với điện thoại của bạn để ghi hình",
  CLICK_AND_USE_YOUR_PHONE: "Nhấp và dùng điện thoại của bạn để ghi hình",
  SCAN_TO_CONNECT: "",
  CAMERA_TOKEN_EXPIRED: "Mã thông báo máy ảnh đã hết hạn",
  IF_YOU_ALREADY_CONNECTED_WITH_YOUR_PHONE:
    "Quét mã QR để kết nối. Sau khi kết nối, điện thoại của bạn sẽ duy trì kết nối giữa các trang.",
};

const Library = {
  MEDICAL_PUBLICATIONS: "Ấn phẩm y khoa",
  SEARCH_MEDICAL_PUBLICATIONS: "Tìm ấn phẩm y khoa",
  SEARCH_PUBLICATION_BY_NAME: "Tìm ấn phẩm theo tên",
  RECENT: "Gần đây",
  LIBRARY: "Thư viện",
  NO_PUBLICATIONS_FOUND: "Không tìm thấy ấn phẩm",
  NO_RECENT_PUBLICATIONS: "Không có ấn phẩm gần đây",
  NO_PUBLICATIONS_IN_LIBRARY: "Không có ấn phẩm trong thư viện",
  SEARCH_FOR_THE_MEDICAL_PUBLICATIONS_IN_SEARCH_BAR_OR_VISIT_OUR_LIBRARY:
    "Tìm ấn phẩm y khoa trong thanh tìm kiếm hoặc truy cập thư viện của chúng tôi",
  JUST_NOW: "Vừa xong",
  RECENT_X_MINUTES: "{{x}} phút trước",
  RECENT_X_HOURS: "{{x}} giờ trước",
  RECENT_X_DAYS: "{{x}} ngày trước",
  ADD_THIS_BOOK_TO_YOUR_FAVORITES: "Thêm sách này vào mục yêu thích của bạn",
  CHAPTERS: "Chương",
  BOOKMARK: "Đánh dấu",
  ADD_BOOKMARK: "Thêm đánh dấu",
  FULL_SCREEN: "Toàn màn hình",
  TEXT_SIZE: "Cỡ chữ",
  NEXT_PAGE: "Trang tiếp",
  PREVIOUS_PAGE: "Trang trước",
  FONT_SIZE: "Cỡ phông",
  SMALL: "Nhỏ",
  MEDIUM: "Vừa",
  LARGE: "Lớn",
  BOOKS_MANAGEMENT: "Quản lý sách",
  SAVE_BOOK: "Sách đã lưu",
  READER: "Trình đọc",
  REGULAR: "Thường",
  SEARCH_FOR_PUBLICATIONS: "Tìm theo tiêu đề hoặc tác giả",
  ERROR_BOOKINGS: "Lịch hẹn lỗi",
  TIP: "Mẹo",
  ERROR_BOOKINGS_USUALLY_BECUZ_THE_WORKING_DURATION_HAS_CHANGED_OVER_TIME_AFTER_THE_APPOINTMENT_HAS_BEEN_CREATED_EARLIER:
    "Lịch hẹn không hợp lệ thường do thay đổi giờ làm việc trước khi lịch hẹn được tạo. Bạn vẫn có thể tiến hành tư vấn hoặc đặt lại thời gian mới cho bệnh nhân.",
};

const bookingPage = {
  BOOK_DOCTOR: "Đặt lịch khám",
  BOOKING_A_DOCTOR: "Đang đặt lịch khám",
  SEARCH_BY_PRACTITIONER_NAME_SERVICE_TYPE_OR_SUBURB:
    "Tìm theo tên chuyên viên, loại dịch vụ, hoặc mã bưu chính khu vực",
  BY: "Bởi ",
  SERVICE_TYPE: "Loại dịch vụ",
  PLEASE_SELECT_SERVICE_TYPE: "Vui lòng chọn ít nhất một loại dịch vụ",
  SEARCH_BY_PRACTITIONER_NAME: "Tìm theo tên chuyên viên",
  SEARCHING_PRACTITIONERS: "Đang tìm chuyên viên",
  NO_SERVICE_LISTED: "Không có dịch vụ được liệt kê",
  BOOK: "Đặt lịch",
  WEBSITE: "Trang web",
  PUBLISH_WEBSITE: "Xuất bản trang web",
  JOIN: "Tham gia",
  AND_X_PRACTITIONERS_MORE: "và {{X}} chuyên viên khác...",
  MEDICINE_TREATMENT: "Điều trị bằng Đông y",
  ACUPUNCTURE_TREATMENT: "Điều trị châm cứu",
  MASSAGE_TREATMENT: "Điều trị xoa bóp",
  REMEDIAL_MASSAGE_TREATMENT: "Điều trị xoa bóp trị liệu",
  NO_RELEVANT_PRACTITIONERS_FOUND: "Không tìm thấy chuyên viên phù hợp",
  NO_SERVICES_LISTED: "Không có dịch vụ được liệt kê",
  BOOK_THIS_PRACTITIONER: "Đặt lịch với chuyên viên này",
  THIS_PRACTITIONER_HAS_NOT_REGISTERED_YET:
    "Chuyên viên này chưa đăng ký",
  PUBLISH_PRACTITIONER_PROFILE_WEBSITE: "Xuất bản trang web hồ sơ chuyên viên",
  VIEW_PRACTITIONER_PROFILE_WEBSITE: "Xem trang web hồ sơ chuyên viên",
  NO_WORKING_CLINIC: "Không có phòng khám nơi bạn làm việc",
  AND_X_MORE_CLINIC: "và {{X}} phòng khám khác",
  CHOOSE_CLINIC: "Chọn phòng khám",
  CHOOSE_CLINIC_DESCRIPTION: "Vui lòng chọn phòng khám bạn muốn đến khám",
  CHOOSE_SERVICE: "Chọn dịch vụ",
  CHOOSE_SERVICE_DESCRIPTION:
    "Chọn các dịch vụ bạn muốn đặt lịch hẹn",
  PICK_APPOINTMENT_DATE: "Chọn ngày hẹn",
  PICK_APPOINTMENT_DATE_DESCRIPTION: "Chọn ngày/giờ hẹn của bạn",
  MORNING: "Buổi sáng",
  AFTERNOON: "Buổi chiều",
  PATIENT_INFO_DESCRIPTION: "Vui lòng điền thông tin bệnh nhân",
  CONFIRM_DESCRIPTION: "Vui lòng xác nhận chi tiết lịch hẹn",
  SUBMIT_APPOINTMENT: "Gửi lịch hẹn",
  PREV: "Trước",
  YOUR_APPOINTMENT_BOOKED_SUCCESSFULLY:
    "Lịch hẹn của bạn đã được tạo thành công",
  CREATE_BOOKING: "Tạo lịch hẹn",
  TOMORROW: "Ngày mai",
  TODAY: "Hôm nay",
  IS_ALREADY_BOOKED: "đã được người khác đặt",
  TIME_ALREADY_BOOKED: "Thời gian đã được đặt",
  YOU_NEED_TO_WAIT_FOR_THE_PRACTITIONER_TO_CONFIRM:
    "Lịch hẹn này gây trùng lịch, nhưng vì được chính bạn (chuyên viên) tạo, nó sẽ được hệ thống tự động phê duyệt.",
  ARE_YOU_SURE_YOU_WANT_TO_BOOK_THIS_TIME:
    "Bạn có chắc chắn muốn đặt thời gian này không?",
  BACK_TO_HOME: "Đóng trang",
  INVITATION_LINK_EXPIRED: "Liên kết lời mời đã hết hạn",
  INVITATION_LINK_EXPIRED_DESC: "Liên kết lời mời này không còn hợp lệ. Vui lòng yêu cầu chủ phòng khám gửi cho bạn một lời mời mới.",
  EXISTING_PATIENT: "Bệnh nhân hiện có",
  START_WITH_NEW_PATIENT: "Bắt đầu với bệnh nhân mới",
  BACK_TO_EXISTING_PATIENT: "Quay lại bệnh nhân hiện có",
  NEW_PATIENT: "Bệnh nhân mới",
  ARE_U_LOOKING_FOR: "👀 Bạn có đang tìm",
  SELECTED_PATIENT: "Bệnh nhân đã chọn",
  ALL_GOOD: "Tất cả ổn",
  PLS_REFER_TO_THE_APPOINTMENT_DETAIL_BELOW:
    "Vui lòng tham khảo chi tiết lịch hẹn được cung cấp bên dưới.",
  VIEW_DETAIL: "Xem chi tiết",
  SELECTED_FROM_OUTSIDE_TIMESLOT: "Đã chọn từ thời khóa biểu",
  BOOK_TIMESLOT: "Đặt khung giờ này",
  INVALID_DOB: "Ngày sinh không hợp lệ",
  AGREED_TO_SEND_APPOINTMENT_SMS_TO_PATIENT:
    "Tôi đồng ý gửi SMS / Email lịch hẹn để thông báo cho bệnh nhân",
  CONFIGURE_UR_PROVIDED_SERVICES: "Cấu hình các dịch vụ bạn cung cấp",
  NOT_AVAILABLE_FOR_BOOKING: "Không khả dụng để đặt lịch",
  BOOKED_ENABLED_ONLY: "Chỉ những mục đã bật đặt lịch",
  PLEASE_SELECT_EXISTING_PATIENT:
    "Vui lòng chọn một bệnh nhân hiện có để tiến hành đặt lịch",
  THIS_FEATURE_REQUIRED_PRESCRIPTION_PACKAGE:
    "Xin lỗi, tính năng Hồ sơ bệnh nhân không khả dụng trong gói hiện tại của bạn.",
  PLEASE_CONSIDER_UPGRADE_YOUR_PACKAGE_OR_CONTINUE_WITH_NEW_PATIENT:
    "Nếu bạn cần truy cập tính năng này, vui lòng liên hệ chủ phòng khám để nâng cấp gói, hoặc tiếp tục đặt lịch cho bệnh nhân mới.",
  U_SELECTED_A_PAST_TIMESLOT: "Đã chọn khung giờ trong quá khứ",
  U_SELECTED_A_PAST_TIMESLOT_NO_SMS_WILL_BE_SENT:
    "Bạn đã chọn một khung giờ trong quá khứ. Sẽ không có SMS thông báo nào được gửi.",
  ANY_RECOMMENDED_PATIENTS_FROM_EXISTING_WILL_BE_SHOWN_HERE:
    "Các bệnh nhân được đề xuất dựa trên những bệnh nhân bạn đã lưu trong hệ thống sẽ hiển thị tại đây.",
  PICK_APPOINTMENT_PRACTITIONER: "Chọn chuyên viên cho",
  PICK_APPOINTMENT_PRACTITIONER_END: "",
  PICK_APPOINTMENT_PRACTITIONER_SINGLE_PATIENT: "Chọn chuyên viên",
  RESELECT_APPOINTMENT_DATE: "Chọn lại ngày hẹn",
  RESELECT_PRACTITIONER: "Chọn lại chuyên viên",
  AVAILABLE_PRACTITIONERS: "Chuyên viên khả dụng",
  DESELECT_CHINESE_MEDICINE_FIRST: "Vui lòng bỏ chọn Đông y trước.",
  DESELECT_PRODUCTS_FIRST: "Vui lòng bỏ chọn các sản phẩm đã chọn trước.",
  NUMBER_OF_PEOPLE: "Số người",
  PERSON: "người",
  PEOPLE: "người",
  ENTER_PATIENT_INFORMATION: "Nhập thông tin bệnh nhân",
  IS_THIS_PERSON_NEW_PATIENT: "Đây có phải lần đầu đến phòng khám này không?",
  A_REMINDER_SMS_WILL_BE_SENT_TO_THE_U_WHEN_NEAR_THE_APPOINTMENT_DATE:
    "Mẹo: Khi gần đến giờ hẹn, một tin nhắn SMS nhắc nhở sẽ được gửi đến bạn",
  NO_AVAILABLE_PRACTITIONERS: "Không tìm thấy chuyên viên khả dụng trong ngày này",
  ORR: "HOẶC",
  CONFIRM_APPOINTMENT_DESCRIPTION:
    "Vui lòng xem lại chi tiết lịch hẹn trước khi xác nhận đặt lịch.",
  PICK_APPOINTMENT_TIME: "Chọn giờ hẹn",
  PRODUCTS: "Sản phẩm dịch vụ",
  I_AM_A_NEW_PATIENT: "Tôi là bệnh nhân mới",
  SEARCH_EXISTING_PATIENT: "Tìm bệnh nhân hiện có",
  DESELECT_ALL: "Bỏ chọn",
  SERVICES_ITEM: "Hạng mục dịch vụ",
  X_BED_NUM: "{{X}} giường",
  NEW_TO_THIS_CLINIC: "Đây là lần đầu tôi đến phòng khám này",
  A_REMINDER_EMAIL_WILL_BE_SENT_TO_THE_PATIENT: "Một email xác nhận sẽ được gửi đến bệnh nhân",
};

const guide = {
  WE_FIRST_GO_TO_CLINIC_MANAGEMENT_PAGE:
    "Trước tiên chúng ta đến trang Quản lý thành viên phòng khám",
  CLICK_ON_THIS: "Nhấp vào nút này",
  CREATE_A_NEW_CLINIC_BY_COMPLETE_THE_ESSENTIAL_INFORMATION:
    "Hoàn thành thông tin thiết yếu của phòng khám",
  SUBMIT_YOUR_CLINIC_INFORMATION:
    "Gửi thông tin phòng khám của bạn, sau đó phòng khám sẽ được tạo",
  IF_U_RECEIVE_CLINIC_INVITATION: "Nếu bạn nhận được lời mời phòng khám",
  ANY_INVITATION_WILL_BE_SHOWN_HERE_U_CAN_ACCEPT_OR_REJECT_THE_INVITATION:
    "Bất kỳ lời mời phòng khám nào cũng sẽ hiển thị tại đây, bạn có thể quyết định chấp nhận hoặc từ chối lời mời",
  IF_U_WISH_TO_JOIN_A_CLINIC: "Nếu bạn muốn tham gia một phòng khám",
  SEARCH_THE_CLINIC_NAME_U_WISH_TO_JOIN:
    "Tìm tên phòng khám bạn muốn tham gia",
  DONE: "Hoàn tất",
  START_GUIDE: "Bắt đầu hướng dẫn",
  USER_GUIDE: "Hướng dẫn video",
  GUIDE: "Hướng dẫn",
  NEED_HELP: "Cần trợ giúp?",
  CONTACT_SUPPORT: "Liên hệ hỗ trợ",
  VIEW_USER_GUIDE: "Xem hướng dẫn video",
  CLINIC_MANAGEMENT_GUIDE: "Hướng dẫn quản lý phòng khám",
  CLINIC_MANAGEMENT_DESCRIPTION:
    "Hướng dẫn này sẽ chỉ cho bạn cách và nơi để tạo và tham gia phòng khám.",
  PRESCRIPTION_MEDICAL_HISTORY_GUIDE: "Hướng dẫn đơn thuốc & hồ sơ bệnh án",
  PRESCRIPTION_MEDICAL_HISTORY_GUIDE_DESCRIPTION:
    "Hướng dẫn này sẽ chỉ cho bạn cách và nơi để tạo bệnh nhân và đơn thuốc.",
  APPOINTMENT_GUIDE: "Hướng dẫn lịch hẹn",
  MANAGE_UR_APPOINTMENTS_GUIDE_DESCRIPTION:
    "Hướng dẫn này sẽ chỉ cho bạn cách và nơi để lên lịch thời gian làm việc và đặt lịch hẹn.",
  MORE_GUIDES_ON_THE_WAY: "Sắp có thêm hướng dẫn",
};

const patientConsent = {
  PATIENT_CONSENT: "Phiếu đồng ý của bệnh nhân",
  CONSENT_TITLE_1: "Điều trị",
  CONSENT_DESCRIPTION_1: "Tôi hiểu rằng việc điều trị tại {{X}} có thể bao gồm:",
  CONSENT_ITEM_1: "Châm cứu sử dụng kim vô trùng, dùng một lần ",
  CONSENT_ITEM_2: "Cứu ngải, giác hơi hoặc cạo gió ",
  CONSENT_ITEM_3:
    "Thuốc thảo dược Đông y (thuốc sắc, thuốc bột, thuốc viên hoặc thuốc cốm) ",
  CONSENT_ITEM_4:
    "Lời khuyên về lối sống và chế độ ăn uống dựa trên nguyên lý Đông y ",
  CONSENT_TITLE_2: "Rủi ro và Tác dụng phụ ",
  CONSENT_DESCRIPTION_2:
    "Tôi hiểu rằng mặc dù mọi sự chăm sóc hợp lý đều được thực hiện, một số tác dụng phụ nhẹ có thể xảy ra, bao gồm: ",
  CONSENT_ITEM_5: "Bầm tím nhẹ, chảy máu hoặc đau nhức sau khi châm kim ",
  CONSENT_ITEM_6: "Chóng mặt hoặc mệt mỏi tạm thời ",
  CONSENT_ITEM_7:
    "Thay đổi tiêu hóa nhẹ hoặc phản ứng dị ứng từ thuốc thảo dược ",
  CONSENT_ITEM_8: "Đỏ da hoặc vết tạm thời do giác hơi hoặc cạo gió ",
  CONSENT_ITEM_9: "Phản ứng bất lợi nghiêm trọng rất hiếm. ",
  CONSENT_TITLE_3: "Khai báo và An toàn ",
  CONSENT_DESCRIPTION_3: "Tôi đã thông báo cho chuyên viên điều trị của mình về: ",
  CONSENT_ITEM_10: "Bất kỳ tình trạng bệnh lý hoặc dị ứng hiện tại nào ",
  CONSENT_ITEM_11: "Tình trạng mang thai (nếu có) ",
  CONSENT_ITEM_12: "Bất kỳ loại thuốc hoặc thực phẩm bổ sung nào tôi đang sử dụng ",
  CONSENT_DESCRIPTION_4:
    "Tôi hiểu rằng điều trị bằng Đông y không thay thế cho chăm sóc y tế khẩn cấp. ",
  CONSENT_DESCRIPTION_5:
    "Thông tin cá nhân và sức khỏe của tôi sẽ được xử lý theo luật bảo mật của Úc.",
  CONSENT_TITLE_4: "Đồng ý và Xác nhận",
  CONSENT_ITEM_13:
    "Tôi đã đọc và hiểu thông tin trên. Tôi đã có cơ hội đặt câu hỏi và tất cả đã được trả lời thỏa đáng. ",
  CONSENT_ITEM_14:
    "Tôi tự nguyện đồng ý nhận điều trị Đông y và/hoặc châm cứu từ các chuyên viên tại {{X}}.",
  DRAW_YOUR_SIGNATURE: "Vẽ chữ ký của bạn",
  SIGNATURE_UPLOADED: "Đã tải lên chữ ký",
  CONSENT_SIGN_SUCCESS:
    "Bạn đã ký phiếu đồng ý điều trị thành công. Vui lòng tiếp tục quá trình tư vấn của bạn!",
};

const agreements = {
  PRIVACY_POLICY_TITLE: "CHÍNH SÁCH QUYỀN RIÊNG TƯ HEALTHNEX",
  PRIVACY_POLICY_EFFECTIVE_DATE:
    "Ngày hiệu lực: Chính sách quyền riêng tư này có hiệu lực kể từ ngày Người dùng lần đầu đăng ký và sử dụng Nền tảng Healthnex.",
  PRIVACY_POLICY_SECTION_OVERVIEW_TITLE: "1. Tổng quan",
  PRIVACY_POLICY_SECTION_OVERVIEW_CONTENT:
    "Healthnex coi trọng và cam kết bảo vệ quyền riêng tư của Người dùng và bệnh nhân của họ. Chính sách quyền riêng tư này giải thích cách chúng tôi thu thập, sử dụng, lưu trữ và tiết lộ thông tin cá nhân và thông tin sức khỏe theo Đạo luật Quyền riêng tư 1988 (Cth) và các Nguyên tắc Quyền riêng tư của Úc (APPs).",
  PRIVACY_POLICY_SECTION_COLLECT_TITLE: "2. Thông tin chúng tôi thu thập",
  PRIVACY_POLICY_COLLECT_USER_INFO:
    "Thông tin Người dùng: tên, thông tin liên hệ, thông tin đăng ký nghề nghiệp, thông tin phòng khám và thông tin đăng nhập tài khoản;",
  PRIVACY_POLICY_COLLECT_PATIENT_INFO:
    "Thông tin Bệnh nhân: hồ sơ bệnh án, thông tin lịch hẹn, thông tin đơn thuốc và các thông tin sức khỏe khác;",
  PRIVACY_POLICY_COLLECT_TECH_INFO:
    "Thông tin Kỹ thuật: địa chỉ IP, thông tin thiết bị và nhật ký hệ thống.",
  PRIVACY_POLICY_SECTION_USAGE_TITLE: "3. Mục đích thu thập",
  PRIVACY_POLICY_USAGE_PLATFORM:
    "Cung cấp và duy trì Nền tảng Healthnex;",
  PRIVACY_POLICY_USAGE_ACCOUNT: "Quản lý tài khoản người dùng và hoạt động của phòng khám;",
  PRIVACY_POLICY_USAGE_SECURITY:
    "Hỗ trợ kỹ thuật, bảo mật hệ thống và tuân thủ;",
  PRIVACY_POLICY_USAGE_LEGAL:
    "Các mục đích khác theo yêu cầu của luật pháp và quy định hiện hành.",
  PRIVACY_POLICY_SECTION_HEALTH_INFO_TITLE: "4. Thông tin sức khỏe",
  PRIVACY_POLICY_HEALTH_INFO_DESCRIPTION:
    "Thông tin sức khỏe được phân loại là thông tin nhạy cảm. Healthnex chỉ hoạt động với tư cách là đơn vị xử lý dữ liệu và xử lý thông tin sức khỏe của bệnh nhân chỉ theo chỉ dẫn của Người dùng, người hoạt động với tư cách là đơn vị kiểm soát dữ liệu.",
  PRIVACY_POLICY_SECTION_DISCLOSURE_TITLE: "5. Tiết lộ thông tin",
  PRIVACY_POLICY_DISCLOSURE_DESCRIPTION:
    "Chúng tôi không tiết lộ thông tin cá nhân hoặc sức khỏe cho bên thứ ba trừ khi luật pháp yêu cầu hoặc được Người dùng cho phép. Một số dịch vụ kỹ thuật (như dịch vụ đám mây và dịch vụ email) có thể liên quan đến việc xử lý của bên thứ ba được kiểm soát.",
  PRIVACY_POLICY_SECTION_SECURITY_TITLE: "6. Bảo mật dữ liệu",
  PRIVACY_POLICY_SECURITY_DESCRIPTION:
    "Chúng tôi áp dụng các biện pháp kỹ thuật và tổ chức hợp lý để bảo vệ an ninh thông tin, bao gồm kiểm soát truy cập, mã hóa và cơ chế kiểm toán.",
  PRIVACY_POLICY_SECTION_RETENTION_TITLE: "7. Lưu giữ dữ liệu",
  PRIVACY_POLICY_RETENTION_DESCRIPTION:
    "Thông tin sẽ được lưu giữ hoặc xóa theo các yêu cầu pháp lý và nhu cầu kinh doanh.",
  PRIVACY_POLICY_SECTION_RIGHTS_TITLE: "8. Quyền của Người dùng",
  PRIVACY_POLICY_RIGHTS_DESCRIPTION:
    "Người dùng có quyền yêu cầu truy cập, chỉnh sửa hoặc xóa thông tin cá nhân của mình, tùy theo các giới hạn pháp lý.",
  PRIVACY_POLICY_SECTION_BREACH_TITLE: "9. Vi phạm dữ liệu",
  PRIVACY_POLICY_BREACH_DESCRIPTION:
    "Trong trường hợp vi phạm dữ liệu phải báo cáo, chúng tôi sẽ tuân thủ chương trình Vi phạm Dữ liệu Phải Báo cáo của Úc (NDB).",
  PRIVACY_POLICY_SECTION_CONTACT_TITLE: "10. Liên hệ với chúng tôi",
  PRIVACY_POLICY_CONTACT_DESCRIPTION:
    "Đối với các thắc mắc liên quan đến quyền riêng tư, vui lòng liên hệ Healthnex qua các kênh hỗ trợ chính thức.",
  IF_ANY_SENSITIVE_RELATED_QUESTION_PLS_CONTACT_HEALTHNEX:
    "Đối với các thắc mắc liên quan đến quyền riêng tư, vui lòng liên hệ Healthnex qua các kênh hỗ trợ chính thức.",

  DATA_PROCESSING_ADDENDUM: "Phụ lục Xử lý Dữ liệu",
  DPA_TITLE: "PHỤ LỤC XỬ LÝ DỮ LIỆU HEALTHNEX",
  DPA_SUB_TITLE: "(Phụ lục Xử lý Dữ liệu, DPA)",
  DPA_INTRO:
    "Phụ lục Xử lý Dữ liệu này là một phần của Điều khoản Sử dụng Nền tảng Healthnex.",
  DPA_SECTION_ROLES_TITLE: "1. Vai trò",
  DPA_ROLE_USER: "Người dùng: Đơn vị Kiểm soát Dữ liệu",
  DPA_ROLE_HEALTHNEX: "Healthnex: Đơn vị Xử lý Dữ liệu",
  DPA_SECTION_SCOPE_TITLE: "2. Phạm vi xử lý",
  DPA_SCOPE_DESCRIPTION:
    "Healthnex xử lý thông tin cá nhân và thông tin sức khỏe chỉ trong phạm vi cần thiết để cung cấp các dịch vụ Nền tảng và tuân thủ nghiêm ngặt theo chỉ dẫn của Người dùng.",
  DPA_SECTION_DATA_TYPE_TITLE: "3. Loại dữ liệu",
  DPA_DATA_TYPE_DESCRIPTION: "Dữ liệu được xử lý bao gồm, nhưng không giới hạn ở:",
  DPA_DATA_TYPE_PATIENT_INFO: "Thông tin sức khỏe của bệnh nhân;",
  DPA_DATA_TYPE_APPOINTMENT_RECORD: "Dữ liệu lịch hẹn và hồ sơ bệnh án;",
  DPA_DATA_TYPE_USER_ACCOUNT: "Dữ liệu tài khoản người dùng.",
  DPA_SECTION_SECURITY_TITLE: "4. Bảo mật dữ liệu",
  DPA_SECURITY_DESCRIPTION:
    "Healthnex sẽ áp dụng các biện pháp bảo mật kỹ thuật và tổ chức hợp lý để bảo vệ dữ liệu khỏi việc truy cập, tiết lộ hoặc mất mát trái phép.",
  DPA_SECTION_SUBPROCESSORS_TITLE: "5. Xử lý phụ",
  DPA_SUBPROCESSORS_DESCRIPTION:
    "Healthnex có thể sử dụng các nhà cung cấp dịch vụ bên thứ ba đáng tin cậy (như hạ tầng đám mây hoặc nhà cung cấp dịch vụ AI). Tất cả các đơn vị xử lý phụ đều phải tuân thủ các nghĩa vụ về bảo mật và bảo vệ dữ liệu.",
  DPA_SECTION_BREACH_RESPONSE_TITLE: "6. Ứng phó vi phạm dữ liệu",
  DPA_BREACH_RESPONSE_DESCRIPTION:
    "Trong trường hợp vi phạm dữ liệu, Healthnex sẽ thông báo cho Người dùng trong khoảng thời gian hợp lý và hợp tác để thực hiện các nghĩa vụ pháp lý hiện hành.",
  DPA_SECTION_POST_TERMINATION_TITLE: "7. Xử lý dữ liệu sau khi chấm dứt",
  DPA_POST_TERMINATION_DESCRIPTION:
    "Khi chấm dứt thỏa thuận, Healthnex sẽ xóa hoặc ẩn danh dữ liệu liên quan theo chỉ dẫn của Người dùng và các yêu cầu pháp lý hiện hành, trừ khi việc lưu giữ là bắt buộc theo luật.",
  DPA_SECTION_PRECEDENCE_TITLE: "8. Thứ tự ưu tiên",
  DPA_PRECEDENCE_DESCRIPTION:
    "Trong trường hợp có bất kỳ sự không thống nhất nào giữa Phụ lục này và thỏa thuận chính, Phụ lục này sẽ được ưu tiên áp dụng đối với các vấn đề bảo vệ dữ liệu.",
};

const freeTrialTerms = {
  FREE_TRIAL_TERMS_PAGE_TITLE: "Điều khoản",
  FREE_TRIAL_TERMS_TITLE:
    "ĐIỀU KHOẢN SỬ DỤNG DÙNG THỬ MIỄN PHÍ BA (3) THÁNG NỀN TẢNG HEALTHNEX\n(BAO GỒM ĐIỀU KHOẢN QUYỀN RIÊNG TƯ VÀ XỬ LÝ DỮ LIỆU)\n",
  FREE_TRIAL_TERMS_SUBTITLE:
    "Các Điều khoản này điều chỉnh việc bạn truy cập và sử dụng Nền tảng Healthnex trong thời gian dùng thử miễn phí ba tháng.",
  FREE_TRIAL_TERMS_EFFECTIVE_DATE:
    "Ngày hiệu lực: Ngày Người dùng lần đầu đăng ký và truy cập Nền tảng Healthnex.",
  FREE_TRIAL_TERMS_PARTIES:
    "Thỏa thuận này (“Thỏa thuận”) được ký kết giữa: Healthnex (“Healthnex”, “chúng tôi”, hoặc “Nền tảng”); và bất kỳ cá nhân hoặc tổ chức nào đăng ký hoặc sử dụng Nền tảng Healthnex, bao gồm nhưng không giới hạn ở chủ phòng khám, người vận hành phòng khám, người hành nghề y tế, hoặc các cá nhân hoạt động với nhiều vai trò (“Người dùng”, “bạn”).",

  FREE_TRIAL_TERMS_PURPOSE_TITLE: "1.	Mục đích của Thỏa thuận",
  FREE_TRIAL_TERMS_PURPOSE_DESC:
    "Thỏa thuận này quy định các điều khoản theo đó Healthnex cung cấp cho Người dùng quyền truy cập Nền tảng trong thời gian dùng thử miễn phí ba (3) tháng và làm rõ các sắp xếp sau khi kết thúc thời gian dùng thử.",

  FREE_TRIAL_TERMS_USER_DEF_TITLE: "2. Định nghĩa Người dùng",
  FREE_TRIAL_TERMS_USER_DEF_DESC:
    "Người dùng có thể truy cập và sử dụng Nền tảng Healthnex với một hoặc nhiều vai trò sau đây, bao gồm nhưng không giới hạn ở:",
  FREE_TRIAL_TERMS_USER_DEF_ITEM_1: "• Chủ phòng khám / Quản trị viên",
  FREE_TRIAL_TERMS_USER_DEF_ITEM_2: "• 1) Chủ hoặc người vận hành phòng khám ",
  FREE_TRIAL_TERMS_USER_DEF_ITEM_3: "• 2) Quản trị viên phòng khám ",
  FREE_TRIAL_TERMS_USER_DEF_MULTI_CAPACITY:
    "3) Người hành nghề y tế hoặc chuyên gia chăm sóc sức khỏe ",
  FREE_TRIAL_TERMS_USER_ACCOUNT_RESP:
    "Khi Người dùng hoạt động với nhiều vai trò, tất cả các nghĩa vụ và trách nhiệm theo Thỏa thuận này được áp dụng tích lũy.\nNgười dùng chịu trách nhiệm cho tất cả các hoạt động được thực hiện dưới tài khoản của mình, bao gồm các hành động của các chuyên viên hoặc nhân viên liên kết.",

  FREE_TRIAL_TERMS_ACCESS_TITLE: "3. Quyền truy cập dùng thử miễn phí",
  FREE_TRIAL_TERMS_ACCESS_P1:
    "Trong thời gian dùng thử, Healthnex cấp cho Người dùng giấy phép có giới hạn, không độc quyền, không thể chuyển nhượng và có thể thu hồi để truy cập và sử dụng Nền tảng Healthnex.",
  FREE_TRIAL_TERMS_ACCESS_P2:
    "Thời gian dùng thử miễn phí kéo dài ba (3) tháng liên tiếp kể từ Ngày hiệu lực.",
  FREE_TRIAL_TERMS_ACCESS_P3:
    "Bản dùng thử miễn phí được cung cấp miễn phí và không tự động gia hạn.",

  FREE_TRIAL_TERMS_FEATURES_TITLE: "4.	Tính năng Nền tảng trong thời gian dùng thử",
  FREE_TRIAL_TERMS_FEATURES_INTRO:
    "Trong thời gian dùng thử, Người dùng có thể truy cập các tính năng bao gồm, nhưng không giới hạn ở:",
  FREE_TRIAL_TERMS_FEATURES_ITEM_1:
    "1)	Tạo và tùy chỉnh trang web chuyên nghiệp cá nhân hoặc phòng khám;",
  FREE_TRIAL_TERMS_FEATURES_ITEM_2: "2)	Quản lý lịch hẹn và lịch trình;",
  FREE_TRIAL_TERMS_FEATURES_ITEM_3:
    "3)	Quản lý thông tin bệnh nhân và hồ sơ bệnh án, bao gồm chức năng liên quan đến đơn thuốc;",
  FREE_TRIAL_TERMS_FEATURES_ITEM_4:
    "4)	Sử dụng các tính năng hỗ trợ bằng AI cho việc hỗ trợ hành chính và quy trình làm việc (không chẩn đoán);",
  FREE_TRIAL_TERMS_FEATURES_ITEM_5:
    "• Các dịch vụ hỗ trợ được cung cấp trong thời gian dùng thử",
  FREE_TRIAL_TERMS_FEATURES_NOTE:
    "Healthnex bảo lưu quyền sửa đổi, giới hạn hoặc ngừng các tính năng dùng thử theo quyết định của mình.",

  FREE_TRIAL_TERMS_EXPIRY_TITLE: "5.	Hết hạn dùng thử và Gia hạn (Điều khoản quan trọng)",
  FREE_TRIAL_TERMS_EXPIRY_P1:
    "1)	Người dùng xác nhận và đồng ý rõ ràng rằng nếu khi kết thúc thời gian dùng thử miễn phí ba (3) tháng, Người dùng chưa ký kết thỏa thuận đăng ký hoặc dịch vụ trả phí với Healthnex, quyền truy cập Nền tảng Healthnex sẽ chấm dứt.",
  FREE_TRIAL_TERMS_EXPIRY_P2:
    "2)	Nếu Người dùng không hoàn tất đăng ký khi hết hạn dùng thử:",
  FREE_TRIAL_TERMS_EXPIRY_ITEM_1:
    "quyền truy cập Nền tảng có thể bị tạm ngưng hoặc chấm dứt; và",
  FREE_TRIAL_TERMS_EXPIRY_ITEM_2:
    "Người dùng có thể không còn có thể sử dụng các tính năng Nền tảng hoặc truy cập dữ liệu đã lưu trữ.",
  FREE_TRIAL_TERMS_EXPIRY_P3:
    "Healthnex không có nghĩa vụ kéo dài thời gian dùng thử hoặc tiếp tục cung cấp quyền truy cập miễn phí.",

  FREE_TRIAL_TERMS_DATA_PRIVACY_TITLE:
    "6.	Dữ liệu, Quyền riêng tư và Thông tin sức khỏe",
  FREE_TRIAL_TERMS_DATA_PRIVACY_P1:
    "1)	Người dùng thừa nhận rằng khi sử dụng Nền tảng Healthnex, Healthnex có thể thu thập, lưu trữ, xử lý và truyền tải thông tin cá nhân và thông tin sức khỏe theo định nghĩa của Đạo luật Quyền riêng tư 1988 (Cth).",
  FREE_TRIAL_TERMS_DATA_PRIVACY_P2:
    "2)	Người dùng hoạt động với tư cách Đơn vị Kiểm soát Dữ liệu đối với dữ liệu bệnh nhân, và Healthnex xử lý dữ liệu đó chỉ theo chỉ dẫn của Người dùng.",
  FREE_TRIAL_TERMS_DATA_PRIVACY_P3:
    "3)	Healthnex sẽ xử lý tất cả thông tin cá nhân và sức khỏe theo:",
  FREE_TRIAL_TERMS_DATA_PRIVACY_ITEM_1: "Chính sách Quyền riêng tư Healthnex; ",
  AND_D: "và",
  FREE_TRIAL_TERMS_DATA_PRIVACY_ITEM_2:
    "Phụ lục Xử lý Dữ liệu Healthnex (DPA).",
  FREE_TRIAL_TERMS_DATA_PRIVACY_P4:
    "4)	Chính sách Quyền riêng tư và DPA được hợp nhất và là một phần của Thỏa thuận này theo tham chiếu.",
  FREE_TRIAL_TERMS_DATA_PRIVACY_P5:
    "5)	Trong trường hợp có bất kỳ sự không thống nhất nào giữa Thỏa thuận này và DPA, DPA sẽ được ưu tiên trong phạm vi các nghĩa vụ xử lý dữ liệu sức khỏe.",

  FREE_TRIAL_TERMS_USER_RESP_TITLE: "7.	Trách nhiệm và Tuân thủ của Người dùng",
  FREE_TRIAL_TERMS_USER_RESP_INTRO: "Người dùng cam đoan và bảo đảm rằng:",
  FREE_TRIAL_TERMS_USER_RESP_ITEM_1:
    "1)	khi Người dùng là người hành nghề y tế, họ được đăng ký hợp pháp và được phép hành nghề trong khu vực pháp lý liên quan;",
  FREE_TRIAL_TERMS_USER_RESP_ITEM_2:
    "2)	khi Người dùng là chủ hoặc người vận hành phòng khám, họ đảm bảo rằng tất cả các chuyên viên sử dụng Nền tảng đều được đăng ký và cấp phép phù hợp;",
  FREE_TRIAL_TERMS_USER_RESP_ITEM_3:
    "3)	việc sử dụng Nền tảng Healthnex tuân thủ tất cả các luật hiện hành, bao gồm luật về quyền riêng tư và hồ sơ sức khỏe;",
  FREE_TRIAL_TERMS_USER_RESP_ITEM_4:
    "4)	tất cả các quyết định lâm sàng, chẩn đoán, điều trị và đơn thuốc là trách nhiệm duy nhất của chuyên viên liên quan, không phải của Healthnex.",

  FREE_TRIAL_TERMS_TRIAL_DISCLAIMER_TITLE: "8.	Tuyên bố miễn trừ trong thời gian dùng thử",
  FREE_TRIAL_TERMS_TRIAL_DISCLAIMER_P1:
    "1)	Trong phạm vi tối đa được luật pháp cho phép, Nền tảng Healthnex được cung cấp trong thời gian dùng thử trên cơ sở “nguyên trạng” và “theo tình trạng sẵn có”.",
  FREE_TRIAL_TERMS_TRIAL_DISCLAIMER_P2:
    "2)	Healthnex không bảo đảm tính sẵn sàng liên tục, hoạt động không lỗi, hoặc sự phù hợp cho bất kỳ mục đích cụ thể nào trong thời gian dùng thử.",

  FREE_TRIAL_TERMS_LIABILITY_TITLE: "9.	Giới hạn trách nhiệm",
  FREE_TRIAL_TERMS_LIABILITY_P1:
    "1)	Trong phạm vi luật pháp cho phép, Healthnex loại trừ mọi trách nhiệm đối với bất kỳ tổn thất gián tiếp hoặc do hậu quả nào phát sinh từ hoặc liên quan đến việc Người dùng sử dụng các dịch vụ dùng thử.",
  FREE_TRIAL_TERMS_LIABILITY_P2:
    "2)	Không có điều khoản nào trong Thỏa thuận này loại trừ các quyền không thể loại trừ theo Luật Người tiêu dùng Úc.",

  FREE_TRIAL_TERMS_AMENDMENTS_TITLE: "10. Sửa đổi",
  FREE_TRIAL_TERMS_AMENDMENTS_P1:
    "Healthnex có thể sửa đổi Thỏa thuận này bằng cách thông báo hợp lý qua Nền tảng hoặc liên lạc điện tử. Việc tiếp tục sử dụng sau những sửa đổi đó đồng nghĩa với việc chấp nhận các điều khoản đã cập nhật.",

  FREE_TRIAL_TERMS_GOVERNING_LAW_TITLE: "11. Luật điều chỉnh",
  FREE_TRIAL_TERMS_GOVERNING_LAW_P1:
    "Thỏa thuận này được điều chỉnh bởi luật pháp của Tiểu bang New South Wales (NSW), Úc, và các bên chấp nhận thẩm quyền tài phán độc quyền của tòa án Tiểu bang đó.",

  FREE_TRIAL_TERMS_ACK_TITLE: "12.	Xác nhận và Chấp nhận",
  FREE_TRIAL_TERMS_ACK_INTRO:
    "Bằng cách nhấp “Tôi đồng ý”, đăng ký tài khoản, hoặc sử dụng Nền tảng Healthnex, Người dùng xác nhận rằng:",
  FREE_TRIAL_TERMS_ACK_ITEM_1: "họ đã đọc và hiểu Thỏa thuận này;",
  FREE_TRIAL_TERMS_ACK_ITEM_2: "họ đồng ý bị ràng buộc bởi tất cả các điều khoản của nó; và",
  FREE_TRIAL_TERMS_ACK_ITEM_3:
    "họ xác nhận rõ ràng rằng quyền truy cập Nền tảng sẽ kết thúc sau thời gian dùng thử ba (3) tháng trừ khi ký kết một đăng ký trả phí.",
  FREE_TRIAL_TERMS_ACK_CHECKBOX:
    "Tôi đã đọc và đồng ý với Điều khoản Sử dụng Dùng thử Miễn phí, Chính sách Quyền riêng tư, và Phụ lục Xử lý Dữ liệu của Healthnex, và tôi xác nhận rằng quyền truy cập của tôi sẽ kết thúc sau thời gian dùng thử ba tháng trừ khi tôi đăng ký một gói trả phí.",
};

const dashboard = {
  SEARCH_PATIENTS: "Tìm bệnh nhân",
  SEARCH_PATIENTS_THAT_U_WANT_TO_VIEW_THE_DETAIL_ABOUT:
    "Tìm và xem chi tiết bệnh nhân",
  VIEW_USER_GUIDE_AND_UNDERSTAND_THE_SYSTEM:
    "Xem hướng dẫn người dùng và tìm hiểu hệ thống",
  VIEW_APPOINTMENTS: "Xem lịch hẹn",
  VIEW_CREATED_APPOINTMENTS_ON_TIME_SCHEDULE:
    "Xem tất cả lịch hẹn đã lên lịch trong thời khóa biểu.",
  CREATE_APPOINTMENT_FOR_THE_SELECTED_PATIENT:
    "Tạo lịch hẹn cho bệnh nhân đã chọn",
  CREATE_MEIDICAL_HISTORY_FOR_THE_SELECTED_PATIENT:
    "Tạo hồ sơ bệnh án cho bệnh nhân đã chọn",
  VIEW_PATIENT_MEDICAL_HISTORY: "Xem hồ sơ bệnh án của bệnh nhân",
  VIEW_MEDICAL_HISTORY_FOR_THE_SELECTED_PATIENT:
    "Xem hồ sơ bệnh án cho bệnh nhân đã chọn",
  ADD_NEW_PATIENT_TO_THE_SYSTEM: "Thêm bệnh nhân mới vào hệ thống",
  VIEW_PATIENT: "Xem bệnh nhân",
  VIEW_PATIENT_INFO: "Xem thông tin bệnh nhân",
  VALIDATE_PATIENT: "Xác thực bệnh nhân mới",
  VALIDATION_REQUIRED: "Cần xác thực",
  RECOMMENDED_PATIENTS: "Bệnh nhân được đề xuất",
  MERGE: "Hợp nhất",
  MERGE_TO_RECOMMENDED_PATIENTS: "Hợp nhất vào một trong các bệnh nhân hiện có bên dưới",
  MERGE_TO_THIS_PATIENT: "Hợp nhất vào bệnh nhân này",
  VIEW_MERGED_PATIENT: "Xem bệnh nhân đã hợp nhất",
  CONFIRMED_AS_NEW_PATIENT: "Xác nhận là bệnh nhân mới",
  PATIENT_CONFIRMED: "Đã xác nhận bệnh nhân là bệnh nhân mới",
  PATIENT_MERGED: "Đã hợp nhất bệnh nhân thành công",
  DELETE_PATIENT: "Xóa bệnh nhân",
  DELETE_PATIENT_CONFIRM: "Bạn có chắc chắn muốn xóa bệnh nhân này không? Hành động này không thể hoàn tác.",
  DELETE_PATIENT_FAILED: "Không thể xóa bệnh nhân. Bệnh nhân này có thể đã có hồ sơ bệnh án.",
  NUMBER_OF_APPOINTMENTS: "Số lượng lịch hẹn",
  TOTAL_EARNINGS: "Tổng thu nhập",
  TOTAL_CHARGED: "Doanh thu gộp",
  INSURANCE_REBATE_TOTAL: "Tổng hoàn phí bảo hiểm",
  TOTAL_DISCOUNT: "Tổng giảm giá",
  NO_PATIENTS_HAS_CREATED_PRESCRIPTION: "Số bệnh nhân có đơn thuốc",
  NO_PRESCRIPTION_CONDUCTED: "Tổng số đơn thuốc đã kê",
  YOUR_CLINIC_MEMBERS: "Thành viên phòng khám của bạn",
  MY_STATS: "Thống kê của tôi",
  VIEW_STATS: "Xem thống kê",
  VIEW_THIS_WEEK: "Xem tuần này",
  VIEW_TODAY: "Xem hôm nay",
  THIS_WEEK: "Tuần này",
  S_STATS: " - Thống kê",
  GOOD_MORNING: "Chào buổi sáng",
  GOOD_NOON: "Chào buổi chiều",
  GOOD_AFTERNOON: "Chào buổi chiều",
  GOOD_EVENING: "Chào buổi tối",
  VIEW_CLINIC_STATS: "Xem tổng quan công việc phòng khám",
  GO_TO: "Đến ",
  PAGE_BACK: " Trang",
};

const patientList = {
  IMPORT_PATIENT_FROM_EXCEL: "Nhập bệnh nhân từ Excel",
  IF_U_WANT_TO_IMPORT_PATIENTS_FROM_YOUR_EXCEL:
    "Bạn có thể nhanh chóng nhập thông tin bệnh nhân bằng cách hoàn thành mẫu Excel và tải lên Healthnex.",
  STEP_1_DOWNLOAD_THE_EXCEL_TEMPALTE_FILE_FROM_BELOW_AND_FILL_IN_ALL_THE_REQUIRED_COLUMNS:
    "Bước 1: Tải mẫu Excel bên dưới và hoàn thành tất cả các trường bắt buộc cho mỗi bệnh nhân.",
  STEP_2_COMPLETE_PATIENT_INFO_EXCEL_TEMPALTE_AND_UPLOAD_BELOW:
    "Bước 2: Sau khi hoàn thành thông tin bệnh nhân, nhấp vào nút bên dưới để tải mẫu Excel lên Healthnex.",
  DOWNLOAD_EXCEL_TEMPLATE: "Tải mẫu Excel",
  UPLOAD_EXCEL: "Tải lên tệp Excel (.xlsx)",
  IMPORTED_PATIENTS: "Bệnh nhân đã nhập",
  PATIENTS_IMPORTED_SUCCESSFULLY: "Đã nhập bệnh nhân thành công",
  IMPORT_ERRORS_FOUND: "Phát hiện lỗi khi nhập",
  NO_ERRORS_FOUND: "Không tìm thấy lỗi",
  RECORDS_REQUIRED_UR_ACTION_DUE_TO_SIMILAR_PATIENTS_FOUND_IN_THE_SYSTEM:
    "Hồ sơ có thể đã tồn tại trong hệ thống và cần xem xét thủ công.",
  IMPORT_STATUS: "Trạng thái nhập",
  IMPORT_PAUSED: "Đã tạm dừng nhập",
  X_SIMILAR_PATIENTS_FOUND_IN_THE_SYSTEM:
    "Tìm thấy {{X}} bệnh nhân có thông tin tương tự.",
  OVERWRITE_EXCEL_TO_THIS: "Ghi đè bằng dữ liệu đã nhập",
  HERE_IS_THE_DIFFERENCE_BETWEEN_TWO_RECORDS:
    "Bạn có thể xem lại sự khác biệt giữa thông tin bệnh nhân hiện có và dữ liệu đã nhập bên dưới",
  CURRENT_IN_SYSTEM: "Thông tin bệnh nhân hiện tại (Hệ thống)",
  EXCEL_INFO_TO_UPDATE: "Thông tin bệnh nhân đã nhập (Excel)",
  THERE_ARE_STILL_SOME_IMPORTED_PATIENTS_INFO_NEED_UR_ACTION:
    "Có các hồ sơ bệnh nhân chưa được nhập và cần bạn xem xét thủ công.",
  ARE_U_SURE_TO_COMPLETE_THE_IMPORT_NOW:
    "Bạn có chắc chắn đã hoàn thành việc nhập và muốn đóng cửa sổ này không?",
  DOWNLOADING: "Đang tải xuống",
  PATIENTS_IMPORTED_FROM_EXCEL: "Bệnh nhân đã nhập từ Excel",
  RE_UPLOAD_THE_EXCEL: "Tải lên lại Excel",
  COMPLETE_IMPORT: "Hoàn tất nhập",
  PREFER_NOT_TO_SAY: "Không muốn tiết lộ",
  ADDED_PATIENTS: "Bệnh nhân đã thêm",
  DUPLICATED_PATIENTS: "Bệnh nhân đã tồn tại trong hệ thống",
  EXCEL_FILE_UPLOAD_FAILED_PLEASE_MAKE_SURE_YOU_ARE_USING_OUR_TEMPLATE_FILE_U_CAN_DOWNLOAD_THE_FILE_HERE:
    "Tải Excel lên thất bại. Vui lòng đảm bảo bạn đang sử dụng tệp mẫu được cung cấp. Bạn có thể tải mẫu qua nút bên dưới.",
  EXPORT_MEDICAL_HISTORY: "Xuất hồ sơ bệnh án",
  EXPORT_X_MEDICAL_HISTORY: "Xuất hồ sơ bệnh án của {{X}}",
  STEP_1_SELECT_DATE_RANGE_MEDICAL_INSURANCES_TO_FILTER_MEDICAL_HISTORY_THAT_U_LIKE_TO_EXPORT:
    "Bước 1: Chọn khoảng ngày tư vấn và lọc theo bảo hiểm của bệnh nhân để xác định các hồ sơ bệnh án bạn muốn xuất.",
  OPTIONAL: "Tùy chọn",
  GUIDED_REQUIRED_MISSING_SUMMARY: "Bắt buộc ({{X}}) mục chưa điền: ",
  GUIDED_OPTIONAL_MISSING_SUMMARY: "Tùy chọn ({{X}}) mục chưa điền: ",
  IF_U_WANT_TO_EXPORT_PATIENT_HISTORY_CREATED_FROM_SPECIFIC_CLINIC:
    "Nếu bạn muốn xuất hồ sơ bệnh án được tạo bởi một phòng khám cụ thể, vui lòng chọn phòng khám bên dưới để lọc kết quả.",
  STEP_2_EXPORT_RELATED_PATIENT_HISTORY_TO_EXCEL:
    "Bước 2: Xuất các hồ sơ bệnh án đã lọc dưới dạng tệp Excel.",
  TOTAL_MEDICAL_RECORDS_FOUND: "Tổng số hồ sơ bệnh án tìm thấy",
  MULTI_SELECTION: "Cho phép chọn nhiều",
  EXPORT_TO_EXCEL: "Xuất ra Excel",
  UPDATED_BY: "Cập nhật bởi",
  UPLOAD_ATTACHMENT: "Tải lên tệp đính kèm",
  MAX_X_ATTACHMENTS_ALLOWED: "Bạn chỉ có thể tải lên tối đa {{X}} tệp đính kèm",
  DELETING: "Đang xóa",
  OCCUPATION: "Nghề nghiệp",
  NOTES: "Ghi chú",
  ADDRESS_INFO: "Thông tin địa chỉ",
  POSTAL_ADDRESS: "Địa chỉ bưu chính",
  SAME_AS_HOME_ADDRESS: "Giống địa chỉ nhà",
  OTHER_INFO: "Thông tin khác",
  PLEASE_CHECK_THE_INFORMATION_THAT_U_WISH_TO_UPDATE: "Vui lòng chọn thông tin bạn muốn cập nhật hoặc giữ lại.",
  NEW_INFO: "Thông tin mới",
};

const templateEditor = {
  CLINIC_DOC_TEMPLATE: "Mẫu tài liệu & SMS",
  DOCUMENT_TEMPLATES: "Mẫu tài liệu & SMS",
  YOU_CAN_CREATE_EDIT_CLINIC_TEMPLATES_HERE: "Tạo và quản lý các giấy chứng nhận, thư từ và tin nhắn SMS mà phòng khám của bạn sử dụng.",
  NEW_CLINIC_TEMPLATE: "Mẫu phòng khám mới",
  TEMPLATE_NAME: "Tên mẫu",
  TEMPLATE_CATEGORY: "Danh mục mẫu",
  TEMPLATE_SOURCE: "Nguồn mẫu",
  SYSTEM_TEMPLATE: "Mẫu hệ thống",
  CLINIC_TEMPLATE: "Mẫu phòng khám",
  CLINIC_TEMPLATES: "Mẫu phòng khám",
  CLINIC_TEMPLATES_HINT: "Các mẫu được phòng khám của bạn tùy chỉnh.",
  SYSTEM_TEMPLATES: "Mẫu hệ thống",
  SYSTEM_TEMPLATES_HINT: "Mẫu mặc định do Healthnex cung cấp. Khi chỉnh sửa sẽ tạo một bản sao cho phòng khám.",
  NO_CLINIC_TEMPLATE_YET: "Chưa có mẫu phòng khám. Hãy chỉnh sửa một mẫu hệ thống bên dưới để tạo mẫu riêng.",
  USER_DEFINED: "Tùy chỉnh",
  SICK_CERT: "Giấy chứng nhận nghỉ ốm",
  REFERRAL: "Thư giới thiệu",
  ALL: "Tất cả",
  SEARCH_TEMPLATES: "Tìm kiếm mẫu",
  CLEAR_FILTERS: "Xóa bộ lọc",
  CLEAR_SEARCH: "Xóa tìm kiếm",
  NO_TEMPLATE_FOUND: "Không tìm thấy mẫu",
  TRY_ANOTHER_SEARCH_TERM: "Hãy thử từ khóa khác hoặc xóa bộ lọc.",
  LOADING_TEMPLATES: "Đang tải các mẫu...",
  CREATE_SUCCESS: "Tạo mẫu thành công.",
  TEMPLATE_SAVE_SUCCESS: "Lưu mẫu thành công.",
  TEMPLATE_DELETE_SUCCESS: "Xóa mẫu thành công.",
  DELETE_TEMPLATE: "Xóa mẫu",
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEMPLATE: "Bạn có chắc chắn muốn xóa mẫu này không",
  TEMPLATE_WILL_BE_RESET_TO_SYSTEM_TEMPLATE: "Nếu mẫu này đang được sử dụng, hệ thống sẽ chuyển sang sử dụng mẫu hệ thống.",
  NOTE: "Lưu ý",
  CREATED_IN: "Được tạo tại",
  LAST_EDITED_AT: "Chỉnh sửa lần cuối",
  EDIT: "Chỉnh sửa",
  DELETE: "Xóa",
  TEMPLATE_ACTIVATED: "Đã kích hoạt mẫu thành công.",
  TEMPLATE_DEACTIVATED: "Đã ngừng kích hoạt mẫu thành công.",
  STATUS: "Trạng thái",
  IN_USE: "Đang sử dụng",
  NOT_USED: "Không sử dụng",
  UPDATING: "Đang cập nhật",
  DUPLICATE: "Sao chép",
  DUPLICATE_TEMPLATE: "Sao chép mẫu",
  SAVE: "Lưu",
  SAVING: "Đang lưu",
  SAVE_AS_CLINIC_TEMPLATE: "Lưu thành mẫu phòng khám",
  LOADING_TEMPLATE: "Đang tải mẫu",
  CREATING_TEMPLATE: "Đang tạo mẫu",
  SAVING_TEMPLATE: "Đang lưu mẫu",

  SMS_CREATE_BOOKING: "SMS - Xác nhận đặt lịch",
  SMS_RESCHEDULE_BOOKING: "SMS - Đổi lịch hẹn",
  EDIT_SMS_TEMPLATE: "Chỉnh sửa mẫu SMS",
  MESSAGE_CONTENT: "Nội dung tin nhắn",
  VARIABLES: "Biến",
  INSERT_VARIABLE_HINT: "Nhấp hoặc kéo một biến để chèn tại con trỏ, hoặc gõ {{ trong tin nhắn để tìm kiếm.",
  CHARACTERS: "ký tự",
  SMS_CHAR_LIMIT_HINT: "Số ký tự được tính trên tin nhắn đã điền thông tin ví dụ của bệnh nhân và phòng khám. Thông tin thực tế có thể làm tin nhắn dài hơn hoặc ngắn hơn một chút.",
  SMS_CHAR_LIMIT_EXCEEDED: "Tin nhắn vượt quá giới hạn 300 ký tự. Vui lòng rút ngắn trước khi lưu.",
  SMS_TODAY: "Hôm nay",
  SMS_TEXT_MESSAGE: "Tin nhắn",
  SMS_PREVIEW_EMPTY: "Bắt đầu nhập để xem trước tin nhắn",
  DRAG_ELEMENTS_AND_DROP_ON_PAGE: "Vui lòng kéo các mô-đun nội dung bên dưới vào trang để chỉnh sửa.",
  PREVIEW: "Xem trước",
  SCALE: "Tỷ lệ",
  ZOOM_OUT: "Thu nhỏ",
  ZOOM_IN: "Phóng to",
  RESET_SCALE: "Đặt lại tỷ lệ",
  CONTENT: "Nội dung",
  TEXT: "Văn bản",
  LAYOUT: "Bố cục",
  COLUMNS: "Cột",
  LINE_DIVIDER: "Đường phân cách",
  MEDIA: "Phương tiện",
  IMAGE: "Hình ảnh",
  SIGNATURE: "Chữ ký",
  PAGE_SIZE: "Kích thước trang",
  PAGE_MARGIN: "Lề trang",
  PAGE_SETTINGS: "Cài đặt trang",
  SELECT_ELEMENT_TO_EDIT_HINT: "Nhấp vào một phần tử trên trang để chỉnh sửa cài đặt của nó tại đây.",
  TEXT_PARAGRAPH: "Đoạn văn bản",
  ENTER_CONTENT_HERE: "Nhập nội dung tại đây",
  FONT_SIZE: "Cỡ chữ",
  BOLD: "In đậm",
  ITALIC: "In nghiêng",
  UNDERLINE: "Gạch chân",
  ALIGNMENT: "Căn chỉnh",
  TEXT_COLOUR: "Màu văn bản",
  BOTTOM_MARGIN: "Khoảng cách phía dưới",
  DYNAMIC_FIELD: "Nhãn và nội dung cài đặt sẵn",
  LABEL: "Nhãn",
  LABEL_FONT_SIZE: "Cỡ chữ nhãn",
  VALUE_FONT_SIZE: "Cỡ chữ giá trị",
  VALUE_COLOUR: "Màu giá trị",
  LABEL_COLOUR: "Màu nhãn",
  TWO_COLUMNS: "Hai cột",
  COLUMN_GAP: "Khoảng cách giữa các cột",
  LEFT_WIDTH_RATIO: "Chiều rộng cột trái",
  RIGHT_WIDTH_RATIO: "Chiều rộng cột phải",
  HORIZONTAL_LINE: "Đường ngang",
  LINE_WIDTH: "Độ dày đường",
  COLOUR: "Màu sắc",
  SPACING: "Khoảng trống",
  HEIGHT: "Chiều cao",
  MINIMUM_HEIGHT: "Chiều cao tối thiểu",
  PRACTITIONER_SIGNATURE: "Chữ ký bác sĩ",
  CLINIC_LOGO: "Logo phòng khám",
  CLEAR: "Xóa",
  LEFT: "Căn trái",
  CENTER: "Căn giữa",
  RIGHT: "Căn phải",
  JUSTIFY: "Căn đều",
  MANUAL_INPUT: "Nhập thủ công",
  AUTOMATIC_FIELDS: "Trường cài đặt sẵn",
  USER_INPUT_FIELDS: "Các trường người dùng cần nhập",
  USER_INPUT: "Yêu cầu người dùng nhập",
  USER_INPUT_FIELD_HINT: "Người dùng cần điền nội dung này trước khi tạo tài liệu.",
  DRAG_OR_CLICK_VARIABLE_HINT: "Kéo hoặc nhấp để chèn",
  VARIABLE_PALETTE_TITLE: "Chèn biến",
  VARIABLE_PALETTE_PANEL_HINT: "Kéo một biến vào hộp văn bản, hoặc nhấp để chèn tại vị trí con trỏ.",
  INSERT_PRESET_VARIABLES: "Chèn nội dung cài đặt sẵn",
  SELECT_PRESET_OPTIONS: "Chọn nội dung cài đặt sẵn",
  SHOW_PREVIEW: "Hiện bản xem trước",
  TOOLBAR_SIZE: "Cỡ chữ",
  TOOLBAR_COLOUR: "Màu",
  TOOLBAR_THICKNESS: "Độ dày",
  PRACTITIONER_NAME: "Tên bác sĩ",
  CMBA_NUMBER: "Số CMBA",
  CLINIC_NAME: "Tên phòng khám",
  CLINIC_ADDRESS: "Địa chỉ phòng khám",
  PATIENT_NAME: "Tên bệnh nhân",
  PATIENT_DOB: "Ngày sinh bệnh nhân",
  BOOKING: "Đặt lịch",
  BOOKING_CODE: "Mã đặt lịch",
  BOOKING_START_DATE: "Ngày bắt đầu lịch hẹn",
  BOOKING_START_TIME: "Giờ bắt đầu lịch hẹn",
  BOOKING_PATIENT_NAME: "Tên bệnh nhân đặt lịch",
  PRACTITIONER_PHONE: "Số điện thoại bác sĩ",
  TODAY_DATE: "Ngày hôm nay",
  START_DATE: "Ngày bắt đầu",
  END_DATE: "Ngày kết thúc",
  FREE_TEXT: "Văn bản tự do",
  CONSULTED_DATE: "Ngày khám",
  UNFIT_UNTIL_DATE: "Không đủ sức khỏe làm việc đến ngày",

  PERMISSION_ROLES: "Vai trò phân quyền",
  PERMISSION_ROLES_HINT: "Tạo vai trò tùy chỉnh cho phòng khám của bạn, xây dựng từ một bộ quyền dùng chung.",
  CLINIC_ROLES: "Vai trò phòng khám",
  CLINIC_ROLES_SECTION_HINT: "Vai trò do phòng khám của bạn tạo — có thể chỉnh sửa đầy đủ.",
  NO_CLINIC_ROLE_YET: "Chưa có vai trò phòng khám nào. Hãy tạo một vai trò để bắt đầu.",
  SYSTEM_ROLES: "Vai trò hệ thống",
  SYSTEM_ROLES_HINT: "Vai trò mặc định do Healthnex cung cấp — chỉ đọc.",
  SYSTEM: "Hệ thống",
  NEW_CLINIC_ROLE: "Tạo vai trò phòng khám mới",
  EDIT_CLINIC_ROLE: "Chỉnh sửa vai trò phòng khám",
  SEARCH_ROLES: "Tìm kiếm vai trò",
  ROLE_NAME_EN: "Tên vai trò (Tiếng Anh)",
  ROLE_NAME_CN: "Tên vai trò (Tiếng Trung)",
  ROLE_NAME_TH: "Tên vai trò (Tiếng Thái)",
  ROLE_NAME_VN: "Tên vai trò (Tiếng Việt)",
  ROLE_NAME_IS_REQUIRED: "Tên vai trò (Tiếng Anh) là bắt buộc.",
  TRANSLATING: "Đang dịch",
  PERMISSIONS: "Quyền",
  SELECTED: "đã chọn",
  CLEAR_ALL: "Bỏ chọn tất cả",
  SEARCH_PERMISSIONS: "Tìm kiếm quyền",
  NO_PERMISSIONS_FOUND: "Không tìm thấy quyền nào",
  X_PERMISSIONS_ASSIGNED: "Đã gán {{X}} quyền",
  X_PERMISSIONS_ADDED: "Thêm {{X}}",
  X_PERMISSIONS_REMOVED: "Bớt {{X}}",
  REMOVED: "Đã bớt",
  PERMISSION_DIFF_VS_CURRENT_HINT: "Hiển thị sự khác biệt về quyền của vai trò này so với vai trò hiện tại của nhân viên.",
  NO_PERMISSIONS_ADDED_VS_CURRENT: "Không có quyền nào được thêm so với vai trò hiện tại.",
  NO_PERMISSIONS_REMOVED_VS_CURRENT: "Không có quyền nào bị bớt so với vai trò hiện tại.",
  DELETE_ROLE: "Xóa vai trò",
  ROLE_NAME: "Tên vai trò",
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ROLE: "Bạn có chắc chắn muốn xóa vai trò này không",
  NO_DATA: "Không có dữ liệu",
  ROLE_CREATE_SUCCESS: "Tạo vai trò thành công.",

  PERMISSION_ASSIGNMENT: "Phân quyền",
  CURRENT_ROLE: "Vai trò hiện tại",
  CURRENT_PERMISSIONS: "Quyền hiện tại",
  VIEW_PERMISSIONS: "Xem quyền",
  RESET_TO_CURRENT_ROLE: "Quay lại vai trò hiện tại",
  SWITCH_TO_THIS_ROLE: "Chuyển sang quyền của vai trò này",
  NO_PERMISSIONS_ASSIGNED: "Chưa có quyền nào được cấp.",
  REASSIGN_ROLE: "Gán lại vai trò",
  SELECT_ROLE_TO_ASSIGN: "Chọn vai trò",
  PREVIEW_ROLE_PERMISSIONS: "Xem trước quyền của vai trò này",
}

export default {
  translation: {
    ...signUp,
    ...navigation,
    ...prescription,
    ...search,
    ...info,
    ...notification,
    ...appointment,
    ...clinicManagement,
    ...clinicHerbs,
    ...Library,
    ...packagePages,
    ...cmasaImport,
    ...camera,
    ...bookingPage,
    ...guide,
    ...patientConsent,
    ...agreements,
    ...freeTrialTerms,
    ...dashboard,
    ...patientList,
    ...templateEditor,
    BODY_MAP: "Sơ đồ cơ thể",
    CLICK_BODY_PART_TO_SELECT_TECHNIQUE: "Nhấp vào một bộ phận cơ thể trên hình để chọn kỹ thuật",
    CLINICAL_RECORD: "Hồ sơ lâm sàng",
    DOC_CHECKLIST: "Tài liệu hồ sơ",
    ENTER_TREATMENT_NAME: "Nhập tên điều trị",
    GST: "Thuế GST",
    GUIDED_CONFIRM_PAYMENT: "Xác nhận thanh toán",
    GUIDED_DOC_TITLE: "Tài liệu lâm sàng",
    GUIDED_GROUP_ASSESSMENT: "Đánh giá",
    GUIDED_GROUP_COMPLETE: "Hoàn thành",
    GUIDED_GROUP_NOT_STARTED: "Chưa bắt đầu",
    GUIDED_GROUP_PAYMENT: "Thanh toán",
    GUIDED_GROUP_SYMPTOMS: "Triệu chứng",
    GUIDED_GROUP_TREATMENT: "Điều trị",
    GUIDED_HINT_BODY_MAP: "Đánh dấu các vùng bị ảnh hưởng trên sơ đồ cơ thể.",
    GUIDED_HINT_CHECKOUT: "Xem lại phí, thêm bất kỳ khoản phí nào và xác nhận thanh toán.",
    GUIDED_HINT_CONSULT_NOTES: "Ghi lại triệu chứng chính mà bệnh nhân trình bày bằng lời của chính họ.",
    GUIDED_HINT_DURATION: "Nhập thời gian điều trị và ghi chú liên quan.",
    GUIDED_HINT_MEDICAL_SAFETY: "Ghi lại dị ứng và tình trạng mang thai trước khi điều trị.",
    GUIDED_HINT_MODALITY: "Xem lại hoặc thêm các phương pháp điều trị trong lần khám này.",
    GUIDED_HINT_OUTCOME: "Ghi lại phản ứng của bệnh nhân đối với việc điều trị.",
    GUIDED_HINT_OVERVIEW: "Xem lại các điều trị hôm nay, hoặc chọn một mục để ghi hồ sơ.",
    GUIDED_HINT_PAIN_CONDITIONS: "Thêm các tình trạng liên quan, phân theo hệ cơ quan.",
    GUIDED_HINT_PAIN_LEVEL: "Đánh giá mức độ đau hiện tại của bệnh nhân từ 0 (không đau) đến 10 (đau nhất).",
    GUIDED_HINT_PAIN_TYPE: "Chọn tất cả các đặc điểm cơn đau mà bệnh nhân mô tả.",
    GUIDED_HINT_PAYMENT_FEE: "Xác nhận phí cho từng điều trị đã thực hiện.",
    GUIDED_HINT_PAYMENT_OTHER: "Thêm các khoản phí bổ sung và xem lại tổng số tiền.",
    GUIDED_HINT_PRECAUTION: "Ghi lại các lưu ý hoặc chống chỉ định.",
    GUIDED_HINT_RECOMMENDATION: "Ghi lại lời khuyên và kế hoạch tái khám được đề xuất.",
    GUIDED_HINT_TECHNIQUES: "Chọn vùng điều trị và kỹ thuật thủ công áp dụng cho từng vùng.",
    GUIDED_HINT_TODAYS_TREATMENTS: "Các điều trị hôm nay",
    GUIDED_HINT_TREATMENT_DETAILS: "Chọn vùng và huyệt, chọn kỹ thuật và đặt thời lượng.",
    GUIDED_HINT_TREATMENT_NOTE: "Ghi lại ghi chú và kế hoạch điều trị.",
    GUIDED_HINT_TREATMENT_POINTS: "Tìm kiếm và chọn các huyệt được sử dụng trong lần điều trị này.",
    GUIDED_HINT_UPLOAD_PHOTOS: "Đính kèm ảnh liên quan đến lần khám này.",
    GUIDED_LABEL_AFFECTED_AREAS: "Vùng bị ảnh hưởng",
    GUIDED_LABEL_ALLERGY: "Dị ứng",
    GUIDED_LABEL_ASSESSMENT_PHOTOS: "Tải ảnh lên",
    GUIDED_LABEL_CHIEF_COMPLAINT: "Ghi nhận hỏi bệnh",
    GUIDED_LABEL_FOLLOW_UP_RECOMMENDATION: "Khuyến nghị tái khám",
    GUIDED_LABEL_MEDICAL_SAFETY: "Dị ứng / Mang thai",
    GUIDED_LABEL_PAIN_CHARACTER: "Loại đau",
    GUIDED_LABEL_PAIN_SEVERITY: "Mức độ đau",
    GUIDED_LABEL_PAYMENT: "Thanh toán",
    GUIDED_LABEL_PRECAUTIONS_ADVICE: "Lưu ý & Lời khuyên",
    GUIDED_LABEL_RELATED_CONDITIONS: "Tình trạng đau",
    GUIDED_LABEL_TREATMENT_AREA_TECHNIQUE: "Vùng & Kỹ thuật điều trị",
    GUIDED_LABEL_TREATMENT_DURATION: "Thời lượng điều trị",
    GUIDED_LABEL_TREATMENT_NOTE_PLAN: "Ghi chú & Kế hoạch điều trị",
    GUIDED_LABEL_TREATMENT_OUTCOME: "Kết quả điều trị",
    GUIDED_LABEL_TREATMENT_OVERVIEW: "Tổng quan điều trị",
    GUIDED_LABEL_TREATMENT_POINTS: "Huyệt điều trị",
    GUIDED_MISSING: "Còn thiếu",
    GUIDED_MODALITY_TAB_DESC: "Chọn thẻ điều trị ở trên để chỉnh sửa, hoặc thêm điều trị khác. Các tab dùng để ghi hồ sơ cho điều trị đã chọn.",
    GUIDED_SAVE_AND_CONTINUE_TO_PAYMENT: "Lưu & Tiếp tục thanh toán",
    GUIDED_SKIP_TOOLTIP: "Chuyển tiếp mà không hoàn thành mục này",
    GUIDED_STEP_1_SYMPTOMS: "Bước 1: Triệu chứng",
    GUIDED_STEP_2_TREATMENT: "Bước 2: Điều trị",
    GUIDED_STEP_3_PAYMENT: "Bước 3: Thanh toán",
    GUIDED_TAB_HELPER: "Chọn một tab ở trên để chuyển giữa các mục tài liệu.",
    GUIDED_TAB_TOOLTIP: "Mở mục này",
    GUIDED_TREATMENT_DETAILS: "Chi tiết điều trị",
    GUIDED_TREATMENT_OVERVIEW: "Tổng quan",
    GUIDED_X_OF_Y_REQUIRED_COMPLETED: "Đã hoàn thành {{X}}/{{Y}} mục bắt buộc",
    GUIDED_X_REQUIRED_REMAINING: "Còn {{X}} mục bắt buộc",
    NO_INFO_RECORDED: "Chưa có thông tin được ghi nhận.",
    RECEIPT: "Biên lai",
    RECORD_NO: "Số hồ sơ",
    RESPONSE: "Phản hồi",
    SAVE_AND_NEXT: "Lưu & Tiếp theo",
    BACK: "Quay lại",
    CLOSE: "Đóng",
    ONLINE_ZOOM_MEETING: "Cuộc họp Zoom trực tuyến",
    KEY_MEMBERS: "Thành viên chủ chốt",
    INTRODUCTION: " Giới thiệu ngắn gọn",
    LOAD_MORE: "Tải thêm",
    CURRENT: "Hiện tại",
    HISTORY_EVENT: "Sự kiện lịch sử",
    HISTORY_CPD: "Lịch sử CPD",
    HISTORY: "Trong quá khứ",
    EXPIRED: "Đã hết hạn",
    MONTH_FORMAT: "MMMM",
    EDIT: "Chỉnh sửa",
    FROM: "Từ",
    TO: "Đến",
    TOTAL_X: "Tổng cộng {{X}} hồ sơ",
    OTHER_LANGUAGE_VERSION: "中文版",
    CLINIC: "Phòng khám",
    HRS: "giờ",
    VIEW: "Xem",
    LOADING: "Đang tải",
    VIEW_ALL: "Xem tất cả",
    NO_INPUT_YET: "[Chưa cung cấp thông tin]",
    U_ARE_EDITING: "Bạn đang chỉnh sửa",
    X_WEBSITE: "Phiên bản {{X}} của trang web",
    SWITCH_TEMPLATE: "Chuyển mẫu",
    TERMS_AND_CONDITIONS: "Điều khoản và Điều kiện",
    PRIVACY_POLICY: "Chính sách quyền riêng tư",
    INITIATING: "Đang khởi tạo",
    FAILED_TO_ACCESS_MICROPHONE: "Không thể truy cập micrô",
    LISTENING: "Đang nghe",
    TRANSCRIBING: "Đang chuyển lời nói thành văn bản",
    SPEECH_TO_TEXT: "Chuyển lời nói thành văn bản",
    STOP_RECORDING: "Dừng ghi âm",
    DISPLAYED: "Đã hiển thị",
    RECORDS: "Hồ sơ",
    X_RECORDS: "{{X}} hồ sơ",
    WITH_TOTAL_X_RECORDS: "với tổng cộng {{X}} hồ sơ",
    ALL_X_RECORDS_LOADED: "Đã tải tất cả {{X}} hồ sơ",
    AI_AUTO_TRANSLATE: "Dịch bằng AI",
    ADD_TO_CLINIC_FORMULA: "Thêm vào bài thuốc phòng khám",
    NON_PREMIUM: "Không cao cấp",
    NON_TOXIC: "Không độc",
    APPOINTMENT_HISTORY: "Lịch sử lịch hẹn",
    ADJUST_APPOINTMENT_TIME: "Điều chỉnh thời gian hẹn",
    ADJUST_NOW: "Điều chỉnh ngay",
    I_UNDERSTAND_THE_ACTION_AND_AGREE_TO_PROCEED:
      "Tôi hiểu hành động này và đồng ý tiếp tục",
    PLEASE_NOTE_CHANGING_APPOINTMENT_DURATION_MIGHT_CAUSE_OVERBOOKING_TO_OTHER_EXISTING_APPOINTMENT:
      "Xin lưu ý việc thay đổi thời lượng lịch hẹn có thể gây trùng lịch với các lịch hẹn hiện có khác",
    NEXT_WEEK: "Tuần sau",
    JUMP_TO_TODAY: "Nhảy đến hôm nay",
    APPOINTMENTS_PENDING_FOR_SCHEDULE: "Lịch hẹn đang chờ lên lịch",
    X_APPOINTMENTS_PENDING_FOR_YOUR_SCHEDULE:
      "{{X}} lịch trùng đang chờ bạn lên lịch",
    RELOAD: "Tải lại",
    CANNOT_RESCHEDULE_WITHIN_24_HOURS: "Không thể đổi lịch trong vòng 24 giờ",
    PREV_WEEK: "Tuần trước",
    PENDING_APPROVAL: "Đang chờ duyệt",
    SUBSCRIBE: "Đăng ký",
    THIS_ITEM_WILL_NOT_LONGER_BE_ABLE_TO_BE_USED_IN_THIS_CLINIC:
      "Mục này sẽ không còn có thể được sử dụng tại phòng khám này",

    PLEASE_SELECT_A_VIDEO: "Vui lòng chọn một video",
    PLEASE_SELECT_A_COVER_IMAGE: "Vui lòng chọn một ảnh bìa",
    RESCHEDULE: "Đổi lịch",
    RESCHEDULE_APPOINTMENT: "Đổi lịch hẹn",
    CURRENT_APPOINTMENT_TIME: "Thời gian hẹn hiện tại",
    NEW_APPOINTMENT_TIME: "Thời gian hẹn mới",
    NOT_SELECTED: "Chưa chọn",
    LINK_APPOINTMENT_TO_PATIENT_SUCCESS:
      "Đã liên kết lịch hẹn với bệnh nhân thành công",
    LINK_APPOINTMENT_TO_PATIENT: "Liên kết lịch hẹn với bệnh nhân",
    ACCEPT_APPOINTMENT: "Chấp nhận lịch hẹn",
    PROCEED_TO_PATIENT_INFO: "Tiến tới thông tin bệnh nhân",
    CONFIRM_RESCHEDULE: "Xác nhận đổi lịch",
    APPOINTMENT_DATE: "Ngày hẹn",
    PENDING_APPOINTMENT: "Lịch hẹn đang chờ",
    PENDING_APPOINTMENTS: "Các lịch hẹn đang chờ",
    PENDING_SCHEDULE: "Đang chờ lên lịch",
    LINK_TO_PATIENT: "Liên kết với bệnh nhân",
    LINK_TO_ANOTHER_PATIENT: "Liên kết với bệnh nhân khác",
    LINK_ANOTHER_PATIENT_FROM_CLINIC_TO_THIS_APPOINTMENT:
      "Liên kết một bệnh nhân khác từ phòng khám của bạn với lịch hẹn này",
    THIS_PACKAGE_IS_ONLY_FOR_YOUR_CLINIC_PLZ_CREATE_ONE:
      "Gói này áp dụng cho phòng khám của bạn, vui lòng tạo một phòng khám trước",
    CLEAR: "Xóa",
    YOUR_WORKING_CLINICS: "Phòng khám nơi bạn làm việc",
    ALL: "Tất cả",
    SEARCH_PACKAGE: "Tìm gói",
    SEARCH_TREATMENT: "Tìm liệu trình",
    X_APPOINTMENTS_PENDING: "{{X}} lịch hẹn đang chờ",
    X_MODALITIES_INCLUDES: "Bao gồm {{X}} phương thức điều trị",
    ARE_U_SURE_TO_ACCEPT_THIS_APPOINTMENT_SCHEDULE:
      "Bạn có chắc chắn muốn chấp nhận lịch hẹn này không?",
    OVERBOOKING_ACCEPTED: "Đã chấp nhận lịch trùng",
    RESCHEDULE_SUCCESS: "Đổi lịch thành công",
    AN_CONFIRMATION_SMS_WILL_SEND_TO_PATIENT_TO_CONFIRM_THE_RESCHEDULE:
      "Một tin nhắn SMS xác nhận sẽ được gửi lại cho bệnh nhân",
    CONTINUE: "Tiếp tục",
    VIEW_THIS_DATE_SCHEDULE: "Xem lịch của ngày này",
    PLS_NOTE_THIS_CLINIC_INFO_WILL_BE_SUBMITTED_FOR_APPROVAL:
      "Xin lưu ý thông tin phòng khám này sẽ được gửi để phê duyệt",
    YOU_WILL_BE_NOTIFIED_WHEN_APPROVAL_IS_DONE:
      "Bạn sẽ được thông báo khi việc phê duyệt hoàn tất",
    SUBMIT_CONFIRM: "Xác nhận gửi",
    PLEASE_FILL_IN_ALL_REQUIRED_FIELDS: "Vui lòng điền tất cả các trường bắt buộc",
    CLINIC_CREATE_REQUEST_SENT: "Đã gửi yêu cầu tạo phòng khám",
    UPDATE_CONFIRM: "Xác nhận cập nhật",
    ARE_YOU_SURE_TO_UPDATE_YOUR_CLINIC_INFO:
      "Bạn có chắc chắn muốn cập nhật thông tin phòng khám của mình không?",
    CLINIC_UPDATED: "Đã cập nhật thông tin phòng khám",
    CLOSED_CLINIC_SUCCESS: "Đã đóng phòng khám thành công",
    PROTECTED_PAGE: "Trang này yêu cầu quyền truy cập phòng khám",
    PROTECTED_PAGE_WARNING: "Bạn cần có quyền truy cập phù hợp để xem trang này.",
    TO_START_YOUR_WORK_PLS_IDENTIFY_YOUR_ROLE:
      "Để cung cấp cho bạn hướng dẫn chính xác, vui lòng chọn vai trò của bạn (Chủ phòng khám hoặc Chuyên viên).",
    IF_UR_CLINIC_OWNER: "Nếu bạn là chủ phòng khám / hành nghề cá nhân",
    IF_UR_CLINIC_OWNER_CREATE_UR_CLINIC:
      "Nếu bạn là chủ phòng khám / hành nghề cá nhân, vui lòng tạo phòng khám và thông tin liên quan. Sau này bạn có thể mời các thành viên phòng khám khác tham gia.",
    IF_UR_CLINIC_PRACTITIONER: "Nếu bạn là thành viên phòng khám",
    IF_UR_CLINIC_PRACTITIONER_SEARCH_FOR_THE_CLINIC_YOU_WISH_TO_JOIN_AND_SUBMIT_A_JOIN_REQUEST:
      "Nếu bạn là thành viên phòng khám, vui lòng tìm phòng khám bạn muốn tham gia và gửi yêu cầu tham gia.",
    SKIP_USER_GUIDE: "Bỏ qua hướng dẫn hệ thống",
    USER_GUIDE_WILL_GUIDE_THROUGH_HOW_AND_WHERE_TO_CREATE_JOIN_A_CLINIC:
      "Hướng dẫn người dùng sẽ chỉ cho bạn cách và nơi để tạo và tham gia phòng khám.",
    START_NOW: "Bắt đầu ngay",
    ACCEPT_INVITE: "Chấp nhận lời mời",
    ARE_YOU_SURE_TO_ACCEPT_INVITE:
      "Bạn có chắc chắn muốn chấp nhận lời mời từ phòng khám này không?",
    REJECT_INVITE: "Từ chối lời mời",
    ARE_YOU_SURE_TO_REJECT_INVITE:
      "Bạn có chắc chắn muốn từ chối lời mời từ phòng khám này không?",
    RESPONSE_SUCCESS: "Phản hồi thành công",
    JOIN_REQUEST_SENT: "Đã gửi yêu cầu tham gia",
    SEND_JOIN_REQUEST: "Gửi yêu cầu tham gia",
    JOIN_REQUEST_SENT_SHORT: "Đã gửi yêu cầu tham gia",
    REQUEST_ACCEPTED: "Đã chấp nhận yêu cầu",
    INVITATION_SENT: "Đã gửi lời mời",
    NO_PACKAGES: "Không có gói",
    X_PRACTITIONERS_ARE_NOW_INACTIVE: "{{X}} chuyên viên hiện không hoạt động",
    ACTIVE_CONFIRM: "Xác nhận kích hoạt",
    ACTIVATE: "Kích hoạt",
    INACTIVE_CONFIRM: "Xác nhận ngừng hoạt động",
    ARE_YOU_SURE_TO_INACTIVE: "Bạn có chắc chắn muốn đặt thành không hoạt động không?",
    INACTIVE_PRACTITIONERS_ARE_NOT_ALLOWED_TO_BE_BOOKED_BY_PATIENT:
      "Chuyên viên không hoạt động không thể được bệnh nhân đặt lịch",
    REJECTED: "Đã từ chối",
    RESUBMIT: "Gửi lại",
    DELETE_APPLICATION: "Xóa đơn",
    ARE_YOU_SURE_TO_DELETE_THIS_APPLICATION:
      "Bạn có chắc chắn muốn xóa đơn này",
    REBUILD_CLINIC: "Gửi lại phòng khám",
    DELETE_APPLICATION_SUCCESS: "Đã xóa đơn thành công",
    SEARCH_CLINIC_BY_NAME: "Tìm phòng khám theo tên",
    OTHER_PRACTITIONERS_ARE_NO_VISIBLE:
      "Các chuyên viên khác không hiển thị với những người không làm việc tại phòng khám",
    DECLINE_JOIN_INVITATION_CONFIRM: "Xác nhận từ chối lời mời tham gia",
    ARE_YOU_SURE_TO_CANCEL_QUIT_FROM_CLINIC:
      "Bạn có chắc chắn muốn hủy việc rời khỏi phòng khám không?",
    SECTION_UNPUBLISHED: "Đã hủy xuất bản mục",
    SECTION_PUBLISHED: "Đã xuất bản mục",
    REFRESH: "Làm mới",
    CHANGE_THIS_BOOKING_DURATION: "Thay đổi thời lượng lịch hẹn này",
    ARE_YOU_SURE_TO_CHANGE_THIS_APPOINTMENT_DURATION_FOR_X:
      "Bạn có chắc chắn muốn thay đổi thời lượng lịch hẹn này cho {{X}} không?",
    BOOKING_DURATION_ADJUST_SUCCESS: "Đã điều chỉnh thời lượng lịch hẹn thành công",
    NO_PENDING_APPOINTMENTS: "Không có lịch hẹn đang chờ",
    ASSIGN_OWNERSHIP: "Đặt người dùng này làm đồng sở hữu phòng khám",
    STOP_BEING_CLINIC_OWNER: "Không còn là chủ sở hữu phòng khám",
    CONFIRM_TO_ADD_CLINIC_CO_OWNER: "Bạn có chắc chắn muốn đặt {{name}} làm đồng sở hữu phòng khám không?",
    CLINIC_CO_OWNER_ADDED_SUCCESS: "Đã thêm đồng sở hữu phòng khám thành công",
    TRANSFER_OWNERSHIP: "Chuyển quyền sở hữu",
    CONFIRM_TO_TRANSFER_CLINIC_OWNERSHIP: "Bạn có chắc chắn muốn chuyển quyền sở hữu phòng khám cho {{name}} không?",
    CLINIC_OWNERSHIP_TRANSFERRED_SUCCESS: "Đã chuyển quyền sở hữu phòng khám thành công",
    TRANSFER_OWNERSHIP_AND_QUIT_CLINIC: "Chuyển quyền sở hữu & rời phòng khám",
    SELECT_A_SUCCESSOR_TO_TRANSFER_OWNERSHIP_AND_QUIT_HINT: "Chọn một chuyên viên để chuyển quyền sở hữu phòng khám. Sau khi chuyển thành công, bạn sẽ rời khỏi phòng khám này.",
    CLINIC_OWNERSHIP_TRANSFERRED_AND_QUIT_SUCCESS: "Đã chuyển quyền sở hữu và rời khỏi phòng khám",
    CONFIRM_TO_EXIT_CLINIC_OWNERSHIP: "Bạn có chắc chắn không muốn tiếp tục sở hữu {{name}} không?",
    EXIT_CLINIC_OWNERSHIP_SUCCESS: "Bạn không còn là chủ sở hữu phòng khám này",
    CANNOT_EXIT_OWNERSHIP_NO_OTHER_OWNER:
      "Bạn hiện là chủ sở hữu duy nhất của phòng khám này nên không thể ngừng làm chủ sở hữu. Nếu muốn ngừng hoạt động phòng khám này, vui lòng dùng \"Đóng phòng khám\" thay thế.",
    ARE_YOU_SURE_TO_ASSIGN_OWNERSHIP_TO:
      "Bạn có chắc chắn muốn gán quyền sở hữu cho",
    YOU_WILL_BE_LOST_ALL_OWNER_PERMISSIONS_IN_THIS_CLINIC:
      "Bạn sẽ mất tất cả quyền chủ sở hữu tại phòng khám này",
    ACTIONS_REQUIRED_OWNER_PERMISSION:
      "Hành động này yêu cầu quyền của chủ sở hữu",
    SUBSCRIBE_PACKAGE_TO_UNLOCK_FEATURE:
      "Vui lòng nâng cấp hoặc đăng ký để mở khóa quyền truy cập",
    FEATURE_LOCKED: "Dịch vụ hiện đang bị khóa",
    PAY_SUCCESSFUL: "Thanh toán thành công",
    OWNER_CHANGED: "Đã thay đổi quyền sở hữu",
    VIEW_PATIENT_INFO: "Xem thông tin bệnh nhân",
    CLINIC_QR_CODE: "Mã QR lịch hẹn",
    APPOINTMENT_QR_CODE: "Quét để đặt lịch",
    DOWNLOAD: "Tải xuống",
    SIGNATURE: "Chữ ký",
    MANAGE_YOUR_SIGNATURE: "Quản lý chữ ký của bạn",
    UPLOAD_SIGNATURE_FROM_DEVICE: "Tải lên tệp chữ ký từ thiết bị",
    VIEW_SIGNATURE: "Tải xuống chữ ký",
    SIGNATURE_USAGE_MSG:
      "Chữ ký của bạn sẽ được dùng để ký tự động khi kê đơn thuốc.",
    UPLOAD_SIGNATURE_CONSENT:
      "Bằng việc tải lên chữ ký, bạn đồng ý cho việc sử dụng nó trong hệ thống Healthnex khi áp dụng.",
    ARE_YOU_SURE_TO_CLEAR_ALL_SELECTED_ITEMS:
      "Bạn có chắc chắn muốn xóa tất cả các mục đã chọn không?",
    RECORD_VIDEO: "Quay video",
    NO_RESULTS_FOUND: "Không tìm thấy kết quả",
    PRESS_ENTER_TO_CREATE: "Nhấn Enter để tạo",
    CREATING: "Đang tạo",
    CREATE_CLINIC_ITEM: "Tạo mục phòng khám",
    NAME_CN: "Tên (tiếng Trung)",
    NAME_EN: "Tên (tiếng Anh)",
    CREATE: "Tạo",
    YOU_CAN_EDIT_THIS_LATER:
      "Bây giờ bạn chỉ cần cung cấp tên. Bạn có thể hoàn thành chi tiết của mục phòng khám này sau trong phần Quản lý tài nguyên phòng khám.",
    OPTION: "Tùy chọn",
    CONFIGURE_CLINIC_OPTION: "Cấu hình tùy chọn phòng khám",
    CLINIC_OPTIONS: "Tùy chọn phòng khám",
    OPTION_ITEM_INFO: "Thông tin mục tùy chọn",
    ADD_ITEM: "Thêm mục",
    PLZ_INPUT_ITEM_NAME_CN: "Vui lòng nhập tên mục bằng tiếng Trung",
    PLZ_INPUT_ITEM_NAME_EN: "Vui lòng nhập tên mục bằng tiếng Anh",
    PLZ_INPUT_ITEM_NAME_X: "Vui lòng nhập tên mục bằng {{X}}",
    SEARCH_OPTION_ITEM_NAME: "Tìm tên mục tùy chọn",
    SIGN_AND_UPLOAD: "Ký và Tải lên",
    DRAW_YOUR_SIGNATURE: "Vẽ chữ ký của bạn",
    SIGNATURE_UPLOADED: "Đã tải lên chữ ký",
    SIGNATURE_DELETED: "Đã xóa chữ ký",
    NO_RECORDS_FOUND: "Không tìm thấy hồ sơ",
    CLINIC_POINT_GROUPS: "Nhóm huyệt phòng khám",
    CONFIGURE_CLINIC_POINT_GROUPS: "Cấu hình nhóm huyệt phòng khám",
    ADD_POINT_GROUP: "Thêm nhóm huyệt",
    ALL_POINTS_IN_X_HAS_ADDED: "Đã thêm tất cả huyệt trong {{X}}",
    POINT_GROUPS_NAME: "Tên nhóm huyệt",
    POINT_GROUPS_NAME_IN_X: "Tên nhóm huyệt({{X}})",
    POINT_GROUP_INFO: "Thông tin nhóm huyệt",
    PLZ_INPUT_POINT_GROUP_NAME_CN:
      "Vui lòng nhập tên nhóm huyệt bằng tiếng Trung",
    PLZ_INPUT_POINT_GROUP_NAME_EN:
      "Vui lòng nhập tên nhóm huyệt bằng tiếng Anh",
    PLZ_INPUT_POINT_GROUP_NAME_X: "Vui lòng nhập tên nhóm huyệt bằng {{X}}",
    SEARCH_POINT_NAME_HERE: "Tìm tên huyệt tại đây",
    POINTS_IN_THIS_GROUP: "Huyệt trong nhóm này",
    ADD_TO_CLINIC_POINT_GROUPS: "Thêm vào nhóm huyệt phòng khám",
    NO_POINT_ADDED: "Chưa thêm huyệt",
    REMOVE_PRACTITIONER_SUCCESS: "Đã gỡ chuyên viên thành công",
    SEARCHING_CLINICS: "Đang tìm phòng khám...",
    INVITE_SUCCESS: "Đã gửi lời mời thành công",
    ITEM_CREATED: "Đã tạo mục thành công",
    PRACTITIONER_QUIT_REJECTED: "Đã từ chối yêu cầu nghỉ của chuyên viên",
    PRACTITIONER_QUIT_ACCEPTED: "Đã chấp nhận yêu cầu nghỉ của chuyên viên",
    PLEASE_ADD_AT_LEAST_ONE_HERB: "Vui lòng thêm ít nhất một dược liệu",
    PLEASE_ADD_AT_LEAST_ONE_POINT: "Vui lòng thêm ít nhất một huyệt",
    INSURANCE_INFO_UPDATED: "Đã cập nhật thông tin bảo hiểm",
    REPORTING: "Báo cáo",
    CHECK_YOUR_REPORTING: "Kiểm tra báo cáo của bạn",
    CLINIC_REPORTING: "Báo cáo phòng khám",
    CHECK_YOUR_CLINIC_REPORTING: "Kiểm tra báo cáo phòng khám của bạn",
    SELECT_DEFAULT_DATE_UNIT: "Chọn đơn vị ngày mặc định",
    DAY: "Ngày",
    MONTH: "Tháng",
    YEAR: "Năm",
    PATIENTS_AND_REVENUE: "Bệnh nhân & Doanh thu",
    PATIENTS: "Bệnh nhân",
    REVENUE: "Doanh thu",
    PEOPLE_UNIT: "người",
    AVERAGE_REVENUE: "Doanh thu trung bình",
    PLEASE_SELECT_VALID_DATE_RANGE_90_DAYS:
      "Vui lòng chọn khoảng ngày hợp lệ trong vòng 90 ngày",
    PLEASE_SELECT_VALID_DATE_RANGE_36_MONTHS:
      "Vui lòng chọn khoảng ngày hợp lệ trong vòng 36 tháng",
    PLEASE_SELECT_VALID_DATE_RANGE_10_YEARS:
      "Vui lòng chọn khoảng ngày hợp lệ trong vòng 10 năm",
    PRINT_INSTRUCTION: "Tải xuống đơn thuốc",
    PRINT_TCM_INSTRUCTION: "Tải đơn Đông y",
    PRINT_MASSAGE_INSTRUCTION: "Tải hướng dẫn huyệt",
    MAXIMUM_NUMBER_OF_USERS: "Đã đạt số lượng người dùng tối đa",
    HERB_WITH_ZERO_RAW_EXISTS_PLS_CHECK:
      "Liều lượng không thể bằng không. Vui lòng kiểm tra đơn thuốc của bạn.",
    NO_GST: " (chưa bao gồm GST)",
    INC_GST: " (đã bao gồm GST)",
    PRESCRIPTION_RECORDS: "Hồ sơ đơn thuốc",
    CLINIC_SERVICES: "Dịch vụ phòng khám",
    LOADING_SERVICES: "Đang tải dịch vụ",
    AND_OTHER_COUNT: " và {{count}} mục khác",
    WHO_IS_THIS_APPOINTMENT_FOR: "Lịch hẹn này dành cho ai?",
    MYSELF: "Bản thân tôi",
    SOMEONE_ELSE: "Người khác",
    ABOUT_YOU: "Về bạn",
    ABOUT_THE_PATIENT: "Về bệnh nhân",

    PREVIOUS: "Trước",
    APPROVED: "Đã duyệt",
    I_AGREE_TO_RECEIVE_SMS: "Tôi đồng ý nhận thông báo SMS về các cập nhật của lịch hẹn này.",
    I_AGREE_TO_RECEIVE_SMS_EMAIL: "Tôi đồng ý nhận thông báo SMS / email về các cập nhật của lịch hẹn này.",
    SELECT_PRACTITIONER: "Chọn chuyên viên",
    CREATE_APPOINTMENT: "Lịch hẹn",
    ADD_APPOINTMENT: "Tạo lịch hẹn",
    NO_AVAILABLE_CLINIC: "Không có phòng khám khả dụng",
    NO_SERVICES_AVAILABLE: "Không có dịch vụ khả dụng",
    IS_ALREADY_BOOKED: "đã được người khác đặt",
    TIME_ALREADY_BOOKED: "Thời gian đã được đặt",
    YOU_NEED_TO_WAIT_FOR_THE_PRACTITIONER_TO_CONFIRM:
      "Lịch hẹn này gây trùng lịch, nhưng vì được chính bạn (chuyên viên) tạo, nó sẽ được hệ thống tự động phê duyệt.",
    ARE_YOU_SURE_YOU_WANT_TO_BOOK_THIS_TIME:
      "Bạn có chắc chắn muốn đặt thời gian này không?",
    PLEASE_SELECT_AT_LEAST_ONE_SERVICE: "Vui lòng chọn ít nhất một dịch vụ",
    May: "Tháng Năm",
    June: "Tháng Sáu",
    July: "Tháng Bảy",
    August: "Tháng Tám",
    September: "Tháng Chín",
    October: "Tháng Mười",
    November: "Tháng Mười Một",
    December: "Tháng Mười Hai",
    January: "Tháng Một",
    February: "Tháng Hai",
    March: "Tháng Ba",
    April: "Tháng Tư",
    Mon: "T2",
    Tue: "T3",
    Wed: "T4",
    Thu: "T5",
    Fri: "T6",
    Sat: "T7",
    Sun: "CN",
    Jan: "Th1",
    Feb: "Th2",
    Mar: "Th3",
    Apr: "Th4",
    Jun: "Th6",
    Jul: "Th7",
    Aug: "Th8",
    Sep: "Th9",
    Oct: "Th10",
    Nov: "Th11",
    Dec: "Th12",
    REMEDIAL_MASSAGE: "Xoa bóp trị liệu",
    REMEDIAL_MASSAGE_OPTION: "Xoa bóp trị liệu",
    DEEP_TISSUE_MASSAGE: "Massage mô sâu",
    SPORTS_MASSAGE: "Massage thể thao",
    DRY_NEEDLING: "Liệu pháp kim khô",
    CUPPING: "Giác hơi",
    PREGNANCY_MASSAGE: "Massage cho phụ nữ mang thai",
    MYOTHERAPY: "Liệu pháp cơ",
    ASSISTED_STRETCHING: "Kéo giãn có hỗ trợ",
    TRIGGER_PT_THERAPY: "Liệu pháp điểm kích hoạt",
    MYOFASCIAL_RELEASE: "Giải phóng cân cơ",
    JOINT_MOBILISATION: "Vận động khớp",
    PHYSIO: "Vật lý trị liệu",
    CHIRO: "Nắn chỉnh cột sống",
    BEAUTY: "Chăm sóc sắc đẹp",
    COSMETIC_MEDICINE: "Thẩm mỹ y khoa",

    SELECT_SERVICE: "Chọn dịch vụ {{service}}",
    MAXIMUM_NUMBER_OF_FILES: "Đã đạt số lượng tệp tối đa ({{X}})",
    MULTIPLE_SELECT: "Chọn nhiều",
    CANCEL_MULTIPLE_SELECT: "Hủy chọn nhiều",
    ARE_YOU_SURE_TO_DELETE_THIS_APPOINTMENT_FOR_X:
      "Bạn có chắc chắn muốn xóa lịch hẹn này cho {{X}} không? Một thông báo hủy sẽ được gửi đến bệnh nhân.",
    DELETE_APPOINTMENT: "Xóa lịch hẹn",
    REJECT_APPOINTMENT: "Từ chối lịch hẹn",
    SYSTEM_OPTIMIZED_FOR_DESKTOP: "Hệ thống này được tối ưu hóa cho việc sử dụng trên máy tính.",
    RECOMMEND_DESKTOP_FOR_BEST_EXPERIENCE:
      "Để có trải nghiệm tốt nhất, chúng tôi khuyên bạn nên truy cập trang web qua cổng máy tính.",
    PROMOTION_CODE: "Mã khuyến mãi",
    PLEASE_SELECT_VALID_DATE_RANGE: "Vui lòng chọn khoảng ngày hợp lệ.",
    PLEASE_CHECK_THE_FORM: "Vui lòng kiểm tra biểu mẫu.",
    TIMESLOT_HAS_BOOKED_BY_OTHER_PATIENT:
      "Khung giờ này đã được một bệnh nhân khác đặt.",
    NO_AVAILABLE_TIMESLOT_FOUND_IN_THIS_DATE:
      "Không có khung giờ khả dụng cho ngày này",
    APPOINTMENT_SCHEDULE_APPROVED: "Lịch hẹn đã được phê duyệt",
    FORGOT_PASSWORD: "Quên mật khẩu",
    WE_SENT_VERIFY_CODE_PLEASE_CHECK_YOUR_SMS:
      "Chúng tôi đã gửi một mã xác minh. Vui lòng kiểm tra SMS của bạn.",
    SEND_VERIFY_CODE: "Gửi mã xác minh",
    RESEND_VERIFY_CODE: "Gửi lại mã xác minh",
    PLEASE_ENTER_YOUR_VERIFICATION_CODE: "Vui lòng nhập mã xác minh của bạn",
    VERIFICATION_CODE: "Mã xác minh",
    PLEASE_ENTER_YOUR_NEW_PASSWORD: "Vui lòng nhập mật khẩu mới của bạn",
    PLEASE_ENTER_YOUR_NEW_PASSWORD_AGAIN: "Vui lòng nhập lại mật khẩu mới của bạn",
    NEW_PASSWORD: "Mật khẩu mới",
    SEND_TO: "Gửi đến",
    OR: "HOẶC",
    WE_WILL_SEND_VERIFY_CODE_PLEASE_CHECK_YOUR_SMS:
      "Chúng tôi sẽ gửi một mã xác minh. Vui lòng kiểm tra SMS của bạn.",
    WRONG_VERIFY_CODE: "Mã xác minh không đúng.",
    SMS_SEND_TOO_FREQUENT_WAIT_3_MIN_RETRY:
      "Gửi SMS quá thường xuyên. Vui lòng chờ 3 phút trước khi thử lại.",
    USERNAME_NOT_FOUND: "Không tìm thấy thông tin người dùng. Vui lòng kiểm tra lại thông tin nhập.",
    CHANGE_PASSWORD_SUCCESS: "Đã đổi mật khẩu thành công",
    SMS_SENT: "Đã gửi SMS",
    REQUEST_REJECTED: "Đã từ chối yêu cầu",
    INVITED_SUCCESS: "Đã gửi lời mời thành công",
    VIP_PACKAGE_EXPIRED:
      "Gói đăng ký VIP của bạn đã hết hạn hoặc đã bị vô hiệu hóa. Bạn không còn quyền truy cập trang này.",
    RECORDING_TOO_SHORT: "Bản ghi quá ngắn, không thể lấy được thông tin!",
    TRANSCRIPT_EMPTY_TRY_AGAIN: "Nội dung trống. Vui lòng thử lại.",
    MORNING: "Buổi sáng",
    AFTERNOON: "Buổi chiều",
    DOWNLOAD_INVOICE: "Tải hóa đơn",
    OTHER_PHOTO: "Ảnh khác",
    DIAGNOSIS_DESCRIPTION: "Mô tả",
    SET_AS_HOME: "Đặt làm trang khởi đầu",
    APPOINTMENT_DETAILS: "Chi tiết lịch hẹn",
    SEARCH_AND_USE_EXISTING_PATIENT_INFO:
      "Tìm và sử dụng thông tin bệnh nhân hiện có",
    OP_TYPE: "Loại tùy chọn",
    CANCEL_INVITATION: "Hủy lời mời",
    ARE_U_SURE_TO_CANCEL_THIS_INVITATION:
      "Bạn có chắc chắn muốn hủy lời mời này không?",
    ARE_YOU_SURE_TO_DELETE_X_ITEMS:
      "Bạn có chắc chắn muốn xóa {{X}} mục không?",
    PROFILE: "Hồ sơ",
    UPDATE: "Cập nhật",
    PROFILE_UPDATED: "Đã cập nhật hồ sơ",
    INVITE_PRACTITIONER_TO_JOIN_CLINIC:
      "Chuyên viên bạn tìm kiếm có thể chưa phải là người dùng của chúng tôi. Nhấp vào nút bên dưới để mời họ tạo tài khoản và tham gia phòng khám của bạn.",
    PRACTITIONER_U_SEARCHED_MAY_NOT_BE_USER_YET:
      "Chuyên viên bạn tìm kiếm có thể chưa phải là người dùng hệ thống của chúng tôi.",
    CLICK_BUTTON_BELOW_TO_INVITE:
      "Nhấp vào nút bên dưới để mời họ tạo tài khoản và tham gia phòng khám của bạn!",
    INVITE_NEW_USER: "Mời người dùng mới",
    NEW_REQUESTS: "Yêu cầu đang chờ",
    PLZ_SIGN_IN: "Vui lòng đăng nhập trước",
    SELECT_YOUR_SPECIALTY: "Vui lòng chọn loại dịch vụ của bạn",
    EXPIRED_AT: "Hết hạn lúc",
    PENDING_USER_SIGNUP: "Đang chờ người dùng đăng ký",
    RESEND_EMAIL: "Gửi lại email",
    RESEND_EMAIL_SUCCESS: "Đã gửi email thành công",
    DAYS_LEFT_X: "Hết hạn sau {{X}} ngày",
    ASSIGN_A_PACKAGE: "Gán một gói cho chuyên viên này",
    ASSIGN_A_ROLE: "Gán một vai trò",
    PATIENT_CONSENT: "Phiếu đồng ý của bệnh nhân",
    PLEASE_SELECT_A_PACKAGE: "Vui lòng chọn một gói",
    REJECT_SUCCESS: "Đã từ chối yêu cầu",
    ACCEPT_SUCCESS: "Đã chấp nhận yêu cầu",
    ARE_YOU_SURE_TO_DELETE_THIS_TEST: "Bạn có chắc chắn muốn xóa xét nghiệm này không?",
    FILE_TOO_LARGE_MAX_100MB:
      "Tệp quá lớn. Kích thước tối đa cho phép là 100MB.",
    BEST_UPLOAD_PRACTICE:
      "Để có trải nghiệm tốt nhất, vui lòng giữ mỗi tệp dưới 100MB và đảm bảo các video được quay lý tưởng nhất là trong vòng 30 giây.",
    REVIEW_REVIEW: "Đánh giá",
    CAN_NOT_START_WITH_NUMBER: "Không thể bắt đầu bằng chữ số",
    PACKAGE_NAME: "Tên gói",
    OG_PRICE: "Giá gốc",
    INSURANCE_NAME: "Tên bảo hiểm",
    USER_ALREADY_BEEN_TAKEN:
      "Tên đăng nhập đã được sử dụng, vui lòng thử tên khác.",
    INVALID_FORMAT:
      "Tên đăng nhập có thể không hợp lệ (ví dụ: tên đăng nhập không thể bắt đầu bằng chữ số hoặc chứa khoảng trắng)",
    LOGIN_USERNAME: "Tên đăng nhập",
    CONNECT_FAILED: "Không thể kết nối với dịch vụ AI",
    CONNECTING_AI: "Đang kết nối với AI",
    U_CAN_NOW_START_SPEAKING: "Bây giờ bạn có thể bắt đầu nói",
    UNIT_NO_SHOP_NO: "Số căn/Số cửa hàng",
    STREET_NO: "Số nhà",
    STREET_NAME: "Tên đường",
    CLINIC_NAME_IS_REQUIRED: "Bắt buộc nhập tên phòng khám",
    CLINIC_CREATED: "Đã tạo phòng khám",
    PERSONAL_WEB: "Trang của tôi",
    SLUG_CHAR_TYPE_LIMIT: "Chỉ cho phép chữ cái, chữ số và ‘-’.",
    CHECK_THIS_CLINIC_PACKAGES: "Kiểm tra các gói hiện tại của phòng khám này",
    TYPE_TO_SEARCH: "Nhập để tìm kiếm",
    PLEASE_ENTER_VALID_PHONE_NUMBER: "Vui lòng nhập số điện thoại hợp lệ",
    NO_AVAILABLE_PACKAGES: "Không tìm thấy gói khả dụng",
    PLEASE_PURCHASE_PACKAGE_FIRST:
      "Vui lòng mua gói VIP trước khi mời người dùng",
    ASSIGNED_TO: "Gán cho",
    PERSONAL: "Người dùng cá nhân (Bản thân tôi)",
    RECEIPT_GENERATING: "Đang tạo biên lai",
    RECEIPT_GENERATING_PLZ_WAIT: "Đang tạo biên lai, vui lòng chờ.",
    INSTRUCTION_GENERATING: "Đang tạo hướng dẫn",
    STREET_TYPE: "Loại đường",
    SUMMARY: "Xem lại & Tóm tắt",
    FEATURE_PREVIEW_VIDEO_NOTE:
      "Video này là bản xem trước tính năng. Mua gói VIP tương ứng để mở khóa chức năng này.",
    FEATURE_PURCHASE_HINT_FOR_CLINIC_OWNER:
      "Nếu bạn là chủ phòng khám, vui lòng nhấp vào nút bên dưới để mua.",
    TODAY: "Hôm nay",
    CLOSED_TODAY: "Hôm nay không làm việc tại đây",
    GENERATING_NEW_WINDOW_MSG:
      "Tệp sẽ mở trong cửa sổ mới. Vui lòng kiểm tra cài đặt trình duyệt và cho phép cửa sổ bật lên.",
    DISCONNECTED_SUCCESSFULLY: "Đã ngắt kết nối thành công",
    PATIENT_VISIT_FLOW: "Hướng dẫn quy trình khám của bệnh nhân",
    PATIENT_CHECKIN_AND_VISIT:
      "Tổng quan về toàn bộ quy trình khám của bệnh nhân, bao gồm cả tình huống có lịch hẹn và khách vãng lai, nhận khám, tạo hồ sơ và nhập tư vấn.",
    SYSTEM_SETTING_SUMMARY: "Hướng dẫn tổng quan cài đặt hệ thống",
    SYSTEM_SETTING_OVERVIEW:
      "Tổng quan nhanh về các tính năng cấu hình chính và điểm truy cập trong Healthnex.",
    SYSTEM_SETTING_WORK_TIME_SETTING:
      "Cài đặt hệ thống - Hướng dẫn cài đặt thời gian làm việc",
    SYSTEM_SETTING_WORKTIME:
      "Hướng dẫn từng bước về cách thiết lập và quản lý lịch làm việc của chuyên viên trong hệ thống.",
    APPOINTMENT_SUMMARY: "Hướng dẫn tổng quan lịch hẹn",
    APPOINTMENT_SUMMARY_DESCRIPTION:
      "Tổng quan về cách lịch hẹn hoạt động trong Healthnex và các cách khác nhau để tạo chúng.",
    APPOINTMENT_CREATE: "Lịch hẹn - Hướng dẫn tạo lịch hẹn",
    HOW_TO_CREATE_APPOINTMENT:
      "Hướng dẫn từng bước về cách tạo lịch hẹn cho bệnh nhân, bao gồm chọn dịch vụ, chuyên viên và khung giờ. Tìm hiểu cách tạo lịch hẹn qua cổng chuyên viên, trang web cá nhân, hoặc trang chủ Healthnex.",
    APPOINTMENT_MANAGE: "Lịch hẹn - Hướng dẫn quản lý lịch hẹn",
    VIEW_EDIT_CANCEL_APPOINTMENT:
      "Tìm hiểu cách xem, chỉnh sửa, đổi lịch và hủy lịch hẹn trong hệ thống Healthnex.",
    PRESCRIPTION_SUMMARY: "Hướng dẫn tổng quan đơn thuốc",
    PRESCRIPTION_SUMMARY_DESCRIPTION:
      "Tổng quan về quy trình tư vấn và kê đơn thông minh cùng năm bước chính của nó.",
    PRESCRIPTION_SYMPTOM: "Đơn thuốc - Hướng dẫn triệu chứng",
    PRESCRIPTION_SYMPTOM_DESCRIPTION:
      "Ghi nhanh các triệu chứng của bệnh nhân bằng giọng nói hoặc văn bản, với cấu trúc hóa và dịch thuật hỗ trợ bằng AI.",
    PRESCRIPTION_DIAGNOSIS: "Đơn thuốc - Hướng dẫn chẩn đoán",
    PRESCRIPTION_DIAGNOSIS_DESCRIPTION:
      "Ghi nhận các đánh giá lâm sàng, chọn nguyên tắc điều trị và tạo nội dung chẩn đoán chuẩn hóa.",
    PRESCRIPTION_TREATMENT: "Đơn thuốc - Hướng dẫn điều trị",
    PRESCRIPTION_TREATMENT_DESCRIPTION:
      "Chọn các phương pháp điều trị như thuốc thảo dược hoặc châm cứu, hoàn thành đơn thuốc và lưu các mẫu phòng khám có thể tái sử dụng.",
    PRESCRIPTION_PAYMENT: "Đơn thuốc - Hướng dẫn thanh toán",
    PRESCRIPTION_PAYMENT_DESCRIPTION:
      "Xem lại các khoản phí, áp dụng bảo hiểm nếu có và hoàn tất thanh toán cho lần khám.",
    PRESCRIPTION_CONCLUSION: "Đơn thuốc - Hướng dẫn kết luận",
    PRESCRIPTION_CONCLUSION_DESCRIPTION:
      "Xem lại toàn bộ hồ sơ bệnh án, in đơn thuốc và biên lai, và hoàn tất lần khám.",
    PERSONAL_WEBSITE_SUMMARY: "Hướng dẫn tổng quan trang web cá nhân",
    PERSONAL_WEBSITE_OVERVIEW:
      "Tổng quan về trang web cá nhân của chuyên viên, bao gồm các mục hồ sơ và tính năng đặt lịch.",
    EDIT_AND_PUBLISH: "Trang web cá nhân - Hướng dẫn chỉnh sửa và xuất bản",
    EDIT_AND_PUBLISH_WEBSITE:
      "Hướng dẫn từng bước về cách chỉnh sửa nội dung trang web cá nhân, xem trước bố cục và xuất bản để bệnh nhân đặt lịch.",
    RESET_PASSWORD: "Đặt lại mật khẩu",
    PLEASE_ENTER_YOUR_CURRENT_PASSWORD: "Vui lòng nhập mật khẩu hiện tại của bạn",
    PLEASE_ENTER_DIFFERENT_PASSWORD:
      "Vui lòng nhập mật khẩu khác với mật khẩu hiện tại",
    CONFIG_PRINT_UNIT_IN_EACH_CMT:
      "Lưu ý: Đơn vị liều lượng được in sẽ tuân theo cài đặt trong mỗi đơn thuốc Đông y riêng lẻ.",

    AT_LEAST_ONE_PRINT_OPTION_REQUIRED:
      "Vui lòng chọn ít nhất một đơn vị để hiển thị.",

    CHECKBOX_SHOW_RAW_UNIT_IN_PRINT:
      "Đánh dấu để hiển thị liều lượng dược liệu thô khi in.",

    CHECKBOX_SHOW_GRAN_UNIT_IN_PRINT:
      "Đánh dấu để hiển thị liều lượng thuốc cốm khi in.",
    SHOW_RAW_UNIT_IN_PRINT: "Hiển thị đơn vị dược liệu thô khi in",
    HIDE_RAW_UNIT_IN_PRINT: "Ẩn đơn vị dược liệu thô khi in",

    SHOW_GRAN_UNIT_IN_PRINT: "Hiển thị đơn vị thuốc cốm khi in",
    HIDE_GRAN_UNIT_IN_PRINT: "Ẩn đơn vị thuốc cốm khi in",

    CONNECTION_FAILED: "Kết nối thất bại",
    PURCHASED_AT: "Đã mua lúc",
    SELECTED: "Đã chọn",
    PERSONALIZATION: "Cá nhân hóa",
    PERSONALIZE_YOUR_SYSTEM: "Cá nhân hóa hệ thống của bạn",
    APPOINTMENT_TIMESLOT_STYLE: "Kiểu khung giờ lịch hẹn",
    DROPDOWN_STYLE: "Kiểu danh sách thả xuống",
    SLIDE_STYLE: "Kiểu nút",
    PERSONALIZE_YOUR_TIMESLOT_STYLE: "Cá nhân hóa kiểu khung giờ của bạn",
    FORM_HAS_NOT_BEEN_SAVED_U_SURE_LEAVE_NOW:
      "Biểu mẫu này chưa được lưu, bạn có chắc chắn muốn rời đi ngay bây giờ không?",
    PAGE_NOT_FOUND: "Không tìm thấy trang",
    THE_REQUESTED_PAGE_COULD_NOT_BE_LOCATED:
      "Không thể tìm thấy trang được yêu cầu",
    WE_COULDNT_FIND_THE_PAGE_YOU_ARE_LOOKING_FOR_IT_MAY_HAVE_BEEN_MOVED_DELETED_OR_THE_URL_MIGHT_BE_INCORRECT:
      "Chúng tôi không tìm thấy trang bạn đang tìm. Trang có thể đã bị di chuyển, xóa, hoặc URL có thể không đúng.",
    WHAT_YOU_CAN_DO: "Bạn có thể làm gì",
    CHECK_THE_URL_FOR_TYPOS_AND_TRY_AGAIN:
      "Kiểm tra lỗi chính tả trong URL và thử lại",
    USE_THE_NAVIGATION_MENU_TO_FIND_WHAT_YOU_NEED:
      "Sử dụng menu điều hướng để tìm những gì bạn cần",
    CONTACT_SUPPORT_IF_THE_PROBLEM_PERSISTS:
      "Liên hệ bộ phận hỗ trợ nếu sự cố vẫn tiếp diễn",
    NEED_ASSISTANCE_CONTACT_SYSTEM_SUPPORT:
      "Cần hỗ trợ? Liên hệ với chúng tôi qua trang web chính thức của Healthnex",
    GO_TO_LOGIN: "Đến trang đăng nhập",
    CUSTOMER_SERVICE: "Dịch vụ khách hàng",
    TECHNICAL_SUPPORT: "Hỗ trợ kỹ thuật",
    PATIENT_LIST: "Danh sách bệnh nhân",
    CREATED_AT: "Tạo lúc",
    FILTER_BY_LAST_NAME: "Lọc theo họ",
    TOTAL_PATIENTS: "Tổng số bệnh nhân",
    THIS_IS_A_X_USER_PACKAGE: "Gói {{X}} người dùng",
    THIS_IS_A_X_USER_PACKAGE_MSG:
      "Gói này được định giá cho {{X}} người dùng và đã bao gồm chiết khấu trọn gói.",
    X_USERS_PER_YEAR: "{{X}} người dùng / năm",
    X_USERS_PER_Y_YEAR: "{{X}} người dùng / {{Y}} năm",
    X_USERS_PER_MONTH: "{{X}} người dùng / tháng",
    SECTION_CHANGED_TO: "Mục đã chuyển sang",
    OTHER_NON_ENGLISH_PATIENT_FIRST_NAME: "Tên khác không phải tiếng Anh",
    WELCOME_TO_HEATHNEX: "Chào mừng đến với Healthnex!",
    THIS_PLATFORM_IS_DESIGNED_TO_PROVIDE_A_MODERN_AND_EFFICIENT_WAY_TO_MANAGE_YOUR_CLINIC_PRESCRIPTION:
      "Healthnex là nền tảng quản lý lâm sàng hiện đại được thiết kế để tinh giản quy trình kê đơn và nâng cao hiệu quả thực hành hằng ngày.",
    ALSO_AIMS_TO_BUILD_ALL_IN_ONE_PLATFORM_FOR_MODERN_TCM_PRACTICES:
      "Được xây dựng riêng cho các chuyên viên Y học cổ truyền Trung Hoa (TCM), Healthnex tích hợp quản lý đơn thuốc, lập kế hoạch điều trị và hồ sơ lâm sàng vào một hệ thống thống nhất.",
    TO_START_LET_US_QUICK_INTRODUCE_WUT_WE_HAVE_IN_THIS_SYSTEM:
      "Hãy cùng tham quan nhanh để giúp bạn bắt đầu.",
    SYSTEM_NOTICE: "Thông báo hệ thống",
    THIS_REQUIRED_U_TO_HAVE_CLINIC_PACKAGE_SUBSCRIPTION:
      "Truy cập tính năng này yêu cầu đăng ký Gói phòng khám.",
    CURRENT_WORKING_CLINIC: "Phòng khám hiện tại",
    IF_U_WORKING_IN_MULTIPLE_CLINICS_YOU_CAN_SELECT_THE_CURRENT_WORKING_CLINIC_HERE:
      "Nếu bạn làm việc tại nhiều phòng khám, bạn có thể chọn phòng khám hiện tại tại đây.",
    UR_CURRENT_PACKAGE: "Gói đăng ký hiện tại",
    PACKAGE_SUBSCRIPTION_ALLOW_YOU_TO_ACCESS_PREMIUM_SERVICE:
      "Các gói đăng ký cấp quyền truy cập các tính năng cao cấp. Ví dụ, Gói phòng khám cho phép quản lý đơn thuốc và quản lý bệnh nhân, trong khi Gói trang web cá nhân cho phép bạn xuất bản một trang web cá nhân có thể truy cập công khai.",
    CHANGE_UR_SYSTEM_LANGUAGE_HERE: "Thay đổi ngôn ngữ hệ thống của bạn tại đây",
    ACCOUNT_MENU: "Menu tài khoản",
    U_CAN_VIEW_UPDATE_UR_ACCOUNT_DETAIL_HERE_LIKE_PASSWORD:
      "Xem và cập nhật thông tin tài khoản của bạn, bao gồm mật khẩu và cài đặt bảo mật.",
    VIEW_ALL_UR_PATIENTS_HERE:
      "Xem và quản lý tất cả bệnh nhân liên kết với phòng khám của bạn.",
    CREATE_JOIN_MANAGE_UR_CLINIC_HERE:
      "Tạo, tham gia hoặc quản lý phòng khám của bạn từ đây.",
    CONFIGURE_WORKING_TIME_IN_CLINIC_FOR_PATIENT_TO_SCHEDULE_APPOINTMENT:
      "Cấu hình giờ làm việc của phòng khám để bệnh nhân có thể đặt lịch hẹn.",
    THIS_REQUIRED_U_TO_HAVE_PERSOANL_WEBSITE_PACKAGE_SUBSCRIPTION_TO_PUBLISH:
      "Việc xuất bản yêu cầu đăng ký Gói trang web cá nhân đang hoạt động.",
    MORE_TUTORIALS_TO_FOLLOW: "Thêm hướng dẫn để theo dõi",
    ALTERNATIVELY_HERE_YOU_CAN_FIND_MORE_TUTORIALS_TO_FOLLOW_ABOUT_HOW_TO_USE_THIS_PLATFORM_IN_DETAIL:
      "Khám phá các hướng dẫn từng bước để giúp bạn hiểu rõ hơn và sử dụng nền tảng.",
    VER: "Phiên bản ",
    URL_NOT_SET: "Chưa đặt URL",
    TCM_MODE: "Chế độ chẩn đoán chi tiết",
    ACUPUNCTURE_MASSAGE_MEDICINE_MODE: "Chế độ Châm cứu & Xoa bóp",
    THIS_PACKAGE_IS_NOT_LONGER_PROVIDED_PLS_CHOOSE_ANOTHER_PACKAGE:
      "Gói này không còn khả dụng để gia hạn",
    LOADING_PACKAGES: "Đang tải gói",
    OWNER_BUSINESS_SIGNUP: "Chủ cơ sở kinh doanh",
    CMBA_INFO: "Thông tin CMBA",
    CMBA_NUMBER: "Số CMBA",
    PLEASE_ENTER_YOUR_CMBA_NUMBER_HERE: "Vui lòng nhập số CMBA của bạn tại đây",
    NOTE_YOUR_CMBA_NUMBER_WILL_BE_SHOWN_ON_THE_MEDICAL_INVOICE:
      "Lưu ý: Số CMBA bạn nhập sẽ được hiển thị trên biên lai đơn thuốc.",
    UPDATING_CMBA_INFO: "Đang cập nhật thông tin CMBA",
    CMBA_INFO_UPDATED: "Đã cập nhật thông tin CMBA",
    PLEASE_ENTER_YOUR_CMBA_NUMBER: "Vui lòng nhập số CMBA của bạn",
    U_CAN_ENTER_MODIFY_UR_CMBA_NUMBER_HERE:
      "Bạn có thể nhập hoặc chỉnh sửa số CMBA của mình tại đây",
    VIEW_EDIT_INSURANCE: "Xem / Chỉnh sửa bảo hiểm",
    IF_U_NEED_TO_RENEW_PLS_CONTACT_CLINIC_OWNER:
      "Nếu bạn cần gia hạn hoặc đăng ký gói mới, vui lòng liên hệ chủ phòng khám.",
    INVITE_U_TO_JOIN_THE_CLINIC: "Mời bạn tham gia phòng khám",
    U_HAD_LEFT_FROM_BELOW_CLINICS: "Bạn đã rời khỏi các phòng khám sau đây",
    GO_CLINIC: "Xem trong phòng khám",
    FROM_X_CLINIC: "Từ {{X}}",
    CREATED_IN_CLINIC: "Được tạo trong phòng khám",
    PLEASE_SELECT_A_PACKAGE_FOR_THIS_PRACTITIONER:
      "Vui lòng chọn một gói cho chuyên viên mới này:",
    NEW_DURATION: "Thời lượng",
    OTHER_PHONE: "Số điện thoại khác",
    GST_INCLUDED: "Đã bao gồm GST",
    SHOW_GST_DETAIL: "Hiển thị chi tiết GST",
    COLLAPSE: "Thu gọn",
    THIS_PRICE_INCLUDES_GST: "Giá này đã bao gồm GST",
    FILTER_BY_INSURANCE_PROVIDER: "Lọc theo quỹ y tế",
    FILTER_BY_COMPLETION_STATUS: "Lọc theo trạng thái hoàn tất",
    PATIENT_INSURANCES: "Bảo hiểm của bệnh nhân",
    OTHER_PROVIDERS: "Nhà cung cấp khác",
    WELCOME_BACK: "Chào mừng trở lại",
    CREATED_IN: "Được tạo trong",
    COLLAPSE_NAVIGATION: "Thu gọn điều hướng",
    EXPAND_NAVIGATION: "Mở rộng điều hướng",
    PRESCRIPTION_HISTORY: "Lịch sử đơn thuốc",
    SEARCH_HISTORY_BY_ID_OR_PATIENT_NAME:
      "Tìm hồ sơ theo mã hoặc tên bệnh nhân",
    VIEW_ALL_PRESCRIPTION_HISTORIES: "Xem hồ sơ đơn thuốc hôm nay / tất cả",
    SEARCH_PACKAGE_BY_ORDER_ID_PACKAGE_NAME:
      "Tìm gói theo mã đơn hàng / tên gói",
    ORDER_NUMBER: "Số đơn hàng",
    FILL_IN_DETAILS: "Điền chi tiết",
    NOT_SCHEDULED: "Chưa lên lịch",
    NO_CLINICS_TO_CREATE_OR_JOIN: "Không có phòng khám để tạo hoặc tham gia",
    ACU_POINT_INFO: "Thông tin huyệt châm cứu",
    ACU_POINT_CN: "Tên huyệt châm cứu (tiếng Trung)",
    ACU_POINT_EN: "Tên huyệt châm cứu (tiếng Anh)",
    PLZ_INPUT_ACU_POINT_CN: "Vui lòng nhập tên huyệt châm cứu bằng tiếng Trung",
    PLZ_INPUT_ACU_POINT_EN: "Vui lòng nhập tên huyệt châm cứu bằng tiếng Anh",
    PLZ_INPUT_ACU_POINT_X: "Vui lòng nhập tên huyệt châm cứu bằng {{X}}",
    ADD_ACU_POINT: "Thêm huyệt châm cứu",
    POINT_CREATED: "Đã tạo huyệt châm cứu",
    ONLY_PAID_HISTORY_WILL_BE_SHOWN_BELOW:
      "Lưu ý: Chỉ các hồ sơ đã thanh toán mới hiển thị bên dưới",
    ME_ONLY: "Chỉ tôi",
    PREFERRED_NAME: "Tên thường gọi",
    SELECT_PAIN_CONDITION: "Chọn tình trạng đau",
    CLICK_TO_ADD_CONDITION: "Nhấp để thêm tình trạng đau",
    SELECT_CATEGORY_BELOW_TO_ADD_CONDITION: "Chọn danh mục bên dưới để thêm tình trạng",
    PAIN_CONDITIONS: "Tình trạng đau",
    SELECT_POINTS_FOR_THIS_TREATMENT: "Chọn huyệt cho liệu trình này",
    THIS_IS_OPTIONAL:
      "Đây là tùy chọn, bạn có thể nhấp nút để bỏ qua bước này.",
    COMMON_ACU_GROUP_TITLE: "Nhóm huyệt châm cứu thường dùng",
    SEARCH_ACU_GROUP_PLACEHOLDER: "Tìm tên nhóm huyệt châm cứu",
    NO_ACU_GROUP_FOUND: "Không tìm thấy nhóm huyệt châm cứu",
    NO_TREATMENT_ADDED: "Chưa thêm liệu trình",
    TREATMENT_AMOUNT: "Số lượng liệu trình",
    ENTER_TREATMENT: "Nhập liệu trình",
    CLINIC_GROUP: "Nhóm phòng khám",
    FROM_RECORD: "Từ hồ sơ",
    X_RELATED_RECORDS: "{{X}} hồ sơ liên quan",
    RELATED_RECORDS: "Hồ sơ liên quan",
    REFRESHING: "Đang làm mới",
    CONFIGURE_PRODUCTS: "Cấu hình hạng mục dịch vụ & sản phẩm",
    SYSTEM_ACU_GROUP: "Nhóm huyệt châm cứu hệ thống",
    COMPLETED: "Đã hoàn thành",
    IS_RECORD_COMPLETED: "Hoàn tất hồ sơ",
    RECORD_INCOMPLETE: "Chưa hoàn tất",
    HIDE_INSTRUCTION: "Ẩn hướng dẫn",
    VIEW_INSTRUCTION: "Xem hướng dẫn",
    HIDE_DETAIL: "Ẩn chi tiết",
    PRICE_REQUIRED: "Giá hiện tại là 0",
    PLEASE_FILL_IN_TREATMENT_PRICE: "Vui lòng điền giá",
    TREATMENT_SUBTOTAL: "Tạm tính liệu trình",
    OTHER_FEE_SUBTOTAL: "Tạm tính phí khác",
    POINTS: "Huyệt",
    TREATMENT_INSTRUCTION: "Hướng dẫn điều trị",
    CONFIGURE_CLINIC_POINTS: "Cấu hình huyệt phòng khám",
    CLINIC_POINTS: "Huyệt phòng khám",
    POINTS_NAME: "Tên huyệt",
    POINTS_NAME_IN_X: "Tên huyệt ({{X}})",
    QUICK_PAY: "Tạo nhanh hồ sơ",
    TREATMENT_FEE: "Phí điều trị",
    UPLOAD_PHOTOS: "Tải lên ảnh",
    CLICK_TO_EXPAND: "Nhấp để mở rộng",
    CLICK_TO_COLLAPSE: "Nhấp để thu gọn",
    SELECT_TREATMENT_TYPE: "Chọn loại điều trị",
    QUICK_CREATE_TREATMENT: "Tạo nhanh liệu trình",
    SELECT_ACU_GROUP: "Chọn nhóm huyệt châm cứu",
    SELECT_TREATMENT: "Chọn liệu trình",
    NO_AVAILABLE_TREATMENT:
      "Chưa có danh mục dịch vụ massage hoặc châm cứu nào được cấu hình. Vui lòng cấu hình qua Healthnex bản máy tính → Quản lý phòng khám và nhân viên",
    NO_AVAILABLE_TREATMENTS:
      "Không có liệu trình khả dụng, vui lòng thêm dịch vụ cung cấp trong cài đặt phòng khám trước",
    FREQUENTLY_USED_ACU_GROUP: "Nhóm huyệt châm cứu sử dụng thường xuyên",
    USED: "Số lần sử dụng",
    MOST_USED: "Dùng nhiều nhất",
    EXPAND: "Mở rộng",
    FILTERED_BY_PAID_AT: "Lọc theo thời gian thanh toán",
    FILTERED_BY_CREATED_AT: "Lọc theo thời gian tạo",
    NO_NEW_PATIENT_CREATED_WITHIN_X:
      "Không có hồ sơ bệnh nhân mới nào được tạo trong khoảng {{X}}",
    NO_NEW_PRESCRIPTION_PAID_WITHIN_X:
      "Không có hồ sơ đơn thuốc mới nào được thanh toán trong khoảng {{X}}",
    HEAD_FACE: "Đầu/Mặt",
    SHOULDER_NECK_BACK: "Vai/Cổ/Lưng",
    ABDOMEN: "Bụng",
    HAND: "Bàn tay",
    LEG: "Chân",
    FOOT: "Bàn chân",
    WAIST: "Thắt lưng",
    SHOULDER_NECK: "Vai/Cổ",
    NECK_BACK: "Cổ/Lưng",
    ARM: "Cánh tay",
    YOU_HAVE_EXCEEDED_THE_MAXIMUM_NUMBER_OF_RETRIES:
      "Bạn đã vượt quá số lần thử tối đa, vui lòng thử lại sau.",
    PRESCRIPTION_NOT_READY:
      "Đơn thuốc chưa sẵn sàng, vui lòng thử lại sau.",
    PRODUCT_MANAGEMENT: "Quản lý sản phẩm & dịch vụ",
    SERVICE: "Dịch vụ",
    PRODUCT: "Sản phẩm",
    NO_SERVICE_FOUND: "Chưa thêm dịch vụ",
    NO_PRODUCT_FOUND: "Chưa thêm sản phẩm",
    CREATE_SERVICE_AND_PRODUCT: "Thêm hạng mục dịch vụ và sản phẩm dịch vụ",
    CREATE_SERVICE: "Thêm hạng mục dịch vụ",
    CREATE_PRODUCT: "Thêm sản phẩm dịch vụ",
    EDIT_SERVICE: "Chỉnh sửa hạng mục dịch vụ",
    EDIT_PRODUCT: "Chỉnh sửa sản phẩm dịch vụ",
    NO_SERVICE_OR_PRODUCT_FOUND:
      "Vui lòng chọn một hạng mục dịch vụ hiện có ở bên trái để xem, hoặc nhấp nút bên dưới để tạo hạng mục dịch vụ hoặc sản phẩm dịch vụ mới.",
    SERVICE_BASIC_INFO: "Thông tin cơ bản của hạng mục dịch vụ",
    SERVICE_DESCRIPTION: "Mô tả hạng mục dịch vụ",
    NAME_ENGLISH: "Tên (tiếng Anh)",
    NAME_CHINESE: "Tên (tiếng Trung)",
    DESCRIPTION_CHINESE: "Mô tả (tiếng Trung)",
    DESCRIPTION_ENGLISH: "Mô tả (tiếng Anh)",
    DETAILS: "Chi tiết",
    PRACTITIONERS_PRODUCT_SETTING: "Phân công chuyên viên",
    CONFIGURE_PRACTITIONERS_FOR_THIS_PRODUCT:
      "Cấu hình chuyên viên cho sản phẩm dịch vụ này",
    DEFAULT_PRICE: "Giá mặc định",
    ENABLED: "Đã bật",
    ENABLE: "Đã bật",
    CUSTOM_PRICE: "Giá tùy chỉnh",
    NEW_PRACTITIONERS_ARE_ABLED_BY_DEFAULT:
      "Chuyên viên mới được bật theo mặc định",
    CUSTOM_PRICE_OVERRIDES_DEFAULT_PRICE:
      "Giá tùy chỉnh ghi đè giá mặc định",
    LEAVE_CUSTOM_PRICE_EMPTY_TO_USE_DEFAULT_PRICE:
      "Để trống giá tùy chỉnh để dùng giá mặc định",
    PRODUCT_DESCRIPTION: "Mô tả sản phẩm dịch vụ",
    NO_MODALITY_SELECTED: "Chưa chọn loại dịch vụ",
    SERVICE_INFO: "Thông tin hạng mục dịch vụ",
    FIELDS_MARKED_WITH_ASTERISK_ARE_REQUIRED:
      "Các trường có dấu * là bắt buộc",
    SELECT_MODALITY: "Chọn loại dịch vụ",
    PLEASE_ENTER_NAME_ENGLISH: "Vui lòng nhập tên (tiếng Anh)",
    PLEASE_ENTER_NAME_CHINESE: "Vui lòng nhập tên (tiếng Trung)",
    PLEASE_ENTER_DESCRIPTION_ENGLISH: "Vui lòng nhập mô tả (tiếng Anh)",
    PLEASE_ENTER_DESCRIPTION_CHINESE: "Vui lòng nhập mô tả (tiếng Trung)",
    PRODUCT_INFO: "Thông tin sản phẩm dịch vụ",
    SELECT_SERVICE_TYPE: "Chọn loại dịch vụ",
    PRODUCT_NAME: "Tên sản phẩm dịch vụ",
    THIS_ITEM: "mục này",
    ASSIGN_PRACTITIONERS: "Phân công chuyên viên",
    BED_NUM_IF_APPLIED: "Sức chứa giường cho XB / CC (Nếu có)",
    BED_NUM_IF_APPLIED_DESCRIPTION:
      "Chỉ áp dụng khi gán các sản phẩm có thể đặt lịch cho thành viên phòng khám và phòng khám cần giới hạn sức chứa đồng thời theo số giường hoặc phòng có sẵn. Nếu phòng khám chỉ cung cấp dịch vụ YHCT, cài đặt này thường không cần thiết—để mặc định là 1. Giá trị tối thiểu là 1 giường.",
    WORK_CAPACITY: "Số khách phục vụ đồng thời tối đa (XB / CC)",
    WORK_CAPACITY_DES:
      "Đặt số lượng khách tối đa mà nhân viên này có thể phục vụ cùng lúc. Tối thiểu là 1, và không thể vượt quá sức chứa giường của phòng khám.",
    CASE_CREATED: "Đã tạo hồ sơ bệnh án",
    NO_AVAILABLE_TREATMENT_TYPE:
      "Không có phương thức điều trị nào khác được cấu hình. Sử dụng xoa bóp YHCT theo mặc định.",
    PATIENTS_CREATED_BY: "Bệnh nhân được tạo bởi",
    PRESCRIPTION_PAID_AT: "Thời gian chẩn đoán của hồ sơ",
    LEFT_ARM: "Cánh tay trái",
    RIGHT_ARM: "Cánh tay phải",
    LEFT_LEG: "Chân trái",
    RIGHT_LEG: "Chân phải",
    LEFT_HAND: "Bàn tay trái",
    RIGHT_HAND: "Bàn tay phải",
    LEFT_FOOT: "Bàn chân trái",
    RIGHT_FOOT: "Bàn chân phải",
    SERVICE_PRODUCT_LIST: "Danh sách sản phẩm dịch vụ của hạng mục dịch vụ này",
    ASSIGNED_PRACTITIONERS: "Số lượng chuyên viên được phân công",
    PRODUCT_SERVICE: "Thuộc về dịch vụ",
    ASSIGNED: "Đã phân công",
    UNASSIGNED: "Chưa phân công",
    ASSIGN_OR_NOT: "Phân công hay không",
    PLEASE_ENTER_NAME: "Vui lòng nhập tên",
    PLEASE_ENTER_DESCRIPTION: "Vui lòng nhập mô tả",
    SERVICE_NAME: "Tên hạng mục dịch vụ",
    PRODUCT_INCLUDED: "Số lượng sản phẩm dịch vụ",
    EDIT_PRODUCT_INFO: "Chỉnh sửa thông tin sản phẩm dịch vụ",
    EDIT_PRACTITIONERS_PRODUCT_SETTING:
      "Chỉnh sửa phân công sản phẩm dịch vụ cho chuyên viên",
    SERVICE_PROJECT: "Hạng mục dịch vụ",
    SELECT_WORKING_SERVICES: "Chọn loại dịch vụ cho hạng mục dịch vụ này",
    SELECT_SERVICE_PROJECT: "Chọn hạng mục dịch vụ cho sản phẩm dịch vụ này",
    SERVICE_EXPLANATION:
      "Hạng mục dịch vụ được dùng để định nghĩa một loại dịch vụ, chẳng hạn như xoa bóp đầu, xoa bóp lưng, v.v. Các sản phẩm dịch vụ sau đó sẽ dựa trên hạng mục dịch vụ này để đặt giá và thời lượng.",
    NO_PRACTITIONERS_FOR_THIS_SERVICE:
      "Không có chuyên viên nào khả dụng cho loại dịch vụ này. Vui lòng đến cấu hình loại dịch vụ, hoặc liên hệ các chuyên viên liên quan để hoàn tất cấu hình.",
    PATIENT_SYSTEM_AND_PRESCRIPTION_FUNCTION_FOR_TCM:
      "Bạn có thể quản lý thông tin bệnh nhân và hồ sơ bệnh án của phòng khám, đồng thời tạo đơn thuốc cho bệnh nhân ở chế độ YHCT",
    PRESCRIPTION_MEDICAL_HISTORY_FOR_TCM:
      "Hướng dẫn đơn thuốc và bệnh sử - Chế độ YHCT",
    PRESCRIPTION_MEDICAL_HISTORY_FOR_MASSAGE:
      "Hướng dẫn đơn thuốc và bệnh sử - Chế độ Xoa bóp",
    PATIENT_SYSTEM_AND_PRESCRIPTION_FUNCTION_FOR_MASSAGE:
      "Bạn có thể quản lý thông tin bệnh nhân và hồ sơ bệnh án của phòng khám, đồng thời tạo đơn thuốc cho bệnh nhân ở chế độ Xoa bóp",
    NAME_IS_REQUIRED: "Vui lòng nhập tên",
    INVALID_PRICE: "Vui lòng nhập giá hợp lệ",
    INVALID_DURATION: "Vui lòng nhập thời lượng hợp lệ",
    NO_PRODUCTS_AVAILABLE_FOR_THIS_PRACTITIONER:
      "Không có sản phẩm dịch vụ khả dụng cho chuyên viên này",
    ADD_CUSTOMISED_SERVICE: "Thêm dịch vụ tùy chỉnh",
    CUSTOM_SERVICE_CREATEDED: "Đã tạo dịch vụ tùy chỉnh",
    U_CAN_ADD_UR_CUSTOMISED_SERVICE_TO_WORK_WITH: "Bạn có thể tạo danh mục dịch vụ tùy chỉnh để sử dụng khi tạo bệnh án.",
    INPUT_UR_SERVICE_TYPE_NAME_HERE: "Nhập tên danh mục dịch vụ",
    PLEASE_NOTE_ONLY_YOU_WILL_BE_ABLE_USE_THIS_CUSTOMISED_SERVICE: "Xin lưu ý rằng danh mục dịch vụ tùy chỉnh này chỉ khả dụng cho riêng bạn.",
    PLEASE_NOTE_ONLY_THIS_CLINIC_WILL_BE_ABLE_USE_THIS_CUSTOMISED_SERVICE: "Xin lưu ý: dịch vụ tùy chỉnh này chỉ có thể được sử dụng tại các phòng khám mà bạn là Chủ doanh nghiệp (Business Owner).",
    TREATMENT_INSTRUCTIONS: "Hướng dẫn điều trị",
    DEFAULT_DOB_WARNING: "Không có thông tin ngày sinh, hệ thống đã sử dụng ngày mặc định (01/01/1990).",
    RESIGN_CONSENT_FORM: "Ký lại mẫu chấp thuận",
    CONSENT_FORM_DOES_NOT_COVER_DATE_X: "Ngày khám đã chọn sớm hơn ngày bắt đầu hiệu lực của mẫu chấp thuận ({{X}}). Vui lòng để bệnh nhân ký lại mẫu chấp thuận trước khi thay đổi.",
    SAVE_APPOINTMENT_INFO_LOCALLY: "Lưu thông tin cuộc hẹn vào thiết bị",
    TRANSLATING: "Đang dịch",
    PROCESSING: "Đang xử lý",
    OTHER_LANG_CONTENT_GOES_HERE: "Nhập nội dung bằng ngôn ngữ khác tại đây",
    PLEASE_SELECT_DOWNLOAD_FORMAT: "Vui lòng chọn định dạng tải xuống",
    PDF_FILE: "Tệp PDF",
    WORD_DOC: "Tài liệu Word",
    NEXT_MONTH: "Tháng tiếp theo",
    PREV_MONTH: "Tháng trước",
    ALL_TIME: "Tất cả thời gian",
    TCM_MODE_SERVICE_DESC: "Khi chọn các loại dịch vụ sau, hệ thống sẽ sử dụng Chế độ chẩn đoán chi tiết khi tạo hồ sơ bệnh án. Chế độ này cung cấp nhiều tùy chọn hồ sơ đầy đủ hơn và hỗ trợ nhập thông tin khám chữa bệnh chi tiết hơn.",
    ACUPUNCTURE_MASSAGE_MEDICINE_MODE_SERVICE_DESC: "Khi chọn các loại dịch vụ sau, hệ thống sẽ sử dụng Chế độ nhanh châm cứu / xoa bóp bấm huyệt khi tạo hồ sơ bệnh án. Chế độ này được thiết kế cho các dịch vụ xoa bóp và trị liệu thủ công, với quy trình kê đơn được đơn giản hóa hơn so với Chế độ chẩn đoán chi tiết, giúp nhập thông tin điều trị nhanh chóng và dễ dàng hơn.",
    MASSAGE_QUICK_MODE: "Chế độ nhanh châm cứu / xoa bóp bấm huyệ",
    TRY_NEW_UI: "Dùng thử mẫu hồ sơ bệnh án mới",
    TRY_NEW_UI_INTRO: "Mẫu hồ sơ mới này hiện chỉ là cải tiến giao diện cho hồ sơ loại Châm cứu / Xoa bóp bấm huyệt. Mẫu sẽ tự động nhắc bạn những mục bắt buộc nào chưa điền. Nội dung điền vào hoàn toàn giống như trước, chỉ khác về hình thức. Đây là tính năng thử nghiệm, nếu gặp vấn đề vui lòng phản hồi cho chúng tôi, và bạn có thể tắt thử nghiệm bất cứ lúc nào nếu không thích.",
    TRY_NEW_UI_STEP_BY_STEP: "Kê đơn theo từng bước có hướng dẫn",
    GUIDED_UI_TOGGLE_OLD: "Giao diện cũ",
    GUIDED_UI_TOGGLE_NEW: "Giao diện mới",
    I_AGREE_AND_SIGN: "Tôi đồng ý và ký",
    PATIENT_SIGN_IN_PERSON: "Bệnh nhân ký trực tiếp",
    AND_X_MORE: "và {{X}} hơn",
    CLICK_TO_ADD_CONTENT: "Nhấp để thêm nội dung",
    NO_CONTENT_FILLED: "Chưa điền nội dung",
    CONTENT_FILLED: "Đã điền nội dung",
    TREATMENT_OUTCOME: "Kết quả điều trị",
    TREATMENT_RECOMMENDATION: "Khuyến nghị điều trị",
    SHOW_ALL_SERVICES: "Hiển thị tất cả dịch vụ",
    SHOW_SERVICE_HAS_PRODUCT: "Hiển thị dịch vụ có sản phẩm",
    UP_TO_X_USERS_INCLUDED: "Bao gồm tối đa {{X}} người dùng",
    PHONE_CONSULTATION: "Tư vấn qua điện thoại",
    PLEASE_CONTACT_US_FOR_THIS_PACKAGE: "Vui lòng liên hệ với chúng tôi để thiết kế gói dịch vụ riêng cho phòng khám của bạn",
    LEFT_CALF: "Bắp chân trái",
    SHOWING: "Đang hiển thị",
    SWIPE_OR_USE_ARROWS_TO_VIEW_MORE_PACKAGES: "Vuốt ngang hoặc dùng mũi tên để xem thêm gói",
    DOWNLOAD_SICK_CERTIFICATE: "Tải giấy nghỉ ốm",
    ISSUE_SICK_CERTIFICATE: "Cấp giấy nghỉ ốm",
    DAY: "Ngày",
    DAY_VIEW: "Chế độ xem ngày",
    PREV_DAY: "Ngày trước",
    NEXT_DAY: "Ngày tiếp theo",
    SCROLL_TO_NEXT_BOOKING: "Cuộn đến lịch hẹn tiếp theo",
    X_BOOKINGS: "Tổng số lịch hẹn {{X}}",
    CREATE_APPOINTMENT_FOR_THIS_DAY: "Tạo lịch hẹn cho ngày này",
    PLEASE_SELECT_SERVICE_TYPE_FROM_LEFT_FIRST: "Vui lòng chọn loại dịch vụ ở bên trái trước.",
    UNSELECT_THIS_BODY_PART: "Bỏ chọn vùng cơ thể này",
    UNSAVED_CHANGES: "Thay đổi chưa được lưu",
    UNSAVED_BODY_PART_METHOD_CHANGES_DESC: "Bạn đã thay đổi vùng cơ thể đã chọn hoặc kỹ thuật massage. Nếu đóng ngay bây giờ, các thay đổi này sẽ không được lưu.",
    CONTINUE_EDITING: "Tiếp tục chỉnh sửa",
    DISCARD_AND_CLOSE: "Bỏ thay đổi và đóng",

    EDIT_CUSTOMISED_SERVICE: "Chỉnh sửa dịch vụ tùy chỉnh",
    PRIMARY_LANGUAGE: "Ngôn ngữ chính",
    OTHER_LANGUAGES: "Ngôn ngữ khác",
    REQUIRED: "Bắt buộc",
    OPTIONAL: "Không bắt buộc",
    TRANSLATE: "Dịch",
    TRANSLATE_TO_OTHER_LANGUAGES: "Dịch sang các ngôn ngữ khác",
    PLEASE_ENTER_ENGLISH_NAME_FIRST: "Vui lòng nhập tên tiếng Anh trước.",
    ENGLISH_NAME_IS_REQUIRED_AND_USED_AS_DEFAULT: "Tên tiếng Anh là bắt buộc và sẽ được dùng làm tên hiển thị mặc định.",
    OTHER_LANGUAGE_FIELDS_ARE_OPTIONAL: "Các ngôn ngữ khác là tùy chọn. Bạn có thể chỉnh sửa thủ công hoặc dịch tự động.",
    NAME_MODALITY_IN_ENGLISH: "Tên dịch vụ (Tiếng Anh)",
    NAME_MODALITY_IN_CHINESE: "Tên dịch vụ (Tiếng Trung)",
    NAME_MODALITY_IN_THAI: "Tên dịch vụ (Tiếng Thái)",
    NAME_MODALITY_IN_VIETNAMESE: "Tên dịch vụ (Tiếng Việt)",
    MODALITY_UPDATED: "Đã cập nhật dịch vụ thành công",
    CLICK_TO_EDIT: "Nhấp để chỉnh sửa",
    PRODUCT_DURATION_CANNOT_EXCEED_5_HOURS: "Thời lượng sản phẩm không được vượt quá 5 giờ.",
    UNSAVED_CHANGES_WARNING: "Mọi thay đổi chưa được lưu sẽ bị mất. Bạn có chắc chắn muốn tiếp tục không?",

    // ---- Tích hợp Xero ----
    XERO_SETTINGS: "Cài đặt Xero",
    XERO_SETTINGS_HINT: "Kết nối tài khoản Xero của phòng khám để đẩy các lượt khám đã thanh toán thành hóa đơn cho kế toán kiểm tra.",
    XERO_CONNECT: "Kết nối với Xero",
    XERO_RETRY_CONNECT: "Thử lại",
    XERO_NOT_CONNECTED_TITLE: "Chưa kết nối với Xero",
    XERO_NOT_CONNECTED_DESCRIPTION: "Kết nối Xero Organisation của phòng khám này để bắt đầu đẩy các lượt khám đã thanh toán thành hóa đơn.",
    XERO_CONNECT_SUCCESS: "Đã kết nối với Xero",
    XERO_CONNECT_SUCCESS_WITH_ORG: 'Đã kết nối với Xero Organisation "{{org}}"',
    XERO_CONNECT_FAILED_ACCESS_DENIED: "Bạn đã hủy cấp quyền trên trang Xero.",
    XERO_CONNECT_FAILED_EXCHANGE: "Cấp quyền thất bại. Vui lòng kết nối lại.",
    XERO_ORGANISATION: "Xero Organisation",
    XERO_CONNECTED_SINCE: "Đã kết nối từ",
    XERO_DISCONNECT: "Ngắt kết nối",
    XERO_DISCONNECT_SUCCESS: "Đã ngắt kết nối khỏi Xero",
    XERO_DISCONNECT_CONFIRM_1: "Sau khi ngắt kết nối, bạn sẽ không thể đẩy lượt khám lên Xero nữa.",
    XERO_DISCONNECT_CONFIRM_2: "Các hóa đơn đã có trên Xero sẽ không bị ảnh hưởng.",
    XERO_DISCONNECT_CONFIRM_3: "Bạn có thể kết nối lại bất cứ lúc nào.",
    XERO_ACCOUNT_MAPPING: "Ánh xạ tài khoản doanh thu",
    XERO_ACCOUNT_MAPPING_HINT: "Chọn tài khoản Xero để ghi nhận phí điều trị và các phí khác.",
    XERO_ACCOUNT_CODES_INCOMPLETE_WARNING: "Ánh xạ tài khoản chưa hoàn tất — không thể đẩy hóa đơn lên Xero cho đến khi cả hai tài khoản được chọn.",
    XERO_TREATMENT_ACCOUNT_CODE: "Tài khoản doanh thu điều trị",
    XERO_OTHER_FEE_ACCOUNT_CODE: "Tài khoản phí khác",
    XERO_NO_ACCOUNTS_AVAILABLE: "Không có tài khoản doanh thu nào khả dụng trong Xero Organisation này. Vui lòng thiết lập trong Xero trước.",
    XERO_ACCOUNT_CODES_REQUIRED: "Vui lòng chọn cả hai tài khoản trước khi lưu.",
    XERO_ACCOUNT_CODES_SAVED: "Đã lưu ánh xạ tài khoản",
    XERO_AUTOMATION_SETTINGS: "Cài đặt tự động hóa",
    XERO_AUTOMATION_SETTINGS_HINT: "Tùy chọn. Mặc định hóa đơn sẽ vào Xero ở dạng nháp để kế toán phòng khám duyệt thủ công.",
    XERO_AUTO_SYNC_TOGGLE: "Tự động duyệt và ghi nhận thanh toán",
    XERO_AUTO_SYNC_TOGGLE_HINT: "Khi bật, các lượt khám đã thanh toán được đẩy lên Xero sẽ tự động được duyệt và đối soát — không cần thao tác thủ công trên Xero.",
    XERO_AUTO_SYNC_OFF_LABEL: "Tắt",
    XERO_AUTO_SYNC_OFF_DESCRIPTION: "Hóa đơn sẽ ở dạng nháp trên Xero để kế toán duyệt thủ công.",
    XERO_AUTO_SYNC_ON_LABEL: "Bật",
    XERO_AUTO_SYNC_ON_DESCRIPTION: "Hóa đơn sẽ được tự động duyệt và đánh dấu đã thanh toán trên Xero — không qua bước nháp.",
    XERO_PAYMENT_ACCOUNT_CODE: "Tài khoản ngân hàng nhận thanh toán",
    XERO_NO_BANK_ACCOUNTS_HINT: 'Xero Organisation này chưa có tài khoản ngân hàng nào. Vui lòng thêm trong Xero ("Add Bank Account") trước khi bật tự động ghi nhận thanh toán.',
    XERO_BANK_ACCOUNT_NOT_PAYABLE: "không nhận thanh toán",
    XERO_AUTO_SYNC_PAYMENT_ACCOUNT_REQUIRED: "Vui lòng chọn một tài khoản ngân hàng trước khi bật tự động ghi nhận thanh toán.",
    XERO_AUTO_SYNC_SAVED: "Đã lưu cài đặt tự động hóa",
    XERO_INVOICE_SEARCH: "Hóa đơn Xero",
    XERO_PUSH_INVOICE: "Đẩy lên Xero",
    XERO_PUSH_NOW: "Đẩy ngay",
    XERO_NEVER_PUSHED_HINT: "Lượt khám này chưa từng được đẩy lên Xero. Đẩy ngay để tạo hóa đơn.",
    XERO_PUSH_SUCCESS: "Đã đẩy lên Xero",
    XERO_PUSH_ALREADY_SYNCED: "Lượt khám này đã được đẩy lên Xero trước đó — hiển thị hóa đơn hiện có.",
    XERO_PUSH_DISABLED_NOT_PAID: "Chỉ các lượt khám đã thanh toán mới có thể đẩy lên Xero.",
    XERO_PUSH_DISABLED_NOT_CONNECTED: "Phòng khám này chưa kết nối với Xero.",
    XERO_INVOICE_NUMBER: "Số hóa đơn",
    XERO_INVOICE_STATUS: "Trạng thái hóa đơn Xero",
    XERO_INVOICE_STATUS_DRAFT: "Nháp",
    XERO_INVOICE_STATUS_SUBMITTED: "Đã gửi",
    XERO_INVOICE_STATUS_DELETED: "Đã xóa",
    XERO_INVOICE_STATUS_AUTHORISED: "Đã duyệt",
    XERO_INVOICE_STATUS_PAID: "Đã thanh toán",
    XERO_INVOICE_STATUS_VOIDED: "Đã hủy",
    XERO_SYNCED_AT: "Thời gian đẩy",
    XERO_SYNC_STATUS_SYNCED: "Đã đẩy thành công",
    XERO_SYNC_STATUS_PENDING: "Đang xử lý",
    XERO_SYNC_STATUS_FAILED: "Thất bại",
    XERO_SYNC_STATUS_NEVER_PUSHED: "Chưa từng đẩy",
    XERO_ERROR_CLINIC_NOT_SELECTED: "Vui lòng chọn phòng khám trước.",
    XERO_ERROR_INVALID_TOKEN: "Phiên đăng nhập của bạn đã hết hạn. Vui lòng đăng nhập lại.",
    XERO_UNKNOWN_ERROR: "Đã xảy ra lỗi. Vui lòng thử lại.",
    XERO_SELECT_ORGANISATION: "Chọn Xero Organisation",
    XERO_SELECT_ORGANISATION_HINT: "Kết nối Xero này bao gồm nhiều hơn một Organisation. Hãy chọn Organisation mà phòng khám này sẽ đẩy hóa đơn đến.",
    XERO_SWITCH_ORGANISATION: "Chuyển Organisation",
    XERO_CURRENT_ORGANISATION: "Hiện tại",
    XERO_SWITCH_ORGANISATION_TO: "Đang chuyển sang",
    XERO_ORG_SWITCH_SUCCESS: 'Đã chuyển sang Xero Organisation "{{org}}"',
    XERO_SWITCH_ORGANISATION_CONFIRM_INTRO: 'Chuyển sang "{{org}}"? Các mục sau sẽ bị xóa vì chúng gắn với Organisation hiện tại:',
    XERO_SWITCH_ORGANISATION_WIPE_ACCOUNTS: "Ánh xạ tài khoản doanh thu điều trị và phí khác",
    XERO_SWITCH_ORGANISATION_WIPE_AUTOMATION: "Tài khoản ngân hàng và cài đặt tự động hóa (sẽ bị tắt)",
    XERO_SWITCH_ORGANISATION_CONFIRM_OUTRO: "Bạn sẽ cần thiết lập lại ánh xạ tài khoản cho Organisation mới trước khi có thể đẩy hóa đơn.",
  },
};
